export default {
  translation: {
    Automation_flow_templates: "Шаблоны сценариев",
    Automation_ai_templates: "Шаблоны ИИ",
    Automation_sample: "Пример",
    Automation_sample_notice: "Вы можете использовать готовые шаблоны и изменять их",
    Automation_template_number: "Шаблон № {{number}}",
    Automation_beginner: "Начальный",
    Automation_intermediate: "Средний",
    Automation_advanced: "Продвинутый",
    Automation_trending: "Популярное",
    Automation_sample_cart: "Восстановление корзины",
    Automation_sample_cart_description:
      "Пример идеи: помогите покупателям вернуться к корзине и ответьте на их вопросы.",
    Automation_sample_language: "Многоязычные беседы",
    Automation_sample_language_description: "Пример идеи: предложите посетителю общение на удобном ему языке.",
    Automation_sample_support: "Помощник службы поддержки",
    Automation_sample_support_description: "Пример идеи: отвечайте на частые вопросы и подсказывайте следующий шаг.",
    Automation_sample_welcome: "Приветствие новых клиентов",
    Automation_sample_welcome_description: "Пример идеи: приветствуйте посетителей и представьте свои товары и услуги.",
    Automation_flow_history: "История сценариев",
    Automation_ai_history: "История ИИ",
    Automation_loaded_count: "Загруженные элементы; + означает, что доступны другие.",
    Automation_sort_newest: " сначала новые",
    Automation_sort_oldest: " сначала старые",
    Automation_sort_title: " по названию",
    Automation_connected_posts: "Связанные публикации",
    Automation_not_connected: "Не связан ни с одной публикацией.",
    Automation_connections_access: "Нужны разрешение на комментарии и доступ к автоматизации и комментариям.",
    Automation_checking_connections: "Проверка связей с публикациями...",
    Automation_connections_retry: "Не удалось проверить все связи. Повторить.",
    aiSuggestedPrompts_title: "Рекомендуемые промпты",
    aiSuggestedPrompts_openImage: "Открыть изображение на весь экран",
    aiSuggestedPrompts_explain: "Выберите промпт для начала работы.",
    aiSuggestedPrompts_category: "Категория промпта",
    aiSuggestedPrompts_subCategory: "Подкатегория",
    aiSuggestedPrompts_allCategories: "Все категории",
    aiSuggestedPrompts_loading: "Загрузка...",
    aiSuggestedPrompts_empty: "Рекомендуемые промпты не найдены.",
    aiSuggestedPrompts_loadMore: "Загрузить еще",
    aiSuggestedPrompts_prompt: "Промпт",
    aiSuggestedPrompts_copy: "Копировать промпт",
    aiSuggestedPrompts_showMore: "Показать больше",
    aiSuggestedPrompts_showLess: "Показать меньше",
    unpin: "Открепить",
    pin: "Закрепить",
    usethisPrompt: "Использовать в Prompt",
    AudienceTooltip:
      "Для более точной оценки текущей вовлечённости статистика рассчитывается на основе показателей за последние 30 дней; статистика Instagram учитывает весь период активности аккаунта и может отличаться от этих данных",
    toggleShowAll: "Показать все",
    toggleShowmonthly: "Показать по месяцам",
    Nodetutorial: "Описание блока",
    Dublicate: "Дублировать",
    zoomout: "Уменьшить масштаб",
    fitscreen: "По размеру экрана",
    zoomin: "Увеличить масштаб",
    shortcuts: "Горячие клавиши",
    Workflow_Statistics: "Статистика рабочего процесса",
    Nodes: "Узлы",
    Connections: "Соединения",
    History_saved: "Сохранённая история",
    Data_Management_explain:
      "Вы можете сохранить свой рабочий процесс и при необходимости импортировать его с других платформ.",
    flow_shortcuts_explain: "Горячие клавиши для повышения скорости и удобства управления рабочими процессами.",
    Last_Auto_saved: "Последнее автосохранение",
    Canvas_Behavior: "Поведение холста",
    Canvas_Behavior_explain: "Настройте привязку к сетке и границы панорамирования для лучшего контроля",
    Data_Management: "Управление данными",
    importJSON_success: "Файл успешно импортирован",
    importJSON_error: "Ошибка при импорте файла",
    exportJSON: "Экспорт JSON",
    importJSON: "Импорт JSON",

    quantity: "Количество",
    allquantity: "Общее количество",
    remainingquantity: "Оставшееся количество",
    Connecting: "Подключение",
    Connected: "Подключено",
    EmailNotification: "Уведомления по Email",
    EmailNotificationExplain: "Системные уведомления отправляются на этот Email-адрес.",
    MobileNotification: "Уведомления на мобильный",
    MobileNotificationExplain: "Системные уведомления отправляются на этот мобильный номер.",
    Responded: "Отвечено",
    notimelimit: "Без ограничения по времени",
    usersettingexplain:
      "Информацию аккаунта Instagram можно изменить только в самом Instagram, и здесь она обновится автоматически.",

    loading: "Загрузка...",
    Beginner: "Начинающий",
    Basic: "Базовый",
    Growing: "Растущий",
    Advanced: "Продвинутый",
    Professional: "Профессиональный",
    Special: "Специальный",
    Unavailable: "Недоступен",
    menu: "Меню",
    level: "Уровень",
    bestposts: "Лучшие посты",
    unselect: "Отменить выбор",
    daysAgo: "Несколько дней назад",
    hoursAgo: "Несколько часов назад",
    minutesAgo: "Несколько минут назад",
    justNow: "Только что",
    upgradeyouraccount: "Обновите свой аккаунт",
    featureNotAvailable: "Эта функция недоступна",
    featureNotAvailableDesc: "Обновите аккаунт, чтобы воспользоваться этой функцией.",
    likeaprouser: "Начните настоящий бизнес",
    followerrate: "Темп роста подписчиков",
    shoppertitle: "Всё готово к продаже 👌",
    advertisertitle: "Всё готово к рекламе 👌",
    shopperdescription: "Точно отслеживайте свои показатели продаж.",
    advertiserdescription: "Точно отслеживайте эффективность рекламы.",
    syncingAccountTitle: "Получение информации",
    syncingAccountDescription: "Информация вашего Instagram обновляется в Brancy",
    syncingAccountDescriptiontooltip: "Некоторая информация будет обновлена в течение следующих 24 часов.",
    subscriptionExpiringTitle: "Срок действия подписки истекает",
    subscriptionExpiringDescription: "Продлите подписку, чтобы продолжить пользоваться доступными функциями.",
    subscriptionDaysRemaining: "Осталось дней: {{days}}",
    priceHistory: "История цен",
    // #region landing page
    shopper: "Продавец",
    onlinestore: "Интернет-магазин",
    onlinestoreExplain: "Всё, что нужно для увеличения продаж, в одном месте.",
    influencerExplain: "Все инструменты для рекламодателей и инфлюенсеров — профессионально объединены",
    advertiser: "Рекламодатель",
    influencer: "Инфлюенсер",
    skip: "Пропустить",
    skipfornow: "Пропустить сейчас",
    freedays: "40 дней",
    freedaysExplain:
      "Если у вас есть активная и развивающаяся страница в Instagram, этот план создан для вас. Полный доступ к инструментам, аналитике, управлению контентом, сообщениями, комментариями и созданию помощников-админов в Brancy активирован.",
    instagramerplanactive: "Ваш Instagram-план активен",
    influencerplanactive: "Ваш план для инфлюенсеров активен",
    onlinestoreplanactive: "Ваш план интернет-магазина активен",

    SwitchtoUserpanel: "Переключиться на панель пользователя",
    chooselanguage: "Выбор языка",
    chooselanguageExplain: "Выберите предпочитаемый язык",
    chooseTheme: "Выбор темы",
    chooseThemeExplain: "Выберите любимую тему",
    chooseCalendar: "Выбор календаря",
    chooseCalendarExplain: "Выберите предпочитаемый тип календаря",
    setupchooseexplain: "Эти настройки можно изменить позже в разделе настроек",

    Lottery: "Лотерея",
    services: "Функции",
    markets: "Платформы",
    pricing: "Ценообразование",
    page1_text1: "Управление бизнесом в Instagram",
    page1_text2: "С новым поколением",
    page1_StartNow: "Бесплатный старт с доступом к профессиональным инструментам",
    page1_services: "Услуги",
    page1_analytics: "Аналитика",
    page1_transportation: "Транспорт",
    page1_financial_solutions: "Финансовые решения",
    page1_customer_communication: "Коммуникация с клиентами",
    page1_content_management: "Управление контентом",
    page1_artificial_intelligence: "Искусственный интеллект",
    page1_tools: "Инструменты",
    page1_advertises: "Управление рекламой",
    page2_text1: "Самые комплексные бизнес-услуги и решения",
    page2_text2:
      "Brancy — это мощный инструмент для управления вашим аккаунтом в Instagram, предоставляющий вам необходимые инструменты для успеха.",
    page2_ads_statistics_title: "Статистика",
    page2_ads_statistics_description: "Продвинутый инструмент анализа эффективности",
    page2_ads_statistics_servicedescription:
      "Отслеживайте все ключевые метрики рекламы в реальном времени с высокой точностью. Получайте полный профессиональный обзор для оптимизации кампаний.",
    page2_ads_calendar_title: "Рабочий календарь",
    page2_ads_calendar_description: "Самое удобное управление рекламой",
    page2_ads_calendar_servicedescription:
      "Управляйте всеми объявлениями — одобренными вами и предложенными ИИ — в умном календаре с организованным таймлайном. Быстрое и безошибочное планирование.",
    page2_ads_adlist_title: "Список объявлений",
    page2_ads_adlist_description: "Просмотр очереди объявлений на одобрение",
    page2_ads_adlist_servicedescription:
      "Четкий и структурированный список объявлений на одобрение с возможностью одобрения или отклонения в один клик. Упростите управление рекламой.",
    page2_store_addproduct_title: "Добавить товар",
    page2_store_addproduct_description: "Определение всех товаров со страницы",
    page2_store_addproduct_servicedescription:
      "Наша умная система обнаруживает все товары в постах вашей страницы и автоматически готовит их для добавления. Ускоряет работу и снижает ошибки.",
    page2_store_productlist_title: "Список товаров",
    page2_store_productlist_description: "Управление запасами и товарами",
    page2_store_productlist_servicedescription:
      "Профессиональное, точное и удобное управление товарами и запасами. Всё умно и с полной отчётностью.",
    page2_store_orders_title: "Заказы",
    page2_store_orders_description: "Управление заказами, счетами и доставкой",
    page2_store_orders_servicedescription:
      "Все этапы управления заказами — от регистрации до выставления счета и отслеживаемой доставки — автоматизированы и безупречны. Быстрый и точный сервис для клиентов.",
    page2_store_statistics_title: "Статистика",
    page2_store_statistics_description: "Продвинутый инструмент анализа",
    page2_store_statistics_servicedescription:
      "Отслеживайте продажи, доходы и тенденции роста магазина с разных сторон и принимайте умные решения на основе данных.",
    page2_delivery_smartshipping_title: "Умная стоимость доставки",
    page2_delivery_smartshipping_description: "Стоимость по месту отправления, месту назначения, размеру и весу",
    page2_delivery_smartshipping_servicedescription:
      "Стоимость доставки рассчитывается точно и автоматически на основе места отправления, назначения, размеров и веса. Точные тарифы без ошибок.",
    page2_delivery_postalservice_title: "Почтовая служба",
    page2_delivery_postalservice_description: "Сбор и доставка посылок",
    page2_delivery_postalservice_servicedescription:
      "Ваши посылки умно собираются из магазина и отправляются без ручного контроля. Быстрая, организованная и удобная логистика.",
    page2_delivery_tracking_title: "Отслеживание посылки",
    page2_delivery_tracking_description: "Автоматическое отображение и отслеживание посылок",
    page2_delivery_tracking_servicedescription:
      "Автоматическое отслеживание с точным и мгновенным статусом для клиентов, обеспечивающее полную прозрачность и доверие.",
    page2_jobs_subadmin_title: "Субадмин",
    page2_jobs_subadmin_description: "Возможность добавления субадминов",
    page2_jobs_subadmin_servicedescription:
      "Добавляйте субадминов безопасно без передачи паролей и настраивайте доступ для каждого. Полный контроль и гарантированная безопасность.",
    page2_ids_store_title: "Магазин ID",
    page2_ids_store_description: "Покупка и продажа Instagram ID",
    page2_ids_store_servicedescription:
      "Безопасная покупка и продажа Instagram аккаунтов с аутентификацией. Подробный анализ, умное ценообразование, аукционы и проверка статистики страницы—all in one place.",
    page2_publish_contentmanagement_title: "Управление Контентом",
    page2_publish_contentmanagement_description: "Управление Постами и Стори",
    page2_publish_contentmanagement_servicedescription:
      "Управляйте всеми постами и сториз на продвинутой умной платформе с возможностью планирования, категоризации и быстрой публикации для удобного контроля соцсетей.",
    page2_publish_contentpublishing_title: "Публикация Контента",
    page2_publish_contentpublishing_description: "Плановая публикация постов и сториз",
    page2_publish_contentpublishing_servicedescription:
      "Публикуйте посты и сториз по расписанию с умным подбором времени. Система предлагает лучшее время, основываясь на анализе поведения фолловеров.",
    page2_publish_analytics_title: "Аналитика Постов и Стори",
    page2_publish_analytics_description: "Полный анализ контента",
    page2_publish_analytics_servicedescription:
      "Получайте глубокие инсайты по эффективности контента и откликам аудитории, оптимизируя свою стратегию.",
    page2_publish_statistics_title: "Статистика",
    page2_publish_statistics_description: "Продвинутый инструмент анализа эффективности",
    page2_publish_statistics_servicedescription:
      "Самый продвинутый инструмент анализа контента с полной детализацией по постам и сториз, графиками и точным анализом для лучших решений.",
    page2_extension_biolink_title: "Bio Link",
    page2_extension_biolink_description: "Больше чем простой био-ссылка",
    page2_extension_biolink_servicedescription:
      "Специальная красивая страница с отображением всех ваших важных ссылок, адаптивным дизайном и полной настройкой, больше чем простая ссылка.",
    page2_extension_paymentgateway_title: "Платежный шлюз",
    page2_extension_paymentgateway_description: "Специальный платежный шлюз",
    page2_extension_paymentgateway_servicedescription:
      "Безопасный и специализированный платежный шлюз без необходимости технических знаний, с подробными отчетами и управлением транзакциями в удобной среде.",
    page2_extension_customwebsite_title: "Индивидуальный сайт",
    page2_extension_customwebsite_description: "Сайт, адаптированный под вашу страницу",
    page2_extension_customwebsite_servicedescription:
      "Индивидуальный сайт, соответствующий визуальной идентичности вашей страницы, без кодирования. Профессионально демонстрируйте все ваши товары и услуги.",
    page4_menu_instagram_management: "Управление страницей Instagram",
    page4_menu_admin_subadmin: "Админ и Субадмин",
    page4_menu_store_shipping: "Магазин и Доставка",
    page4_menu_advertising: "Реклама",
    page4_menu_hashtag_management: "Управление Хештегами",
    page4_menu_ai_analysis: "Умный AI Анализ",
    page4_menu_ad_scheduling: "Планирование Рекламы",
    page4_menu_financial_wallet: "Финансы и Кошелек",
    page4_menu_page_statistics: "Статистика страницы",
    page4_menu_professional_messaging: "Профессиональный Мессенджер",

    page4_content_instagram_management_text:
      "Управляйте всеми частями страницы — от публикации контента до ответов на комментарии и директ — интегрированно и профессионально, без множества приложений!",
    page4_content_admin_subadmin_text:
      "Создайте команду! Назначайте роли, ограничивайте доступ и полностью контролируйте действия без ошибок человека.",
    page4_content_store_shipping_text:
      "Настоящий Instagram-магазин! Управляйте запасами, заказами, счетами и доставкой из одной панели. Онлайн-продажи проще чем когда-либо!",
    page4_content_advertising_text:
      "Создавайте, запускайте и анализируйте рекламу в Instagram несколькими кликами! Привлекайте целевую аудиторию, измеряйте рентабельность и не тратьте бюджет зря.",
    page4_content_hashtag_management_text:
      "Выбирайте хештеги умно! Анализируйте лучшие связанные хештеги, сохраняйте и классифицируйте их, получайте умные рекомендации для каждого поста для максимального охвата.",
    page4_content_ai_analysis_text:
      "Тщательно изучайте поведение фолловеров! Открывайте шаблоны, интересы и лучшие часы активности с помощью продвинутого AI и выигрывайте стратегией.",
    page4_content_ad_scheduling_text:
      "Пусть ваша реклама работает даже во сне! Планируйте кампании, устанавливайте время начала и окончания и развивайтесь без забот.",
    page4_content_financial_wallet_text:
      "Держите все транзакции под контролем! Отслеживайте доходы, расходы, баланс кошелька и получайте полные финансовые отчеты для лучшего управления капиталом.",
    page4_content_page_statistics_text:
      "Точные реальные данные о росте страницы: уровень вовлеченности, рост фолловеров, эффективность постов, просмотры и много данных для умных решений.",
    page4_content_professional_messaging_text:
      "Испытайте настоящий direct маркетинг! Отправляйте групповые сообщения, настраивайте автоответы и профессионально управляйте диалогами с фолловерами без путаницы.",

    shipping: "Доставка",
    jobs: "Вакансии",
    IDstore: "Магазин ID",
    page3_text1: "Решение всех ваших бизнес-потребностей",
    page5_whyBrancy: "Почему Brancy?",
    page5_title1: "Официальный и безопасный партнер Instagram",
    page5_title2: "Интегрированная экосистема, умная экономия",
    page5_title3: "Профессиональное интеллектуальное взаимодействие",
    page5_title4: "Современная и интеллектуальная панель управления",
    page5_title5: "Интеллектуальная система продаж и логистики",
    page5_title6: "Персонализированный интеллектуальный веб-сайт",
    page5_explain1: "Умное управление без доступа к данным – безопасно и совместимо с Instagram.",
    page5_explain2: "Все инструменты в одном – минус 70% затрат, минус 85% времени.",
    page5_explain3: "Автоответы ИИ – +40% откликов, 95% удержание клиентов.",
    page5_explain4: "Быстрый интерфейс, лайв-аналитика, админы, тайминг и отчёты.",
    page5_explain5: "Продажи в Direct – защита, магазин, доставка и умный склад.",
    page5_explain6: "Сайт и Bio-ссылка – продажи, бронь, SEO и соцсети.",
    page9_plantitle: "Выберите количество фолловеров, чтобы увидеть подходящий пакет",

    page9_planheader: "Профессионально начните и наслаждайтесь возможностями!",
    page9_planexplain: "40 дней бесплатного, полного и неограниченного доступа!",
    page9_freeplan: "Бесплатно",
    page9_basicplan: "Базовый",
    page9_proplan: "Профессиональный",
    page9_adsplan: "Реклама",
    page9_storeplan: "Магазин",
    page9_monthly: "ежемесячно",
    page9_Compare: "Сравнить планы по деталям",
    page9_content_management: "Управление Post и Story",
    page9_analize_management: "Продвинутый анализ и статистические инструменты",
    page9_message_management: "Управление Direct и Comment",
    page9_biolink_management: "Умная биоссылка и персональный сайт",
    page9_subadmin_management: "Найм и управление под-админами",
    page9_basicoption: "Базовые функции",
    page9_ticket_management: "Продажи через Direct и тикеты",
    page9_finance_management: "Платёжный шлюз и кошелёк",
    page9_store_management: "Умное управление складом",
    page9_logestic_management: "Автоматическая доставка и отгрузка",
    page9_storeanalize_management: "Продвинутая аналитика",
    page9_calendar_management: "Календарь планирования рекламы",
    page9_advertise_management: "Умное управление рекламой",
    page9_adsanalize_management: "Продвинутая аналитика рекламы",
    page9_campagin_management: "Создание и участие в кампаниях",
    page9_adsticket_management: "Автоматическая отправка отзывов по рекламе клиентам",

    page6_Header: "Тысячи активных бизнесов",
    page6_Explain: "Большинство успешных компаний присоединились к большой семье Brancy",
    page10_header: "Что говорят наши клиенты",
    page8_HelpCenter: "Центр поддержки",
    page8_Community: "Сообщество",
    page8_learn: "Изучение",
    page8_Blog: "Блог",
    page8_FAQ: "Частые вопросы",
    Addfaq: "Добавить FAQ",
    addfaqexplain: "Вы можете добавить до 4 часто задаваемых вопросов",
    faqEmptyState: "Ваши часто задаваемые вопросы будут отображаться здесь",

    page8_Support: "Поддержка",
    support_Online: "Онлайн-поддержка",
    support_EnterBlog: "Перейти в блог",
    page8_CommunityExplain:
      "Свяжитесь с другими пользователями, делитесь своим опытом и получайте коллективные советы для дальнейшего роста.",
    page8_learnExplain:
      "В этом разделе вы узнаете последние стратегии использования Instagram в бизнесе. Всё, что вам нужно для роста вашего бизнеса, вы найдёте здесь.",
    page8_BlogExplain:
      "Получите доступ к последним статьям и образовательным материалам. Актуальная информация по различным направлениям бизнеса и цифрового маркетинга ждёт вас.",
    page8_FAQExplain:
      "Здесь отвечены ваши часто задаваемые вопросы. Для получения помощи по услугам или продуктам обратитесь в этот раздел.",
    page8_SupportExplain:
      "Наша команда поддержки готова помочь вам. Если у вас возникнут проблемы или вопросы, просто свяжитесь с нами.",
    page8_CommunityBTN: "Давайте учиться вместе",
    page8_learnBTN: "Быстрое обучение",
    page8_BlogBTN: "Последние новости",
    page8_FAQBTN: "Мгновенные ответы",
    page8_SupportBTN: "Мы здесь, чтобы помочь",
    footer_Brancy: "Brancy",
    footer_AboutUs: "О нас",
    footer_ContactUs: "Связаться с нами",
    footer_JoinUs: "Присоединиться к нам",
    footer_OrgChart: "Организационная структура",
    footer_FollowUs: "Подпишитесь на нас",
    footer_Solutions: "Решения",
    footer_HelpCenter: "Центр помощи",
    footer_Support: "Поддержка",
    footer_FAQ: "Часто задаваемые вопросы",
    footer_ReportAnIssue: "Сообщить о проблеме",
    footer_TrustLegal: "Юр. информация",
    footer_TermsAndConditions: "Условия",
    footer_PrivacyNotice: "Конфиденциальность",
    footer_CookieNotice: "Cookie",
    footer_Blog: "Блог",
    footer_ProductUpdates: "Последние обновления",
    footer_Articles: "Статьи",
    footer_LatestNews: "Последние новости",
    installPromptMessage: "Установите веб‑приложение Brancy",
    install: "Установить",
    installStep1: "Нажмите кнопку «Поделиться» на нижней панели.",
    installStep2: "Прокрутите открывшееся меню вверх и выберите Add to Home Screen.",
    installStep3: "Нажмите Add в верхней части экрана.",
    joinUs_subtitle: "Присоединяйтесь К Brancy; Здесь Формируются Инновации И Устойчивое Будущее.",
    joinUs_whyWorkWithUs: "Почему Brancy?",
    joinUs_whyWorkWithUsDescription:
      "Brancy — Это Не Просто Рабочее Место; Это Стратегическая Платформа Для Профессионального И Личного Роста. Мы Верим, Что Ведущие Организации Создаются Лучшим Талантом. Наша Задача — Создать Динамичную, Прозрачную И Поддерживающую Среду, В Которой Члены Команды Смогут Оставить Долгосрочный След.",
    joinUs_openPositions: "Открытые Вакансии",
    joinUs_openPositionsDescription:
      "Изучите Доступные Возможности И Выберите Роль, Соответствующую Вашей Экспертизе И Карьерному Пути.",
    joinUs_frontendDeveloper: "Frontend Разработчик",
    joinUs_frontendDeveloperDescription:
      "Разработка Современных Пользовательских Интерфейсов На React И TypeScript. Ключевая Роль В Повышении Качества И Эффективности Продуктов.",
    joinUs_backendDeveloper: "Backend Разработчик",
    joinUs_backendDeveloperDescription:
      "Проектирование И Разработка Масштабируемых И Безопасных Систем С Использованием Node.js И Облачных Технологий. Требуются Системное Мышление И Навыки Решения Сложных Задач.",
    joinUs_uiUxDesigner: "UI/UX Дизайнер",
    joinUs_uiUxDesignerDescription:
      "Создание Стандартных Интерфейсов И Интуитивного Пользовательского Опыта Для Удовлетворенности И Лояльности Пользователей. Важны Внимание К Деталям И Креативность.",
    joinUs_productManager: "Менеджер Продукта",
    joinUs_productManagerDescription:
      "Руководство Стратегией Продукта И Координация Работы Команд Для Предоставления Конкурентных И Эффективных Решений. Идеально Для Людей С Аналитическим Взглядом И Навыками Управления Стейкхолдерами.",
    joinUs_marketingSpecialist: "Специалист По Маркетингу",
    joinUs_marketingSpecialistDescription:
      "Планирование И Реализация Цифровых Кампаний, Усиление Позиции Бренда. Сочетание Аналитических Навыков И Креативности.",
    joinUs_customerSupport: "Специалист Поддержки Клиентов",
    joinUs_customerSupportDescription:
      "Оказывать Профессиональную Поддержку, Решать Проблемы И Улучшать Пользовательский Опыт. Требуется Точность, Терпение И Коммуникативные Навыки.",
    joinUs_engineering: "Инженерия",
    joinUs_design: "Дизайн",
    joinUs_product: "Продукт",
    joinUs_marketing: "Маркетинг",
    joinUs_support: "Поддержка",
    joinUs_remoteOnsite: "Удалённо / На месте",
    joinUs_onsite: "На месте",
    joinUs_remote: "Удалённо",
    joinUs_fullTime: "Полная занятость",
    joinUs_partTimeFullTime: "Частичная / Полная занятость",
    joinUs_applyNow: "Подать заявку",
    joinUs_applicationProcess: "Процесс найма в Brancy",
    joinUs_submitApplication: "Отправить заявку",
    joinUs_submitApplicationDescription: "Отправьте своё резюме и навыки. Наша команда тщательно рассмотрит их.",
    joinUs_initialScreening: "Первичный отбор",
    joinUs_initialScreeningDescription:
      "HR отдел проверяет резюме в течение 3–5 рабочих дней и связывается при соответствии.",
    joinUs_technicalInterview: "Техническое собеседование",
    joinUs_technicalInterviewDescription:
      "Оценка технических знаний и опыта через специализированные интервью с командами.",
    joinUs_finalInterview: "Финальное собеседование",
    joinUs_finalInterviewDescription:
      "Заключительная сессия с руководителями и ключевыми командами для обеспечения согласования целей и ценностей.",
    joinUs_welcomeAboard: "Добро пожаловать",
    joinUs_welcomeAboardDescription:
      "После принятия начинается комплексный процесс адаптации, чтобы познакомить вас с культурой и целями организации.",
    joinUs_readyToJoinUs: "Не нашли нужную позицию?",
    joinUs_readyToJoinUsDescription:
      "Мы всегда приветствуем квалифицированных и мотивированных специалистов. Отправьте резюме и опишите своё видение сотрудничества с Brancy.",
    joinUs_sendYourResume: "Отправить резюме",
    aboutUs_pageTitle: "О Brancy",
    aboutUs_metaDescription:
      "Познакомьтесь с Brancy — всеобъемлющей и международной платформой для управления социальными сетями и цифровыми бизнесами; местом, где инновации, доверие и устойчивый рост вместе формируют будущее цифровой экономики.",
    aboutUs_subtitle: "Умное управление цифровой экономикой с Brancy",
    aboutUs_ourStoryTitle: "Наша История",
    aboutUs_ourStoryPara1:
      "Brancy появился с целью переосмыслить управление онлайн-бизнесом; это точка, где передовые технологии встречаются с реальными потребностями владельцев бизнеса. Мы предлагаем не просто инструмент, а создали платформу, на которой компании могут работать как крупная профессиональная организация.",
    aboutUs_ourStoryPara2:
      "Этот путь основан на убеждении: технологии должны облегчать рост человека и бизнеса, а не становиться препятствием.",
    aboutUs_innovationTitle: "Инновации как Основное Преимущество",
    aboutUs_innovationPara1:
      "Brancy использует искусственный интеллект, большие данные и современные веб-технологии, чтобы создать для пользователей бесшовный, безопасный и эффективный опыт. Каждая функция разработана с упором на простоту и максимальную продуктивность.",
    aboutUs_innovationPara2:
      "Для нас инновации — это не только технологии; это стратегический подход, укоренившийся в нашей организационной культуре и взгляде в будущее.",
    aboutUs_coreValuesTitle: "Наши Основные Ценности",
    aboutUs_innovationFirstTitle: "Лидерство в Инновациях",
    aboutUs_innovationFirstDesc:
      "Мы всегда стремимся предлагать решения, которые удовлетворяют будущие потребности цифровых бизнесов.",
    aboutUs_trustSecurityTitle: "Доверие и Безопасность",
    aboutUs_trustSecurityDesc:
      "Безопасность данных и прозрачность процессов — наш приоритет, чтобы пользователи могли развиваться с полной уверенностью.",
    aboutUs_globalCommunityTitle: "Глобальное Сообщество",
    aboutUs_globalCommunityDesc:
      "Brancy выходит за пределы границ, объединяя глобальную экосистему компаний и специалистов.",
    aboutUs_sustainableGrowthTitle: "Устойчивый Рост",
    aboutUs_sustainableGrowthDesc:
      "Мы привержены умному и устойчивому развитию в соответствии с этическими принципами и социальной ответственностью.",
    aboutUs_userEmpowermentTitle: "Расширение Возможностей Пользователей",
    aboutUs_userEmpowermentDesc:
      "Наши интуитивные инструменты и образовательные ресурсы обеспечивают равный доступ к цифровым возможностям для всех.",
    aboutUs_continuousEvolutionTitle: "Постоянная Эволюция",
    aboutUs_continuousEvolutionDesc:
      "В динамичном мире изменения — часть нашего пути. Мы всегда движемся вперед через обучение и непрерывное совершенствование.",
    aboutUs_globalImpactTitle: "Глобальное Влияние",
    aboutUs_globalImpactPara:
      "Сегодня Brancy — это платформа, расширяющая возможности миллионов предпринимателей и компаний; мост между цифровыми возможностями и безграничным будущим.",
    aboutUs_activeUsers: "Активные Пользователи",
    aboutUs_countries: "Охваченные Страны",
    aboutUs_uptime: "Доступность Системы",
    aboutUs_support: "Выделенная Поддержка",
    aboutUs_teamTitle: "Команда Brancy",
    aboutUs_teamPara1:
      "Наша команда объединяет специалистов по технологиям, стратегов и креативщиков со всего мира, которых связывает общая цель — развитие цифровой экономики.",
    aboutUs_teamPara2:
      "От опыта пионеров отрасли до энергии молодых талантов — мы в Brancy ведем глобальное движение, формирующее новое поколение цифровой коммерции.",

    // #region  landing page
    Dashboard: "Панель управления",
    greeting1: "Солнце проснулось с тобой,",
    greeting2: "Доброе утро, полное энергии,",
    greeting3: "Хорошего дня,",
    greeting4: "Хорошего вечера,",
    greeting5: "Золотой вечер, хорошего времени,",
    greeting6: "Ночь близка",
    greeting7: "Спокойной ночи,",
    greetingtext1: "Раннее утро действительно волшебно🌅",
    greetingtext2: "Мир ждет твоих шагов 💪",
    greetingtext3: "Время для чая и улыбки ☕😊",
    greetingtext4: "Наслаждайся вкусной едой 🍽️",
    greetingtext5: "Солнце все еще на небе, иди вперед 🌟",
    greetingtext6: "Создавай крутой финал 🌇",
    greetingtext7: "Мечтай по-крупному и начни завтра🌙",
    userpanel_yourorders: "Ваши заказы",
    userpanel_SavedProducts: "Сохранённые продукты",
    userpanel_NoSavedProducts: "Нет доступных сохранённых продуктов.",
    userpanel_Startexplore: "Начните исследовать миллионы",
    userpanel_Startexploreexplain: "Рынки, Продукты и Страницы",
    userpanel_TicketSupportExplain: "Отслеживание заказа, общение с продавцом",
    userpanel_TicketSupport: "Связь через тикет",

    userpanel_UseInstagram: "Управляйте Instagram как профессионал.",
    userpanel_FreeProPanel: "Бесплатный ProPanel",
    userpanel_Premiumaccount: "Премиум-аккаунт",
    userpanel_daysFreePremium: "40 дней бесплатно Премиум",
    userpanel_LimitedOffer: "Ограниченное предложение!",
    // #region 0️⃣ General Section
    //0️⃣ General -> sidebar
    color: "Цвет",
    button: "Кнопка",
    Liter: "Литр",
    FrontFace: "Передняя сторона",
    SideFace: "Боковая сторона",
    TopFace: "Верхняя сторона",
    Area: "Площадь",
    Perimeter: "Периметр",
    Volume: "Объем",
    inSystem: "В системе",
    sending: "Отправка",
    uploadsRemaining: "Осталось загрузок",
    logoutExplain: "Вы пытаетесь выйти из Brancy",
    welcomeToBrancy: "Добро пожаловать в Brancy!",
    notloginexplain: "Чтобы воспользоваться услугами Brancy, пожалуйста, подключите свой аккаунт Instagram.",
    welcomeToBrancyExplain: "Введите свой ID Instagram, чтобы настроить свою панель управления.",
    welcomeToBrancyExplainPhone: "Введите свой номер телефона, чтобы настроить свою панель управления.",
    loginWithGoogle: "Google вход",
    loginWithMobile: "SMS вход",

    or: "или",
    InstagramID: "Имя пользователя Instagram (ID)",
    EmptyNotification: "Уведомлений пока нет",
    Notification_NewMessage: "У вас новое сообщение от {{sender}}",
    Notification_NewOrder: "У вас новый заказ от {{sender}}",
    Notification_ImagesCreatedBy: "Ваши изображения успешно созданы моделью {{version}}.",
    Notification_VideoCreatedBy: "Ваше видео успешно создано моделью {{version}}.",
    Notification_MediaCreationFailed: "Не удалось создать медиа моделью {{version}}: {{metadata}}",
    Notification_VideoCreationFailed: "Не удалось создать видео моделью {{version}}: {{metadata}}",
    Notification_NewPost: "Новый пост",
    Notification_UploadPostFailed: "Не удалось загрузить пост",
    Notification_NewStory: "Новая история",
    Notification_UploadStoryFailed: "Не удалось загрузить историю",
    Notification_NewVideo: "Новое видео",
    Notification_VideoCreationFailedTitle: "Не удалось создать видео",
    Notification_YouHaveNewMessage: "У вас новое сообщение",
    Notification_AccountDeauthorized: "Доступ к аккаунту Instagram отменён",
    EnterYourText: "Введите ваш текст",
    EnterYourphonenumber: "Введите ваш номер телефона",
    CopyText: "Копировать текст",
    successfulCopy: "Скопировано",
    download: "Скачать",
    automatic: "Автоматический",
    manual: "Ручной",
    phonenumber: "Номер телефона",
    SendVerificationCode: "Отправить код",
    ShowUserDashboard: "Перейти к панели управления",
    VerificationCode: "Код подтверждения",
    VerificationCodeExplain: "Пожалуйста, введите код подтверждения, отправленный на ваш телефон.",
    remainingTime: "Оставшееся время",
    createtime: "Время создания",
    ResendVerificationCode: "Отправить код подтверждения повторно",
    VerifyCode: "Подтвердить код",
    Verify: "Подтвердить",
    VerifyAddress: "Подтвердить адрес",
    Continue: "Продолжить",
    metaRedirect_aiAnalysisNotice:
      "Обратите внимание: анализ вашей страницы с помощью искусственного интеллекта может занять несколько часов.",
    Efficiency: "Эффективность",
    max: "МАКС",
    logout: "Выйти",
    notallowed: "Не разрешено",
    notallowedExplain: "У вас нет доступа к этой функции",
    notallowedExplainPage: "У вас нет доступа к этой странице",
    CreateAutomationFlow: "Создать поток автоматизации",
    CreateAutomationFlowExplain:
      "Автоматизируйте взаимодействия в Instagram с помощью визуального конструктора рабочих процессов.",
    CreateAutomationAI: "Создать ИИ-автоматизацию",
    CreateAutomationAIExplain: "Автоматизируйте взаимодействия в Instagram с помощью ответов на основе ИИ.",
    flowProperties_notworking_privateReply:
      "⚠️ Внимание: этот флоу не работает в личных чатах с друзьями и используется только для автоматических ответов на комментарии и сообщения Direct",
    flowProperties_privateReply_requiresFollower:
      "Этот флоу нельзя использовать для личных ответов. Чтобы активировать его, включите в настройках параметр «Пользователь должен подписаться на страницу».",

    needPass: "Подтверждение и активация",
    needPassExplain: "Для полного доступа к этой функции требуется пароль от аккаунта Instagram",
    soon: "Скоро",
    soonExplain: "Эта функция будет доступна в ближайшее время",
    underdevelop: "В разработке",
    reject: "Отклонить",
    rejected: "Отклонено",
    approved: "Одобрено",
    ExpirationTime: "Время истечения",
    send: "Отправить",
    accept: "Принять",
    selectall: "Выбрать все",
    General: "Общий",
    Business: "Бизнес",
    undo: "Отменить",
    redo: "Повторить",
    total: "Итого",
    Unknown: "Неизвестно",
    close: "Закрыть",
    closed: "Закрыто",
    admin: " Администратор",
    user: "Пользователь",
    stop: "Остановить",
    save: "Сохранить",
    discard: "Отменить",
    all: "Все",
    update: "Обновление",
    like: "лайк",
    dislike: "отменить лайк",
    next: "следующий",
    cancel: "отмена",
    canceled: "отменено",
    comment: "комментарий",
    mention: "упоминание",
    add: "Добавить",
    icon: "Иконка",
    copylist: "Копировать список",
    reply: "Ответить",
    replies: "Ответы",
    PrivateReply: "Частный Ответ",
    copy: "Копировать",
    everywhere: "Везде",
    UnHide: "Показать",
    show: "Показать",
    Hide: "Скрыть",
    pageSummary: "Сводка страницы",
    summaryGeneralIntro: "Общий обзор страницы",
    summaryUserEngagement: "Анализ вовлеченности пользователей",
    summaryContentStrategy: "Обзор контентной стратегии",
    summaryPostingSchedule: "Оценка графика публикаций",
    summaryImprovementSuggestions: "Предложения по улучшению и росту",
    Ignore: "Игнорировать",
    Orange: "Оранжевый",
    Purple: "Фиолетовый",
    Green: "Зелёный",
    White: "Белый",
    DarkGray: "Тёмно-серый",
    Blue: "Синий",
    LightGray: "Светло-серый",
    Brown: "Коричневый",
    Pink: "Розовый",
    Yellow: "Жёлтый",
    Silver: "Серебряный",
    Black: "Чёрный",
    Red: "Красный",
    select: "выбрать",
    back: "Назад",
    start: "Старт",
    country: "Страна",
    device: "Устройство",
    yourdevice: "Ваше устройство",
    otherdevice: "Другое устройство",
    SessionID: "ID сессии",
    header: "заголовок",
    upload: "Загрузить",
    active: "Активный",
    activate: "Активировать",
    activateAll: "Активировать все",
    DeactivateAll: "Деактивировать все",
    signout: "Выйти",
    switchaccount: "Сменить аккаунт",
    instagramConnect: "Подключить аккаунт Instagram",
    upgrade: "Обновить",
    Renew_Subscription: "Продлить подписку",
    deactive: "Неактивный",
    Deactivate: "Деактивировать",
    done: "Готово",
    text: "Текст",
    PlaceHolder: "Печатается...",
    media: "Видео/Фото",
    ReplyStory: "Ответ на Story",
    photo: "Фото",
    audio: "Голосовое сообщение",
    Generic: "Общее",
    StoryMention: "Упоминание в Story",
    FileShare: "Файл",
    voice: "Аудио",
    CollaboratorExplain: "Совместное размещение Post или Reels на нескольких страницах Instagram",

    abort: "Прервать",
    Pending: "В ожидании",
    Preparing: "Подготовка",
    Finished: "Завершено",
    finish: "Завершить",
    exportJPG: "Экспорт JPG",
    exportPDF: "Экспорт PDF",
    exportXlxs: "Экспорт Excel",
    dismiss: "Отклонить",
    empty: "Пусто",
    searching: "Поиск ...",
    searchMessage: "Искать людей или ключевое слово",
    searchKeyword: "Искать по ключевому слову",
    Recommended: "Рекомендуется",
    VERFIED: "Проверено",
    SuccessADS: "Успех рекламы",
    SuccessSALES: "Успех продаж",
    StartOrder: "Начать заказ",
    Startshoping: "Начать покупки",
    question: "Вопрос",
    Answer: "Ответ",
    shareStory: "Поделиться стори",
    search: "поиск",
    searchLocation: "Поиск местоположения",
    searchPeople: "Поиск людей",
    edit: "Редактировать",
    delete: "Удалить",
    deletecover: "Удалить обложку",
    details: "Детали",
    Insights: "Аналитика",
    new: "Новый",
    comments: "Комментарии",
    nocomment: "Нет комментариев",
    SimilarProducts: "Похожие продукты",
    QandA: "Вопросы",
    caption: "Подпись",
    collaborator: "Страница Сотрудника",
    collaboratorpost: "Пост Сотрудника",
    sidebar_Home: "Дом",
    sidebar_Page: "Управление",
    sidebar_Message: "Сообщения",
    sidebar_Wallet: "Кошелек",
    sidebar_biolink: "Ссылка в био",
    sidebar_Advertise: "Рекламы",
    sidebar_Store: "Магазин",
    sidebar_Stores: "Магазины",
    sidebar_Business: "Бизнес",
    sidebar_Setting: "Настройки",
    //0️⃣ General -> navbar
    navbar_Post: "Пост",
    navbar_Live: "Прямой эфир",
    navbar_Story: "История",
    navbar_Feed: "Лента",
    navbar_Reels: "Катушки",
    navbar_Statistics: "Статистика",
    navbarTools: "Инструменты",
    navbar_Direct: "Сообщения",
    navbar_Comments: "Комментарии",
    navbar_Ticket: "Тикеты",
    navbar_AI: "ИИ",
    navbar_ContentCreator: "Создатель контента",
    navbar_Properties: "Свойства",
    navbar_AIAndFlow: "ИИ и Agent",
    navbar_Payment: "Платежи",
    navbar_Title: "Заголовок",
    navbar_Home: "Главная",
    navbar_Biolink: "Моя ссылка",
    navbar_Calendar: "Календарь",
    navbar_AdList: "Список реклам",
    navbar_General: "Общие",
    navbar_SubAdmin: "Суб-админы",
    navbar_HelpCenter: "Помощь и Поддержка",

    addnewaccount: "Добавить аккаунт",
    addedaccounts: "Добавленные аккаунты",
    SwitchtoAccountexplain: "Все ваши аккаунты, добавленные в Brancy, отображаются здесь",
    SwitchtoAccount: "Переключиться на аккаунт",
    accountmanagement: "Управление аккаунтом",
    subadmininvitation: "Приглашение к сотрудничеству",
    subadmininvitationexplain: "Приглашение на управление Instagram в роли помощника администратора",

    navbar_Products: "Продукты",
    navbar_Orders: "Заказы",
    navbar_totalOrders: "Всего заказов",
    //0️⃣ countdown
    countdown_Days: "День",
    countdown_Hours: "Час",
    countdown_Minutes: "Минута",
    Expired: "Истек срок",
    justnow: "Только что",
    LessThanAMinute: "Меньше минуты",
    ExpiresIn: "Истекает через",
    ExportPDF: "Экспорт PDF",
    ExportJPG: "Экспорт JPG",
    ShareTo: "Поделиться с",
    Expand: "Развернуть",
    // #endregion General Section
    // #region 1️⃣home Section
    // 1️⃣ Home -> cards
    home_FollowRequest: "Запросы на Подписку",
    home_UnreadNewComments: "Новые Непрочитанные Комментарии",
    home_Last24H: "Последние 24 часа",
    home_Last30Days: "За последние 30 дней",
    home_LastLikes: "Новые лайки",
    home_LastPost: "Последний пост",
    home_Followings: "Подписки ",
    home_Followers: "Подписчики",

    AudienceLocation: "Местоположение активной аудитории",
    AudienceGender: "Пол активной аудитории",
    AudienceAge: "Возраст активной аудитории",

    AudienceGenderStats: "У вас {{female}} женщин, {{male}} мужчин и {{unknown}} с неопределенным полом",

    AudienceAgeStats:
      "Большинство вашей аудитории из возрастной группы {{ageRange}} ({{percentage}}%), поэтому контент должен быть привлекательным и подходящим для {{ageCategory}} аудитории.",

    AgeCategoryYoung: "молодой",
    AgeCategoryMiddleAged: "среднего возраста",
    AgeCategoryOlder: "пожилой",

    AudienceLocationStats:
      "Наибольшее количество активных подписчиков из страны {{country}} — {{countryCount, number}} человек и из города {{city}} — {{cityCount, number}} человек",

    // 1️⃣ Home -> last like
    lastLike: "Последние лайки",
    // 1️⃣ Home -> last message
    lastMessage: "Последние сообщения",
    lastOrder: "Последние заказы",
    lastTransaction: "Последние транзакции",
    // 1️⃣ Home -> last follower
    LastFollowers: "Последние подписчики",
    // #endregion home Section
    // #region 2️⃣page Section
    // 2️⃣ Page -> Post
    CreateNewPost: "Создать новый пост",
    Postnotvisible: "Post не отображается?",
    Storynotvisible: "Story не отображается?",
    SmartPageAnalysis: "Умная аналитика страницы",
    EducationAndGuidance: "Обучение и руководство",
    HowToUseBrancy: "Как пользоваться Brancy",
    BrancyKnowsYou: "Brancy знает вас",
    BrancyKnowsYouExplain:
      "Brancy глубоко анализирует вашу страницу, чтобы создать полное представление о вашей цифровой идентичности: от вашей личности, бизнеса и деятельности до тона и стиля общения, типа контента, способа подачи материалов, графика публикаций и характера взаимодействия с аудиторией.\n\nЭтот анализ также учитывает вашу активность во всех точках взаимодействия на странице: от ответов на комментарии и Direct-сообщения до стиля написания, общения с аудиторией и реакции на различные ситуации.\n\nБез необходимости ручного обучения, настройки тона или ввода дополнительной информации Brancy знает вас и настраивает искусственный интеллект в соответствии с вашей реальной идентичностью и стилем.",
    CreateYourDigitalVersion: "Создайте свою цифровую версию",
    CreateNewStrory: "Создать новую историю",
    PostDraft: "Черновик поста",
    StoryDraft: "Черновик истории",
    publishError: "Ошибка публикации",
    DeletedPost: "Удаленный пост",
    errorDraft_title: "Произошла ошибка при публикации поста",
    errorDraft_configFailed: "Настройки публикации поста неверны, пожалуйста, проверьте и исправьте.",
    errorDraft_invalidTags: "Недопустимые теги: ",
    errorDraft_unknown: "Неизвестная ошибка! Пожалуйста, попробуйте снова.",
    errorDraft_uploadError: "Не удалось загрузить изображение, попробуйте еще раз.",
    errorDraft_userCancel: "Публикация поста была отменена вами.",
    InvalidAspectRatio: "Недопустимое соотношение сторон",
    SizeLimitExceed: "Размер файла превышает допустимый лимит",
    UnSupportMediaType: "Неподдерживаемый тип медиа",
    NotPublishedAtTheTime: "Публикация не выполнена в заданное время",
    NotSuccessLogin: "Не удалось войти в систему",

    NewScheduledPost: "Новый Запланированный пост",
    thereAreNoPost: "Вы ещё не создали ни одного запланированного Post",
    ScheduledPost: "Запланированный пост",
    // 2️⃣ Page -> story
    pageStory_CreateNewStory: "Создать Новую Историю (Скоро)",
    pageStory_CreateNewStories: "Новая Запланированная История (Скоро)",
    pageStory_thereAreNoStories: "Вы ещё не создали ни одной запланированной Story",
    pageStory_ScheduledStories: "Запланированная история",
    // 2️⃣ Page -> highlight
    pageStory_highlightManagement: "Управление Основными Моментами",
    pageStory_thereAreNoHighlight: "Нет основных моментов",
    pageStory_HighlightTitle: "Основные моменты / Папки",
    // 2️⃣ Page -> statistic
    pageStatistics_YourBestFollowers: "Ваши Лучшие Подписчики",
    pageStatistics_YourBestFollowersExplain:
      "Рассчитано на основе общего количества взаимодействий на странице (включая лайки, комментарии и репосты).",
    pageStatistics_LoadMore: "Загрузить еще",
    pageStatistics_UnFollowers: "Отписавшиеся",
    pageStatistics_Followers: "Подписчики",
    pageStatistics_NewFollowers: "Новые Подписчики",
    pageStatistics_ActiveFollowers: "Активные Подписчики",
    pageStatistics_MediaFollows: "Медиа Подписки",
    pageStatistics_Reach: "Охват",
    pageStatistics_ProfileVisit: "Посещения Профиля",
    pageStatistics_30Days: "30 дней",
    pageStatistics_60Days: "60 дней",
    pageStatistics_90Days: "90 дней",
    pageStatistics_120Days: "120 дней",
    pageStatistics_WorstTime: "Худшее время",
    pageStatistics_BestTime: "Лучшее время",
    pageStatistics_likes: "Лайки",
    pageStatistics_Engagements: "Вовлеченность",
    pageStatistics_Impression: "Показы",
    pageStatistics_Views: "Просмотры",
    pageStatistics_followerViews: "Посетители-Фалورеры",
    pageStatistics_ghostViewers: "Призрачные зрители",
    pageStatistics_Comments: "Комментарии",
    pageStatistics_Shares: "Поделились",
    pageStatistics_summary: "Резюме",
    pageStatistics_EmptyList: "Данных пока нет!",
    pageStatistics_from: "По сравнению с",
    pageStatistics_post: "Посты",
    pageStatistics_stories: "Сторисы",
    pageStatistics_MaxView: "Максимальный охват",
    pageStatistics_MinView: "Минимальный охват",
    pageStatistics_MaxCommentLike: "Макс. комментарии & лайки",
    pageStatistics_MinCommentLike: "Мин. комментарии & лайки",
    pageStatistics_PostTimeAnalysis: "Анализ времени публикации",
    pageStatistics_Rate: "Оценка",
    pageStatistics_RateExplain: "На основе наибольшего количества полученных комментариев на всей странице",

    pageStatistics_24HourHeatmap: "24-часовая тепловая карта",
    pageStatistics_Low: "Низкий",
    pageStatistics_High: "Высокий",
    pageStatistics_TopHour: "Лучший час",
    pageStatistics_WeakHour: "Слабый час",
    pageStatistics_AverageHour: "Средний час",
    pageStatistics_TopMinute: "Лучшая минута",
    pageStatistics_WeakMinute: "Слабая минута",
    pageStatistics_AverageMinute: "Средняя минута",
    pageStatistics_HourExcellentLevel:
      "Этот час имеет отличный уровень вовлеченности (выше 80% мощности). Вовлеченность в этот период на {{percentage}}% выше среднего, что делает его идеальным для важного контента.",
    pageStatistics_HourGoodLevel:
      "Этот час имеет хороший уровень вовлеченности (60–80% мощности). Вовлеченность на {{percentage}}% выше среднего, подходит для обычных публикаций.",
    pageStatistics_HourAverageLevel:
      "Этот час имеет средний уровень вовлеченности (40–60% мощности). Для лучших результатов попробуйте периоды с более высокой интенсивностью (зелёный цвет). Разница с лучшим временем: {{difference}}%.",
    pageStatistics_HourWeakLevel:
      "Этот час имеет слабый уровень вовлеченности (20–40% мощности). Рекомендуется публиковать в периоды с более высокой интенсивностью.",
    pageStatistics_HourVeryWeakLevel:
      "Этот час имеет очень слабый уровень вовлеченности (менее 20% мощности). Вовлеченность ниже ожидаемой, публикации не рекомендуются.",
    pageStatistics_MinuteTopDescription:
      "Эта минута входит в топ-10 минут часа {{hour}}:00. Для максимальной вовлеченности рекомендуется публиковать именно в это время. Разница с самой слабой минутой: {{difference}}%.",
    pageStatistics_MinuteWeakDescription:
      "Вовлеченность в эту минуту низкая. Публикация в начале или середине часа может дать лучшие результаты. Разница с лучшей минутой: {{difference}}%.",
    pageStatistics_MinuteAverageDescription:
      "Вовлеченность средняя. Для дальнейшей оптимизации изучите минуты с более высоким рейтингом в этот час.",
    pageStatistics_PeakEngagement: "Пиковая вовлечённость",
    pageStatistics_StableGrowth: "Стабильный рост",
    pageStatistics_HighEngagementProbability: "Высокая вероятность вовлечённости",
    pageStatistics_LowestEngagement: "Минимальная моментальная вовлечённость",
    pageStatistics_SustainedLowPeriod: "Период устойчиво низкой активности",
    pageStatistics_LowEngagementProbability: "Низкая вероятность вовлечённости",
    pageStatistics_BestTimes: "Лучшее время",
    pageStatistics_WorstTimes: "Худшее время",
    pageStatistics_EngagementPrediction: "Прогноз вовлечённости",
    pageStatistics_PeakTimeDescription:
      "В этот момент наблюдается наивысшая вовлечённость. Рекомендуется публиковать для максимального охвата.",
    pageStatistics_StableTimeDescription:
      "С этого момента вовлечённость растёт и остаётся выше среднего. Подходит для стабильной активности.",
    pageStatistics_SecondaryTimeDescription: "Публикация в это время может дать хорошие результаты.",
    pageStatistics_LowestTimeDescription:
      "Минимальная вовлечённость в это время. Публикация приведёт к потере {{percentage}}% потенциальной активности.",
    pageStatistics_SustainedLowTimeDescription:
      "С этого момента вовлечённость начинает снижаться и остаётся низкой. Не рекомендуется публиковать.",
    pageStatistics_SecondaryLowTimeDescription:
      "Ещё один слабый момент с низкой вероятностью вовлечённости. Публикация не рекомендуется.",
    pageStatistics_HourEngagementTooltip: "{{hour}}:00 - {{count}} вовлечённость ({{percentage}}%)",
    pageStatistics_MinuteEngagementTooltip: "{{hour}}:{{minute}} - {{count}} вовлечённость",

    // statistics suggestions box
    Statistics_UnFollowers_up_title: "Снижение количества Unfollowers 💡Пора усилить стратегию удержания",
    Statistics_UnFollowers_up_summary:
      "Падение снизилось -значит, недавний контент сработал. Продолжай в том же направлении, но точнее.",
    Statistics_UnFollowers_up_action1: "Проанализируй последние три Posts: обложку, первую строку и CTA.",
    Statistics_UnFollowers_up_action2: "Составь недельный календарь по этим форматам и отслеживай изменения.",
    Statistics_UnFollowers_up_action3: "Создай приветственную Story и аккуратный Highlight для новых Followers.",
    Statistics_UnFollowers_up_urgency: "Средний",

    Statistics_UnFollowers_neutral_title: "Стабильный уровень -сначала собери данные от пользователей",
    Statistics_UnFollowers_neutral_summary:
      "Поведение аудитории не изменилось; нужно напрямую узнать их мнение и провести короткие тесты.",
    Statistics_UnFollowers_neutral_action1: "Размести опрос в Story, чтобы узнать, что им более интересно.",
    Statistics_UnFollowers_neutral_action2:
      "Публикуй один Post в фиксированном формате каждую неделю и сравни результаты.",
    Statistics_UnFollowers_neutral_action3:
      "Собери три самые частые проблемы из Comments и создай Post, решающий каждую.",
    Statistics_UnFollowers_neutral_urgency: "Низкий",

    Statistics_UnFollowers_down_title: "Рост отписок 💡нужно срочно исправлять",
    Statistics_UnFollowers_down_summary:
      "Рост отписок 💡это негативный сигнал в контенте или ритме публикаций; требуется быстрый тест и реакция.",
    Statistics_UnFollowers_down_action1:
      "Проверь данные за последние 7 дней и выдели два Поста с наибольшим числом отписок.",
    Statistics_UnFollowers_down_action2: "Опубликуй честный или закулисный Пост и напрямую спроси аудиторию о причине.",
    Statistics_UnFollowers_down_action3:
      "Размести Story с открытым вопросом: «Почему ты отписался?» и классифицируй ответы.",
    Statistics_UnFollowers_down_urgency: "Высокий",

    Statistics_UnFollowers_zero_title: "Нет активности 💡нет данных для анализа",
    Statistics_UnFollowers_zero_summary:
      "Из-за отсутствия активности нет сигналов для анализа; сначала нужно возобновить цикл публикаций.",
    Statistics_UnFollowers_zero_action1: "Опубликуй ценный Пост, чтобы создать первый поведенческий сигнал.",
    Statistics_UnFollowers_zero_action2:
      "Размести две интерактивные Stories (Poll или Question), чтобы получить первые реакции.",
    Statistics_UnFollowers_zero_action3:
      "Опубликуй короткий вступительный или обновляющий Пост, чтобы запустить органический охват.",
    Statistics_UnFollowers_zero_urgency: "Высокий",

    Statistics_Followers_up_title: "Рост подписчиков 💡Правильно встречай новых",
    Statistics_Followers_up_summary:
      "Рост увеличивается; с момента их прихода нужно создать позитивный опыт, чтобы они стали активными Followers.",
    Statistics_Followers_up_action1: "Создай приветственный Highlight в формате «Что найдёшь и чем это поможет».",
    Statistics_Followers_up_action2:
      "Запланируй два лёгких сотрудничества или Mention для стабильного и качественного притока.",
    Statistics_Followers_up_action3: "Проверь качество Followers через статистику кампаний и входы из Reels.",
    Statistics_Followers_up_urgency: "Средний",

    Statistics_Followers_neutral_title: "Ровный рост 💡Время коротких тестов",
    Statistics_Followers_neutral_summary:
      "Рост страницы стабилен; нужны 7-дневные тесты, чтобы понять, что влияет на привлечение.",
    Statistics_Followers_neutral_action1: "Проведи 7-дневный тест хэштегов, времени публикации и разных обложек.",
    Statistics_Followers_neutral_action2: "Запиши результаты и создай фиксированный формат из лучшей комбинации.",
    Statistics_Followers_neutral_action3:
      "Опубликуй короткое вводное видео, чтобы новые посетители сразу поняли, что их ждёт.",
    Statistics_Followers_neutral_urgency: "Средний",

    Statistics_Followers_down_title: "Падение привлечения 💡Недавний контент, вероятно, не соответствует персоне",
    Statistics_Followers_down_summary:
      "Снижение привлечения означает несовпадение между текущим контентом и целевой аудиторией.",
    Statistics_Followers_down_action1: "Найди три несоответствия между персоной и недавним контентом и исправь их.",
    Statistics_Followers_down_action2:
      "Быстро перепиши Bio, CTA и обложки нескольких последних Posts и протестируй их.",
    Statistics_Followers_down_action3:
      "Запусти небольшую кампанию сотрудничества или UGC, чтобы реактивировать образ страницы.",
    Statistics_Followers_down_urgency: "Высокая",

    Statistics_Followers_zero_title: "Нет недавней активности 💡Нет данных для привлечения",
    Statistics_Followers_zero_summary:
      "Из-за отсутствия публикаций или действий по привлечению нет сигналов для анализа; нужно снова активировать цикл привлечения.",
    Statistics_Followers_zero_action1:
      "Опубликуй пять коротких Reels с 3-секундным hook, чтобы создать первые входящие.",
    Statistics_Followers_zero_action2:
      "Опубликуй вступительный или обновляющий Post, чтобы запустить естественный охват.",
    Statistics_Followers_zero_action3:
      "Запусти небольшую кампанию по привлечению (даже локальную), чтобы восстановить рост.",
    Statistics_Followers_zero_urgency: "Высокая",

    Statistics_MediaFollows_up_title: "Рост трафика из Explore 💡Серийный формат работает лучше всего",
    Statistics_MediaFollows_up_summary:
      "У вас есть внешние переходы и трафик; превратите успешные форматы в регулярную серию.",
    Statistics_MediaFollows_up_action1: "Разделите успешный формат на 3–5 частей с общим CTA во всех эпизодах.",
    Statistics_MediaFollows_up_action2:
      "Выберите постоянную обложку и стабильный график, чтобы аудитория привыкла к серии.",
    Statistics_MediaFollows_up_action3:
      "Отслеживайте распределение в первые дни и сосредоточьтесь на источнике, который быстрее всего приводит аудиторию.",
    Statistics_MediaFollows_up_urgency: "Средний",

    Statistics_MediaFollows_neutral_title: "Средний реферал 💡время протестировать обложку и источник (A/B)",
    Statistics_MediaFollows_neutral_summary:
      "Чтобы увеличить вход из Explore, необходимо улучшить обложку и источник переходов.",
    Statistics_MediaFollows_neutral_action1: "Опубликуйте две A/B-обложки и сравните их эффективность за 48 часов.",
    Statistics_MediaFollows_neutral_action2:
      "Составьте список источников, которые дали больше всего трафика, и таргетируйте их снова.",
    Statistics_MediaFollows_neutral_action3: "Создайте банк успешных форматов, чтобы их было легче повторять.",
    Statistics_MediaFollows_neutral_urgency: "Низкий",

    Statistics_MediaFollows_down_title: "Снижение трафика из Explore 💡нужен более вовлекающий контент",
    Statistics_MediaFollows_down_summary:
      "Для трафика из Explore лучше работают более полезные или скачиваемые материалы.",
    Statistics_MediaFollows_down_action1:
      "Создайте загружаемый PDF или чек-лист и предоставьте ссылку для удобного распространения.",
    Statistics_MediaFollows_down_action2:
      "Публикуйте короткий обучающий контент и протестируйте таргетированную рекламу.",
    Statistics_MediaFollows_down_action3: "Проверьте ссылки и пути переходов, чтобы убедиться, что ничего не сломано.",
    Statistics_MediaFollows_down_urgency: "Высокий",

    Statistics_MediaFollows_zero_title: "Нет активности 💡сигнал Explore не сформирован",
    Statistics_MediaFollows_zero_summary:
      "Из-за отсутствия публикаций или действий по привлечению нет данных для анализа; сначала нужно активировать цикл контента.",
    Statistics_MediaFollows_zero_action1: "Начните регулярно создавать и публиковать привлекательный контент.",
    Statistics_MediaFollows_zero_action2:
      "Публикуйте по пять коротких материалов ежедневно, чтобы сформировать первые сигналы переходов.",
    Statistics_MediaFollows_zero_action3:
      "В первый день разместите усиленный Post для создания первоначального трафика.",
    Statistics_MediaFollows_zero_urgency: "Высокий",

    Statistics_Reach_up_title: "Рост Reach 💡Время масштабирования",
    Statistics_Reach_up_summary: "Доступность увеличилась; повторяйте лучшие форматы, чтобы поддерживать волну роста.",
    Statistics_Reach_up_action_1: "Повторно опубликуйте два формата с наивысшим Reach в пиковое время.",
    Statistics_Reach_up_action_2: "Закрепите эффективные хештеги и всегда включайте их в подпись.",
    Statistics_Reach_up_action_3:
      "Создавайте Posts с высокой возможностью для шаринга, чтобы увеличить органический Reach.",
    Statistics_Reach_up_urgency: "Средний",

    Statistics_Reach_neutral_title: "Reach стабилен 💡Требуется тестирование",
    Statistics_Reach_neutral_summary:
      "Чтобы выйти из стагнации, легкое сотрудничество или тестирование хештегов 💡лучший вариант.",
    Statistics_Reach_neutral_action_1: "Скоординируйте cross-Post с похожей страницей.",
    Statistics_Reach_neutral_action_2:
      "Опубликуйте два образовательных или развлекательных Reels и оцените обратную связь.",
    Statistics_Reach_neutral_action_3: "Проверьте еженедельный список хештегов и найдите лучшую комбинацию.",
    Statistics_Reach_neutral_urgency: "Низкий",

    Statistics_Reach_down_title: "Reach упал 💡Нужно быстро реагировать",
    Statistics_Reach_down_summary: "Reach снизился; приоритет -контент для шаринга и короткие тесты.",
    Statistics_Reach_down_action_1: "Запустите 7-дневный тест на Reels с высоким потенциалом.",
    Statistics_Reach_down_action_2: "Создайте shareable Posts и продвигайте их короткой рекламой.",
    Statistics_Reach_down_action_3: "Перепишите заголовок, обложку и хештеги, затем повторно опубликуйте Post.",
    Statistics_Reach_down_urgency: "Высокий",

    Statistics_Reach_zero_title: "Reach не зафиксирован 💡Низкая активность",
    Statistics_Reach_zero_summary:
      "Из-за отсутствия публикаций или достаточных сигналов нет данных для Reach; цикл контента должен быть активирован.",
    Statistics_Reach_zero_action_1: "Проверьте сбор данных (API/logs) для корректной работы.",
    Statistics_Reach_zero_action_2: "Опубликуйте 5 трендовых Reels и продвиньте один со второго дня.",
    Statistics_Reach_zero_action_3: "Протестируйте систему расписания публикаций и при необходимости сбросьте её.",
    Statistics_Reach_zero_urgency: "Высокий",

    Statistics_ProfileVisit_up_title: "Высокие Посещения Профиля 💡Сосредоточьтесь на Конверсии",
    Statistics_ProfileVisit_up_summary:
      "Хороший входящий трафик; Bio и CTA нужно быстро оптимизировать, чтобы визиты превращались в follows и clicks.",
    Statistics_ProfileVisit_up_action_1: "Перепишите Bio с чётким предложением ценности и прямым CTA.",
    Statistics_ProfileVisit_up_action_2:
      "Создайте ключевые Highlights, чтобы пользователи понимали, что они видели и чего ожидать.",
    Statistics_ProfileVisit_up_action_3: "Опубликуйте Post с особым предложением для увеличения CTR на ссылку.",
    Statistics_ProfileVisit_up_urgency: "Высокий",

    Statistics_ProfileVisit_neutral_title: "Посещения Есть, Конверсия Низкая 💡Генерируйте Leads",
    Statistics_ProfileVisit_neutral_summary: "Есть трафик, но низкая конверсия; магнитный Lead может изменить поток.",
    Statistics_ProfileVisit_neutral_action_1: "Добавьте бесплатный файл или чеклист в Highlights.",
    Statistics_ProfileVisit_neutral_action_2: "Усильте подписи CTA, связанным с профилем.",
    Statistics_ProfileVisit_neutral_action_3: "Увеличьте количество приглашающих и направляющих Stories к профилю.",
    Statistics_ProfileVisit_neutral_urgency: "Средний",

    Statistics_ProfileVisit_down_title: "Падение Посещений Профиля 💡Нужен Более Сильный Hook",
    Statistics_ProfileVisit_down_summary:
      "Любопытство снизилось; начало подписей и CTA должно быть более привлекательным и понятным.",
    Statistics_ProfileVisit_down_action_1: "Перепишите подписи с Hook из 3–5 слов.",
    Statistics_ProfileVisit_down_action_2: "Добавьте направляющие Stories и выделите ссылку жирным.",
    Statistics_ProfileVisit_down_action_3:
      "Опубликуйте привлекательный Post, чтобы побудить пользователей посещать профиль.",
    Statistics_ProfileVisit_down_urgency: "Высокий",

    Statistics_ProfileVisit_zero_title: "Нет Посещений Профиля 💡Недостаточно Активности",
    Statistics_ProfileVisit_zero_summary:
      "Из-за отсутствия публикаций или достаточных сигналов посещения профиля нет; цикл вовлечения нужно снова активировать.",
    Statistics_ProfileVisit_zero_action_1: "Проверьте статус аккаунта, чтобы он был public.",
    Statistics_ProfileVisit_zero_action_2: "Опубликуйте привлекательный Post с ясным CTA.",
    Statistics_ProfileVisit_zero_action_3: "Обновите ключевые Highlights, чтобы создать первый сигнал посещения.",
    Statistics_ProfileVisit_zero_urgency: "Высокий",

    Statistics_Likes_up_title: "Лайки Хорошие 💡Сделайте Привычку",
    Statistics_Likes_up_summary:
      "Пользователи ставят лайки; теперь цель 💡превратить это поведение в постоянную привычку.",
    Statistics_Likes_up_action_1: "Документируйте успешные форматы (cover, template, длина).",
    Statistics_Likes_up_action_2: "Добавьте простой CTA для лайков в конце Post (например, 'Если согласны ❤').",
    Statistics_Likes_up_action_3: "Проведите небольшой A/B тест для cover и первых 3 секунд.",
    Statistics_Likes_up_urgency: "Средний",

    Statistics_Likes_neutral_title: "Лайки Можно Увеличить 💡Улучшите Hook & Cover",
    Statistics_Likes_neutral_summary: "Есть потенциал; изменение cover и hook может повысить количество лайков.",
    Statistics_Likes_neutral_action_1: "Оптимизируйте и протестируйте cover и первые 3 секунды.",
    Statistics_Likes_neutral_action_2: "Используйте эмоциональные или вопросительные CTA для приглашения к лайку.",
    Statistics_Likes_neutral_action_3: "Проведите небольшой опрос, чтобы понять визуальные предпочтения аудитории.",
    Statistics_Likes_neutral_urgency: "Низкий",

    Statistics_Likes_down_title: "Лайки Падают 💡Переработайте Визуальную Идентичность",
    Statistics_Likes_down_summary:
      "Сообщение или изображение может быть слабым; сосредоточьтесь на первом моменте контента.",
    Statistics_Likes_down_action_1: "Перепишите cover и первую строку caption.",
    Statistics_Likes_down_action_2: "Проведите A/B тест цвета/дизайна cover.",
    Statistics_Likes_down_action_3: "Публикуйте сильные и релевантные визуальные Posts.",
    Statistics_Likes_down_urgency: "Высокий",

    Statistics_Likes_zero_title: "Ноль Лайков 💡Нет данных или нет контента",
    Statistics_Likes_zero_summary:
      "Если контент есть, но лайки не зарегистрированы, проверьте данные; иначе начните производство.",
    Statistics_Likes_zero_action_1: "Проверьте точность регистрации данных.",
    Statistics_Likes_zero_action_2: "Если контента нет, опубликуйте несколько Posts с сильными cover.",
    Statistics_Likes_zero_action_3: "Используйте партнерские сети для получения отзывов.",
    Statistics_Likes_zero_urgency: "Высокий",

    Statistics_Comments_up_title: "Комментарии Увеличились 💡Воспринимайте Диалог Серьезно",
    Statistics_Comments_up_summary: "Люди общаются; используйте это, отвечая и превращая комментарии в контент.",
    Statistics_Comments_up_action1: "Отвечайте на комментарии и превратите топ-3 идей в Post.",
    Statistics_Comments_up_action2: "Отметьте лучшие комментарии или покажите их в Story.",
    Statistics_Comments_up_action3: "Добавьте вопрос в caption, который побуждает людей отвечать.",
    Statistics_Comments_up_urgency: "Средний",

    Statistics_Comments_neutral_title: "Комментарии Низкие 💡Добавьте Стимул",
    Statistics_Comments_neutral_summary: "Для генерации диалога задавайте простые и прямые вопросы.",
    Statistics_Comments_neutral_action1: "Оставьте открытый вопрос в конце Post.",
    Statistics_Comments_neutral_action2: "Быстро ответьте на первые 5 комментариев, чтобы мотивировать других.",
    Statistics_Comments_neutral_action3: "Проведите короткий челлендж или опрос.",
    Statistics_Comments_neutral_urgency: "Низкий",

    Statistics_Comments_down_title: "Комментарии Уменьшились 💡Добавьте Четкие Стимулы",
    Statistics_Comments_down_summary: "Нужны прямые CTA и приглашения, чтобы начать разговор.",
    Statistics_Comments_down_action1: "Опубликуйте вызов или запросите личный опыт.",
    Statistics_Comments_down_action2: "Включите четкий CTA для комментариев в caption (например: 'Ваше мнение?').",
    Statistics_Comments_down_action3: "Быстро реагируйте на первые комментарии.",
    Statistics_Comments_down_urgency: "Высокий",

    Statistics_Comments_zero_title: "Нет Комментариев 💡Будьте Приглашающим",
    Statistics_Comments_zero_summary: "Контент не стимулирует к комментариям; сделайте форматы более привлекательными.",
    Statistics_Comments_zero_action1:
      "Разработайте простые и увлекательные вопросы (например, выбор между двумя вариантами).",
    Statistics_Comments_zero_action2: "Быстро отвечайте на первые комментарии, чтобы стимулировать других.",
    Statistics_Comments_zero_action3: "Используйте прямые CTA для приглашения к комментариям.",
    Statistics_Comments_zero_urgency: "Высокий",

    Statistics_Views_up_title: "Просмотры выросли 💡Используйте трафик",
    Statistics_Views_up_summary:
      "Просмотры видео хорошие; используйте конец видео для направления трафика (профиль/сохранение).",
    Statistics_Views_up_action1: "Добавьте ясный CTA в конце видео (например, 'Сохрани для большего').",
    Statistics_Views_up_action2: "Разместите ссылку на дополнительный контент в био или highlights.",
    Statistics_Views_up_action3: "Создайте и опубликуйте короткую версию или тизер.",
    Statistics_Views_up_urgency: "Средний",

    Statistics_Views_neutral_title: "Просмотры стабильны 💡Усильте крючок и обложку",
    Statistics_Views_neutral_summary: "Работайте над первыми 3 секундами и обложкой, чтобы улучшить просмотры.",
    Statistics_Views_neutral_action1: "Перепишите начальный крючок и обложку.",
    Statistics_Views_neutral_action2: "Опубликуйте короткую версию для теста.",
    Statistics_Views_neutral_action3: "Соберите визуальные отзывы от аудитории.",
    Statistics_Views_neutral_urgency: "Низкий",

    Statistics_Views_down_title: "Просмотры упали 💡Усиль крючок",
    Statistics_Views_down_summary: "Начало видео слабое; начни тестировать короткие, привлекательные версии.",
    Statistics_Views_down_action1: "Создай 5 сильных 15-секундных видео с крючком.",
    Statistics_Views_down_action2: "Перепиши начало видео и проведи A/B тесты.",
    Statistics_Views_down_action3: "Увеличь скорость монтажа, чтобы удерживать внимание.",
    Statistics_Views_down_urgency: "Высокий",

    Statistics_Views_zero_title: "Ноль просмотров? 💡Публикуй контент как можно скорее",
    Statistics_Views_zero_summary: "Начни производство контента немедленно при первой возможности.",
    Statistics_Views_zero_action1: "Начни только с анализа рабочего процесса страницы.",
    Statistics_Views_zero_action2: "Если видео не опубликованы, создай 3 коротких рилса.",
    Statistics_Views_zero_action3: "Запусти усиленный пост для получения первых показов.",
    Statistics_Views_zero_urgency: "Высокий",

    Statistics_FollowerViews_up_title: "Подписчики смотрят 💡создайте внутреннее взаимодействие",
    Statistics_FollowerViews_up_summary:
      "Подписчики активны; используйте их для внутреннего взаимодействия (AMA, опросы).",
    Statistics_FollowerViews_up_action1: "Задавайте вопросы или проводите опросы в Stories для подписчиков.",
    Statistics_FollowerViews_up_action2: "Публикуйте эксклюзивный контент для подписчиков (например, AMA).",
    Statistics_FollowerViews_up_action3:
      "Проверяйте форматы по персонам, чтобы точнее соответствовать их предпочтениям.",
    Statistics_FollowerViews_up_urgency: "Средний",

    Statistics_FollowerViews_neutral_title: "Просмотры подписчиков обычные 💡тестируйте время и формат",
    Statistics_FollowerViews_neutral_summary:
      "Время публикации или тип контента может требовать корректировки; проводите простые тесты.",
    Statistics_FollowerViews_neutral_action1: "Измените время публикации и отслеживайте влияние.",
    Statistics_FollowerViews_neutral_action2: "Тестируйте новый формат специально для подписчиков.",
    Statistics_FollowerViews_neutral_action3: "Персонализируйте контент на основе предыдущего поведения аудитории.",
    Statistics_FollowerViews_neutral_urgency: "Низкий",

    Statistics_FollowerViews_down_title: "Просмотры подписчиков снизились 💡Соберите обратную связь",
    Statistics_FollowerViews_down_summary:
      "Возможно, отход от персоны; соберите отзывы и внедрите 3 быстрых изменения.",
    Statistics_FollowerViews_down_action1: "Соберите последние отзывы и примените три быстрых изменения.",
    Statistics_FollowerViews_down_action2: "Разместите стимулирующие Stories, чтобы реактивировать аудиторию.",
    Statistics_FollowerViews_down_action3: "Тестируйте персонализированные версии контента.",
    Statistics_FollowerViews_down_urgency: "Высокий",

    Statistics_FollowerViews_zero_title: "Просмотры подписчиков ноль 💡сначала убедитесь в активности подписчиков",
    Statistics_FollowerViews_zero_summary:
      "Вероятно, у вас мало активных подписчиков; сначала разбудите их, затем взаимодействуйте.",
    Statistics_FollowerViews_zero_action1: "Опубликуйте несколько Stories и постов для активации аудитории.",
    Statistics_FollowerViews_zero_action2: "Взаимодействуйте напрямую с 10 активными подписчиками.",
    Statistics_FollowerViews_zero_action3: "Создавайте контент на основе предыдущих интересов.",
    Statistics_FollowerViews_zero_urgency: "Высокий",

    Statistics_NonFollowerViews_up_title: "Просмотры не подписчиков выросли 💡новая возможность",
    Statistics_NonFollowerViews_up_summary:
      "Люди вне подписчиков смотрят; каждый пост должен иметь вескую причину для подписки.",
    Statistics_NonFollowerViews_up_action1:
      "Укажите вескую причину для подписки в подписи (например, серийный контент или пошаговые уроки).",
    Statistics_NonFollowerViews_up_action2:
      "Создайте трендовые, привлекающие внимание Reels для вовлечения не подписчиков.",
    Statistics_NonFollowerViews_up_action3: "Используйте целевые хэштеги и релевантные коллаборации.",
    Statistics_NonFollowerViews_up_urgency: "Средний",

    Statistics_NonFollowerViews_neutral_title:
      "Просмотры не подписчиков стабильны 💡оптимизируйте хэштеги и распространение",
    Statistics_NonFollowerViews_neutral_summary:
      "Оптимизация хэштегов и создаваемого контента может увеличить трафик не подписчиков.",
    Statistics_NonFollowerViews_neutral_action1: "Определите эффективные хэштеги и оставьте несколько постоянными.",
    Statistics_NonFollowerViews_neutral_action2: "Создайте больше контента для обмена.",
    Statistics_NonFollowerViews_neutral_action3: "Короткое сотрудничество с тематическими страницами.",
    Statistics_NonFollowerViews_neutral_urgency: "Низкий",

    Statistics_NonFollowerViews_down_title: "Просмотры не подписчиков снизились 💡требуется сотрудничество и реклама",
    Statistics_NonFollowerViews_down_summary:
      "Доступ к Explore снизился; восстановите трафик через сотрудничество или легкую рекламу.",
    Statistics_NonFollowerViews_down_action1: "Настройте быстрое сотрудничество с релевантной страницей.",
    Statistics_NonFollowerViews_down_action2: "Создайте больше контента для обмена и опубликуйте пост для продвижения.",
    Statistics_NonFollowerViews_down_action3: "Запустите небольшую целевую рекламу для возвращения трафика.",
    Statistics_NonFollowerViews_down_urgency: "Высокий",

    Statistics_NonFollowerViews_zero_title: "Просмотры не подписчиков ноль 💡нужно создать сигналы для Explore",
    Statistics_NonFollowerViews_zero_summary:
      "Для получения первого трафика трендовые Reels и сотрудничество -лучший старт.",
    Statistics_NonFollowerViews_zero_action1: "Создайте 3 Reels по трендам.",
    Statistics_NonFollowerViews_zero_action2: "Опубликуйте пост для продвижения, чтобы получить начальный трафик.",
    Statistics_NonFollowerViews_zero_action3: "Начните быстрое сотрудничество с релевантной страницей.",
    Statistics_NonFollowerViews_zero_urgency: "Высокий",

    Statistics_Shares_up_title: "Поделились много 💡твой контент стоит распространять",
    Statistics_Shares_up_summary:
      "Люди делятся твоими постами; значит, контент имеет мгновенную ценность и может конвертировать.",
    Statistics_Shares_up_action1: "Проанализируй обратную связь по шерам и найди закономерности.",
    Statistics_Shares_up_action2: "Добавь четкую причину для шеринга в подписи ('Отправь другу').",
    Statistics_Shares_up_action3: "Создай образовательную серию, которую можно поделиться.",
    Statistics_Shares_up_urgency: "Средний",

    Statistics_Shares_neutral_title: "Поделились мало или стабильно 💡нужен простой триггер",
    Statistics_Shares_neutral_summary: "Иногда достаточно короткого CTA, чтобы увеличить шеры.",
    Statistics_Shares_neutral_action1: "Добавь очень короткий CTA для шеринга в конце поста.",
    Statistics_Shares_neutral_action2: "Создавай больше сохраняемого и распространяемого контента.",
    Statistics_Shares_neutral_action3: "Протестируй шаблон 'Отправь другу'.",
    Statistics_Shares_neutral_urgency: "Низкий",

    Statistics_Shares_down_title: "Снижение шеров 💡нужен более практичный контент",
    Statistics_Shares_down_summary:
      "Контент стал менее пригодным для шеринга; создай что-то, что люди захотят отправить другим.",
    Statistics_Shares_down_action1: "Создавай чек-листы или пошаговый контент.",
    Statistics_Shares_down_action2: "Публикуй короткие и лаконичные уроки.",
    Statistics_Shares_down_action3: "Добавь четкий CTA для шеринга.",
    Statistics_Shares_down_urgency: "Высокий",

    Statistics_Shares_zero_title: "Нет шеров 💡нужно создать отправную точку",
    Statistics_Shares_zero_summary:
      "Либо нет данных, либо контент не пригоден для шеринга; быстро разработай план распространения.",
    Statistics_Shares_zero_action1: "Произведи несколько материалов из 5 советов или чек-листов.",
    Statistics_Shares_zero_action2: "Запусти небольшой буст для получения первого сигнала.",
    Statistics_Shares_zero_action3: "Напиши в подписи четкую причину для шеринга.",
    Statistics_Shares_zero_urgency: "Высокий",

    Statistics_Engagement_up_title: "Вовлеченность растет 💡закрепи формулу",
    Statistics_Engagement_up_summary: "Вы нашли рабочий паттерн; теперь повторяйте и масштабируйте его.",
    Statistics_Engagement_up_action1: "Точно записывайте успешные форматы и время публикаций.",
    Statistics_Engagement_up_action2: "Добавьте форматы, стимулирующие вовлеченность, в контент-календарь.",
    Statistics_Engagement_up_action3: "Тестируйте один новый формат удержания еженедельно.",
    Statistics_Engagement_up_urgency: "Средний",

    Statistics_Engagement_neutral_title: "Вовлеченность обычная 💡нужен свежий стимул",
    Statistics_Engagement_neutral_summary:
      "Для роста вводите новые триггеры, например вопросы, челленджи или приглашение к комментированию.",
    Statistics_Engagement_neutral_action1: "Публикуйте один пост в неделю с приглашением к комментарию.",
    Statistics_Engagement_neutral_action2: "Направляйте вовлеченность и сравнивайте результаты разных форматов.",
    Statistics_Engagement_neutral_action3: "Разработайте несколько шаблонов для быстрого взаимодействия.",
    Statistics_Engagement_neutral_urgency: "Низкий",

    Statistics_Engagement_down_title: "Вовлеченность падает 💡срочная переработка необходима",
    Statistics_Engagement_down_summary: "Необходимо немедленно запускать новые тесты; план на 14 дней -лучший старт.",
    Statistics_Engagement_down_action1: "Выполните 14-дневный план с 3 разными форматами.",
    Statistics_Engagement_down_action2: "Ежедневно записывайте данные и быстро делайте pivot.",
    Statistics_Engagement_down_action3: "Спросите у аудитории напрямую, какой контент ей интересен.",
    Statistics_Engagement_down_urgency: "Высокий",

    Statistics_Engagement_zero_title: "Нулевая вовлеченность 💡нужен интенсивный 7-дневный план",
    Statistics_Engagement_zero_summary:
      "Необходимо быстро генерировать сигналы вовлеченности; публикуйте интерактивный контент ежедневно и отслеживайте данные.",
    Statistics_Engagement_zero_action1: "Публикуйте опросы, открытые вопросы и небольшие челленджи.",
    Statistics_Engagement_zero_action2: "Тестируйте каждый формат в течение 3 дней.",
    Statistics_Engagement_zero_action3: "Быстро отвечайте на комментарии и сообщения.",
    Statistics_Engagement_zero_urgency: "Высокий",

    Statistics_Replies_up_title: "Много ответов в сторис 💡сделай из этого контент",
    Statistics_Replies_up_summary: "Аудитория пишет; им нужен интерактив. Это золотой контент.",
    Statistics_Replies_up_action_1: "Выбери 3 лучших ответа и преврати их в пост или Reel.",
    Statistics_Replies_up_action_2: "Создай Q&A или FAQ с часто встречающимися ответами.",
    Statistics_Replies_up_action_3: "Покажи несколько ответов в следующей сторис, чтобы мотивировать других.",
    Statistics_Replies_up_urgency: "Средний",

    Statistics_Replies_neutral_title: "Мало ответов 💡добавь стимул",
    Statistics_Replies_neutral_summary: "Иногда простой вопрос - достаточно, чтобы получить больше ответов.",
    Statistics_Replies_neutral_action_1: "Добавь стикер вопрос, опрос или Quiz.",
    Statistics_Replies_neutral_action_2: "Задавай короткие и интересные вопросы.",
    Statistics_Replies_neutral_action_3: "Быстро реагируй на ответы для увеличения вовлеченности.",
    Statistics_Replies_neutral_urgency: "Низкий",

    Statistics_Replies_down_title: "Ответы падают 💡Увеличь близость",
    Statistics_Replies_down_summary: "Аудитория кажется отдаленной; сблизься с ней через более личный контент.",
    Statistics_Replies_down_action_1: "Опубликуй несколько личных, опытных или эмоциональных сторис.",
    Statistics_Replies_down_action_2: "Задавай вопросы, требующие личного опыта для ответа.",
    Statistics_Replies_down_action_3: "Обращай внимание на первые ответы; реагируй или отвечай на них.",
    Statistics_Replies_down_urgency: "Высокий",

    Statistics_Replies_zero_title: "Ноль ответов 💡Нужен прямой запрос",
    Statistics_Replies_zero_summary: "Когда нет ответов, нужно задавать заманчивые, прямые вопросы.",
    Statistics_Replies_zero_action_1:
      "Публикуй очень простые и интересные вопросы (например, выбор между двумя вариантами).",
    Statistics_Replies_zero_action_2: "Выделяй ответы, которые получаешь, чтобы мотивировать других.",
    Statistics_Replies_zero_action_3: "Каждый день делай лёгкую интерактивную сторис.",
    Statistics_Replies_zero_urgency: "Высокий",

    Statistics_TotalTime_up_title: "Время просмотра увеличилось 💡Давай более глубокий контент",
    Statistics_TotalTime_up_summary: "Аудитория тратит время; готова к длинным и структурированным видео.",
    Statistics_TotalTime_up_action_1: "Создавай длинные видео со структурой: вступление/середина/заключение.",
    Statistics_TotalTime_up_action_2: "Добавь ссылки на дополнительный контент в био или Highlights.",
    Statistics_TotalTime_up_action_3: "Чётко сегментируй видео для увеличения удержания.",
    Statistics_TotalTime_up_urgency: "Средний",

    Statistics_TotalTime_neutral_title: "Время просмотра обычное 💡Укрепи структуру",
    Statistics_TotalTime_neutral_summary:
      "Аудитория остаётся, но не вовлечена полностью; улучшай структуру для удержания.",
    Statistics_TotalTime_neutral_action_1: "Реализуй трёхслойную структуру для видео.",
    Statistics_TotalTime_neutral_action_2: "Выделяй ключевые моменты, чтобы зрители знали, чего ожидать.",
    Statistics_TotalTime_neutral_action_3: "Создай краткую версию для теста и сравнения.",
    Statistics_TotalTime_neutral_urgency: "Низкий",

    Statistics_TotalTime_down_title: "Время просмотра упало 💡слабый первый хук",
    Statistics_TotalTime_down_summary: "Первые 3 секунды должны цеплять; сделайте их быстрее, ярче и сильнее.",
    Statistics_TotalTime_down_action_1: "Перепишите первые 3 секунды и протестируйте несколько версий.",
    Statistics_TotalTime_down_action_2: "Создайте очень короткие версии 15–30 секунд.",
    Statistics_TotalTime_down_action_3: "Уточните ритм монтажа, склейки и музыку.",
    Statistics_TotalTime_down_urgency: "Высокий",

    Statistics_TotalTime_zero_title: "Время просмотра ноль 💡ещё не опубликовано?",
    Statistics_TotalTime_zero_summary:
      "Если видео есть, но время не фиксируется, сначала проверьте технические проблемы.",
    Statistics_TotalTime_zero_action_1: "Убедитесь, что контент опубликован.",
    Statistics_TotalTime_zero_action_2: "Если не опубликовано, разместите 3 коротких рилса подряд.",
    Statistics_TotalTime_zero_action_3: "Запустите boost или начальный показ для сбора данных.",
    Statistics_TotalTime_zero_urgency: "Высокий",

    Statistics_ReachMonth_up_title: "Ежемесячный охват вырос 💡закрепите шаблоны",
    Statistics_ReachMonth_up_summary: "Успешные месяцы очевидны; зафиксируйте шаблоны и планируйте следующий месяц.",
    Statistics_ReachMonth_up_action_1: "Проанализируйте высокоэффективные месяцы и зафиксируйте шаблоны.",
    Statistics_ReachMonth_up_action_2: "Обновите контент-календарь с этими шаблонами.",
    Statistics_ReachMonth_up_action_3: "Перепубликуйте выигрышные форматы для следующего месяца.",
    Statistics_ReachMonth_up_urgency: "Средний",

    Statistics_ReachMonth_neutral_title: "Ежемесячный охват стабильный 💡время для теста и роста",
    Statistics_ReachMonth_neutral_summary:
      "Для увеличения ежемесячного охвата запустите короткую кампанию или ограниченную рекламу.",
    Statistics_ReachMonth_neutral_action_1: "Запустите совместную кампанию или ограниченную рекламу.",
    Statistics_ReachMonth_neutral_action_2: "Запишите, сравните результаты и оптимизируйте.",
    Statistics_ReachMonth_neutral_action_3: "Снова продвигайте успешные предыдущие посты.",
    Statistics_ReachMonth_neutral_urgency: "Низкий",

    Statistics_ReachMonth_down_title: "Ежемесячный охват снизился 💡пересоздайте контент",
    Statistics_ReachMonth_down_summary: "Чтобы восстановить охват, перепубликуйте или пересоздайте ключевые посты.",
    Statistics_ReachMonth_down_action_1: "Перепубликуйте или пересоздайте ключевые посты.",
    Statistics_ReachMonth_down_action_2: "Запустите 14-дневную кампанию по созданию и продвижению контента.",
    Statistics_ReachMonth_down_action_3: "Повторно проверьте хештеги и теги.",
    Statistics_ReachMonth_down_urgency: "Высокий",

    Statistics_ReachMonth_zero_title: "Ежемесячный охват ноль 💡сначала проверьте данные",
    Statistics_ReachMonth_zero_summary:
      "Нет данных или они неполные; сначала проверьте технические моменты, затем запустите 14-дневный план.",
    Statistics_ReachMonth_zero_action_1: "Проверьте соединения данных и регистрацию.",
    Statistics_ReachMonth_zero_action_2: "Реализуйте 14-дневный план по созданию контента.",
    Statistics_ReachMonth_zero_action_3: "Отслеживайте ежедневные результаты.",
    Statistics_ReachMonth_zero_urgency: "Высокий",

    Statistics_MonthEngagement_up_title: "Ежемесячное вовлечение растет 💡масштабируй",
    Statistics_MonthEngagement_up_summary: "Записывайте положительные ежемесячные шаблоны и повторяйте их.",
    Statistics_MonthEngagement_up_action_1: "Документируйте успешные шаблоны и форматы.",
    Statistics_MonthEngagement_up_action_2: "Установите четкие KPI и планы на следующий месяц.",
    Statistics_MonthEngagement_up_action_3: "Проводите небольшие еженедельные тесты для улучшения вовлеченности.",
    Statistics_MonthEngagement_up_urgency: "Средний",

    Statistics_MonthEngagement_neutral_title: "Ежемесячное вовлечение нейтральное 💡добавьте элемент вызова",
    Statistics_MonthEngagement_neutral_summary: "Еженедельный вызов или вопрос может увеличить вовлечение.",
    Statistics_MonthEngagement_neutral_action_1:
      "Публикуйте один сложный или вопросно-ориентированный контент еженедельно.",
    Statistics_MonthEngagement_neutral_action_2: "Записывайте и сравнивайте результаты.",
    Statistics_MonthEngagement_neutral_action_3: "Создайте еженедельную серию для вовлечения.",
    Statistics_MonthEngagement_neutral_urgency: "Низкий",

    Statistics_MonthEngagement_down_title: "Ежемесячное вовлечение упало 💡запусти 14-дневный план",
    Statistics_MonthEngagement_down_summary: "Пересмотрите форматы и выполните 14-дневный план.",
    Statistics_MonthEngagement_down_action_1: "Запустите 14-дневный план с 3 различными форматами.",
    Statistics_MonthEngagement_down_action_2: "Анализируйте результаты ежедневно.",
    Statistics_MonthEngagement_down_action_3: "Собирайте прямую обратную связь от аудитории.",
    Statistics_MonthEngagement_down_urgency: "Высокий",

    Statistics_MonthEngagement_zero_title: "Ежемесячное вовлечение ноль 💡срочная 7-дневная программа",
    Statistics_MonthEngagement_zero_summary: "Опубликуйте 7 быстрых интерактивных постов и отслеживайте ежедневно.",
    Statistics_MonthEngagement_zero_action_1: "Создайте 7 интерактивных постов.",
    Statistics_MonthEngagement_zero_action_2: "Ежедневно проверяйте результаты.",
    Statistics_MonthEngagement_zero_action_3: "Взаимодействуйте с аудиторией через DM и комментарии.",
    Statistics_MonthEngagement_zero_urgency: "Высокий",

    Statistics_MonthView_up_title: "Ежемесячные просмотры выросли 💡зафиксируйте структуру",
    Statistics_MonthView_up_summary: "Видеостратегия работает; публикуйте эти форматы последовательно.",
    Statistics_MonthView_up_action_1: "Документируйте видеостратегию.",
    Statistics_MonthView_up_action_2: "Превратите регулярное производство в стандартный формат.",
    Statistics_MonthView_up_action_3: "Проверяйте и записывайте ключевые ежемесячные показатели.",
    Statistics_MonthView_up_urgency: "Средний",

    Statistics_MonthView_neutral_title: "Ежемесячные просмотры стабильны 💡попробуйте смесь форматов",
    Statistics_MonthView_neutral_summary: "Смешивание Reels и Stories может создать новые каналы трафика.",
    Statistics_MonthView_neutral_action_1: "Создайте смешанный контент Reels+Stories.",
    Statistics_MonthView_neutral_action_2: "Записывайте и сравнивайте результаты.",
    Statistics_MonthView_neutral_action_3: "Добавьте подписи, направляющие к видео.",
    Statistics_MonthView_neutral_urgency: "Низкий",

    Statistics_MonthView_down_title: "Ежемесячные просмотры упали 💡сосредоточьтесь на Reels",
    Statistics_MonthView_down_summary:
      "Короткие Reels с привлекательными обложками - самый быстрый способ вернуть просмотры.",
    Statistics_MonthView_down_action_1: "Создайте Reels длиной 15–30 секунд.",
    Statistics_MonthView_down_action_2: "Разработайте привлекательные обложки.",
    Statistics_MonthView_down_action_3: "Проводите тесты тайминга.",
    Statistics_MonthView_down_urgency: "Высокий",

    Statistics_MonthView_zero_title: "Ежемесячные просмотры ноль 💡сначала проверьте технические проблемы",
    Statistics_MonthView_zero_summary:
      "Возможно, есть проблемы с данными или публикацией; сначала проверьте технически, затем запустите 14-дневный план.",
    Statistics_MonthView_zero_action_1: "Проверьте данные видео технически.",
    Statistics_MonthView_zero_action_2: "Запустите 14-дневный план производства контента.",
    Statistics_MonthView_zero_action_3: "Отслеживайте результаты ежедневно.",
    Statistics_MonthView_zero_urgency: "Высокий",
    Statistics_RePosts_up_title: "Репосты растут 💡 Используйте это",
    Statistics_RePosts_up_summary: "Аудитория делится вашими постами — это значит, что контент стоит распространять.",
    Statistics_RePosts_up_action_1: "Добавьте в описание чёткую причину для репоста («Отправь другу»).",
    Statistics_RePosts_up_action_2: "Создайте обучающую серию, удобную для шаринга.",
    Statistics_RePosts_up_action_3: "Проанализируйте обратную связь по репостам и найдите закономерности.",
    Statistics_RePosts_up_urgency: "Средний",
    Statistics_RePosts_neutral_title: "Репосты Низкие или Стабильные 💡 Нужен Лишь Простой Триггер",
    Statistics_RePosts_neutral_summary: "Иногда короткого CTA достаточно, чтобы увеличить репосты.",
    Statistics_RePosts_neutral_action_1: "Добавьте очень короткий CTA для репоста в конце Post.",
    Statistics_RePosts_neutral_action_2: "Создавайте больше контента, который хочется сохранить и отправить.",
    Statistics_RePosts_neutral_action_3: "Запустите тестовый формат «Отправь другу».",
    Statistics_RePosts_neutral_urgency: "Низкий",
    Statistics_RePosts_down_title: "Репосты Снижаются 💡 Нужен Более Практичный Контент",
    Statistics_RePosts_down_summary:
      "Контент стал менее пересылаемым; нужно создавать то, чем люди хотят делиться с другими.",
    Statistics_RePosts_down_action_1: "Создайте чек-лист или пошаговый контент.",
    Statistics_RePosts_down_action_2: "Публикуйте короткие и ёмкие обучающие материалы.",
    Statistics_RePosts_down_action_3: "Добавьте чёткий CTA для репоста.",
    Statistics_RePosts_down_urgency: "Высокий",
    Statistics_RePosts_zero_title: "Репостов Нет 💡 Нужно Создать Точку Старта",
    Statistics_RePosts_zero_summary:
      "Либо нет данных, либо контент не подходит для репоста; быстро разработайте план распространения.",
    Statistics_RePosts_zero_action_1: "Создайте несколько материалов из 5 пунктов или в формате чек-листа.",
    Statistics_RePosts_zero_action_2: "Запустите небольшое усиление, чтобы получить первый сигнал.",
    Statistics_RePosts_zero_action_3: "Добавьте в описание чёткую причину для репоста.",
    Statistics_RePosts_zero_urgency: "Высокий",

    // statistics suggestions box

    // 4️⃣ Page -> tools
    pageTools_hashtags: "Хэштеги",
    pageTools_MyList: "Список хэштегов",
    pageTools_CreateNewListexplain: "Создайте свой # список и используйте его для создания постов",
    Analyzer: "Анализатор (AI)",
    pageTools_CreateNewList: "Создать Новый Список",
    pageTools_CustomFont: "Пользовательский шрифт",
    pageTools_CustomFontExplain: "Используйте пользовательские шрифты для своих постов в Instagram!",
    pageToolspopup_CreateNewListexplain:
      "Нажмите <Enter> или <Space>, чтобы создать новый хэштег. Щелкните по хэштегу, чтобы удалить его.",
    pageToolspopup_Listname: "Имя списка",
    pageToolspopup_hashtags: "Хэштеги",
    pageToolspopup_typehere: "Введите здесь",
    pageTools_hashtagList: "Список хэштегов",
    pageTools_CreateNewListpic: "Новый анализатор изображений",
    pageTools_CreateNewListpicexplain: "Создание хэштегов, связанных с изображением",
    pageTools_CreateNewListpage: "Новый анализатор страниц",
    pageTools_CreateNewListpageexplain: "Создание хэштегов, связанных с URL страницы Instagram",
    pageToolspopup_pageURL: "ID Instagram",
    pageToolspopup_HideLikeandViewCounts: "Скрыть количество лайков и просмотров",
    pageToolspopup_TurnoffCommenting: "Отключить комментарии",
    pageToolspopup_TurnoffCommentingExplain: "Комментирование этого Post будет отключено",
    pageToolspopup_TurnoffCommentingexplainforlottery:
      "Комментирование этого Post будет отключено во время проведения Lottery",

    pageToolspopup_TopHashtag: "Топ Хэштег",
    pageToolspopup_TopHashtagexplain: "Это сколько раз вы использовали этот хэштег на странице.",
    pageToolspopup_allRepliedcomments: "Все отвеченные комментарии",
    noresult: "Результатов нет",
    viewreplies: "Посмотреть ответы",
    allRepliedcomments: "Все отвеченные комментарии",
    Followers: "Подписчики",
    NonFollowers: "Неподписчики",
    pageToolspopup_ViewersLikes: "Просмотры и Лайки",
    supportedformat: "Поддерживаемый формат",
    limitsize: "Ограничение размера",
    TagMention: "Тег и Упоминание",
    cover: "Обложка",
    Pleaseselect: "Пожалуйста, выберите",
    replace: "Заменить",
    Album: "Альбом",
    SavedHashtagList: "Сохраненный список хэштегов",
    SavedHashtagListexplain: "Выберите хэштег для добавления в конец подписи",
    FirstComment: "Первый комментарий",
    PinFirstComment: "Закрепить первый комментарий",
    areyousure: "Вы уверены!?",
    shouldFollower: "Пользователь должен подписаться на страницу",
    draftexplain: "Вы пытаетесь сохранить как черновик",
    deletedraftexplain: "Вы пытаетесь удалить черновик",
    deleteorderexplain: "Вы пытаетесь удалить заказ",

    Addpeopleexplain: "*После добавления метки людей, настройте метку или дважды щелкните для удаления",
    AdvanceSettings: "Дополнительные настройки",
    sharepreviewtofeed: "Поделиться предпросмотром в ленте",
    Videocopyrightbypass: "Обход авторских прав на видео",
    SetScheduledPost: "Запланировать Пост",
    SetScheduledPostexplain: "Этот пост будет опубликован в указанное время",
    SetScheduledStoryexplain: "Эта история будет опубликована в указанное время",
    addtoproduct: "Добавить к Продуктам",
    addtoproductexplain: "Этот пост будет добавлен как продукт в ваш список продуктов",
    TurnoffCommentingexplain: "Комментирование этого поста будет отключено",
    RecommendedDateTime: "Рекомендуемая дата и время",
    RecommendedDateTimeexplain: "Это время основано на анализе вашей страницы",
    publish: "Опубликовать",
    pageTools_global: "Глобальный",
    pageTools_FA_AR: "Фарси / Арабский",
    pageTools_Overall: "Общий",
    pageTools_year: "Год",
    pageTools_Month: "Месяц",
    pageTools_Week: "Неделя",
    pageTools_Day: "День",
    pageTools_hashtag: "Хэштег",
    pageTools_USED: "Использовано",
    pageTools_SearchedHashtag: "Исканный хэштег",
    pageTools_TrendHashtags: "Трендовые хэштеги",
    pageTools_AutoInterAction: "Авто Взаимодействие с Подписчиками",
    pageTools_AcceptPendingRequests: "Автоматически Принимать Запросы на Подписку",
    pageTools_LikeAllNewComments: "Лайкать Новые Комментарии",
    pageTools_LikeNewFollowersPosts: "Лайкать Последние Посты Новых Подписчиков",
    pageTools_RemoveAllFollowings: "Удалить Всех Подписчиков",
    pageTools_WinnerPicker: "Лотерея (Выбор Победителя)",
    pageTools_DayEvents: "События Дня",
    pageTools_EventDateRange: "Диапазон Дат",
    pageTools_EventLanguage: "Язык",
    pageTools_EventSelectDate: "Выберите Диапазон Дат",
    pageTools_EventSearch: "Поиск Событий",
    pageTools_EventEmpty: "Событий не найдено для выбранного диапазона",
    pageTools_EventReligious: "Религиозный",
    pageTools_EventIdeas: "Идеи Событий",
    pageTools_IdeaCreate: "Генерация Идей Событий",
    pageTools_IdeaExplain: "Получайте идеи контента на основе ИИ для предстоящих событий и мероприятий",
    pageTools_CreateEventIdea: "Генерация Идей Событий",
    pageTools_CreateEventIdeaPrompt: "Тема / Запрос",
    pageTools_CreateEventIdeaPromptPlaceholder: "напр. обувь, фитнес, путешествия... (оставьте пустым для всех тем)",
    pageTools_CreateEventIdeaOptional: "необязательно",
    pageTools_CreateEventIdeaSubmit: "Сгенерировать",
    pageTools_CreateEventIdeaCancel: "Отмена",
    pageTools_EventIdeasLanguage: "Язык",
    pageTools_EventIdeasFetch: "Загрузить Идеи",
    pageTools_EventIdeasEmpty: "Идеи событий не найдены",
    pageTools_EventIdeasLoadMore: "Ещё",
    pageTools_EventIdeasIdea: "Идея",
    pageTools_EventIdeasCountry: "Страна",
    pageTools_EventIdeasPrompt: "Тема",
    pageTools_EventIdeasCreatedTime: "Дата Создания",
    pageTools_CustomEvent: "Пользовательское Событие",
    pageTools_exportcomments: "Все комментарии экспортируются в файл Excel и доступны для скачивания и обмена",

    pageTools_Lottery: "Создать Балльную Лотерею",
    pageTools_emptylotteryList: "Вы еще не создали ни одной лотереи",

    pageTools_LotteryExplain: "Основывается на баллах пользователей в посте",
    pageTools_fromFollowers: "От Подписчиков",
    pageTools_FromFollowersExplain: "Случайно из всех подписчиков",
    pageTools_Result: "Результат",
    pageTools_ResultExplain: "Статус предыдущей лотереи",
    pageTools_popup_detail: "Детали",
    pageTools_popup_history: "История",
    pageTools_LikeAllNewCommentsExplain:
      "Когда один из ваших подписчиков оставляет комментарий к любому посту, он автоматически получает лайк.",
    pageTools_AcceptType: "Тип активации",
    pageTools_popup_AlwaysActive: "Всегда активен",
    pageTools_popup_JustOnce: "Только один раз",
    pageTools_AcceptPendingRequestsexplain: "Автоматически принимать все запросы на фоллоу от пользователей.",
    pageTools_onlyprivate: "*Работает только с частными страницами.",
    pageTools_MaxLike: "Количество постов, которые будут лайкнуты",
    pageTools_Reacceptfollower: "Повторное следование после отписки",
    pageTools_Reacceptfollowerexplain:
      "Если кто-то ранее подписался, затем отписался и снова запросил подписку, система примет.",
    waitday: "Время ожидания",
    waitdayexplain:
      "Если за вами или системой будет последован человек, он будет удален после указанного времени ожидания.",
    waitdayexplain2: "Число ожидания указано в днях. Если это число равно 0, действие будет выполнено мгновенно.",
    pageTools_LikeNewFollowersPostsexplain:
      "Когда новый человек начинает вас фоллоуить, его последний пост автоматически получит лайк.",
    pageTools_RemoveAllFollowingsexplain: "Эта опция автоматически удаляет все ваши фолловинги со страницы.",
    pageTools_progress: "Этот процесс может занять до нескольких дней, в зависимости от числа ваших фолловеров.",
    pageTools_JustUnfollowwho: "Просто отписаться от тех, кто не подписался на меня в ответ",
    pageTools_AllmyFollowings: "Все мои фолловинги",
    pageTools_pageanAnalyzer: "Анализатор страницы",
    pageTools_pictureanAnalyzer: "Анализатор изображения",
    pageTools_StartAnalysis: "Начать анализ",
    pageLottery_Step: "Шаг",
    pageLottery_Specifications: "Характеристики",
    pageLottery_SelectaPost: "Выберите Публикацию",
    pageLottery_SetDateTime: "Установить дату и время",
    pageLottery_WinnersTasks: "Задачи для победителей",
    pageLottery_WinnersTasksexplain: "Задачи, которые каждый участник должен выполнить, чтобы участвовать в розыгрыше.",
    pageLottery_NumberofWinners: "Количество победителей",
    pageLottery_SetScoreForLottery: "Упомянуть Людей",
    pageLottery_SetScoreForLotteryexplain: "Пользователи должны упомянуть других, чтобы участвовать в Лотерее",

    pageLottery_MinimumMention: "Минимальное упоминание",
    pageLottery_MinimumMentionexplain: "Количество людей, которых нужно упомянуть",
    pageLottery_FollowedPage: "Следуемая страница",
    pageLottery_FollowedPageexplain:
      "Люди должны фоллоуить вашу страницу и/или выбранные вами страницы, чтобы участвовать в розыгрыше",
    pageLottery_FollowmyPage: "Фоллоу мою страницу",
    pageLottery_FollowalternativePages: "Фоллоу альтернативные страницы",
    pageLottery_Termsconditions: "Условия и положения",
    pageLottery_publishTermsconditions: "Опубликовать условия и положения",
    pageLottery_previewTermsconditionsexplain: "Эта история будет показана как история для участников.",
    pageLottery_Termsconditionsbanner: "Баннер условий и положений",
    pageLottery_Termsconditionsbannerexplain:
      "Выберите баннер для объявления условий и положений розыгрыша вашим фолловерам.",
    pageLottery_model: "Модель",
    pageLottery_Solid: "Цельный",
    pageLottery_Radial: "Радиальный",
    pageLottery_Linear: "Линейный",
    pageLottery_Background: "Фон",
    pageLottery_Color: "Цвет",
    pageLottery_Position: "Позиция",
    pageLottery_Degree: "Градус",
    pageLottery_TextBox: "Текстовое поле",
    pageLottery_Opacity: "Прозрачность",
    pageLottery_Blur: "Размытие",
    pageLottery_Font: "Шрифт",
    pageLottery_Winnerannouncement: "Объявление победителя",
    pageLottery_participants1: "🎉 из 999,999 участников 🎉",
    pageLottery_participants2: "🥳 вот счастливчики: 🥳",
    pageLottery_participantsexplain:
      "*Система автоматически регулирует количество участников и победителей, присваивая их идентификаторы после каждого символа @.",
    pageLottery_Addtocaption: "Добавить в подпись после завершения лотереи",
    pageLottery_Publishasstory: "Опубликовать список победителей как story",
    pageLottery_deleteexplain: "Это навсегда удалит лотерею, и это действие нельзя будет отменить.",
    pageLottery_Winnerpickersstatus: "Статус лотереи",
    pageLottery_scoreLotteryWinners: "Победители Лотереи",
    pageLottery_NoWinners: "Победители не найдены",
    pageLottery_RandomFollowersWinners: "Случайные победители среди подписчиков",
    pageLottery_specifickeywordexplain:
      "Пользователи должны указать определённое ключевое слово в своём Комменте, чтобы участвовать в Lottery",
    pageLottery_FollowmyPageexplain: "Пользователи должны Follow страницу, чтобы участвовать в Lottery",

    pageLottery_ShareRemainingTime: "Поделиться оставшимся временем",
    ShareTermsAndCondition: "Поделиться условиями и положениями",
    pageLottery_LotteryRemainingTime: "Оставшееся время розыгрыша",
    pageLottery_Winnerpickerisrunning: "Розыгрыш в процессе",
    pageLottery_ViewandEditDetails: "Просмотр и редактирование деталей",
    pageLottery_ActiveWinnerpickers: "Активный розыгрыш",
    pageTools_WinnerPickertooltip24hour: "Лотерея может проводиться раз в 24 часа",
    specifickeywordstooltip:
      "Система автоматически распознает эмодзи и цифры на персидском, арабском и английском языках",
    pageLottery_FilterKeywords:
      "Система случайным образом выбирает и отображает комментарии, содержащие указанное вами ключевое слово",
    pageLottery_NumberofWinnersexplain:
      "Укажите количество победителей лотереи. Максимальное количество победителей – 100",
    pageLottery_permanentlinktooltip: "Эта ссылка является постоянной, но будет удалена при проведении новой лотереи",
    pageLottery_permanentlinkexplain:
      "Вы можете поделиться этой ссылкой с пользователями для проверки честности и подлинности розыгрыша",
    pageTools_randomly: "Случайно",
    pageTools_BestEngagement: "Лучшее Взаимодействие",
    pageTools_BestEngagementexplain: "Выбрать из фолловеров, у которых было больше всего лайков и комментариев",
    // #endregion page Section
    // #region 3️⃣ Message Section
    message_youareattemptingto: "Вы пытаетесь",
    message_blockexplain:
      "Они не смогут найти ваш профиль, публикации или историю в Instagram. Instagram не сообщит им, что вы их заблокировали.",
    message_deleteexplain: "Чат будет удален навсегда, и это действие нельзя отменить.",
    message_block: "Заблокировать",
    notactivemessage: "Этот чат временно отключен. Пожалуйста, отправьте свой ответ через приложение Instagram.",
    notactivemessageexplain:
      "Обратите внимание, что если в течение 24 часов не будет отправлен ответ, чат станет недоступным. Чтобы снова активировать, вы можете либо ответить через приложение Instagram, либо подождать, пока другая сторона отправит вам новое сообщение.",
    waitingforconnection: "Ожидание подключения...",
    message_unblock: "Разблокировать",
    messagesetting_goodbye: "До свидания",
    messagesetting_welcome: "Добро пожаловать",
    messagesetting_welcomingmessage: "приветственное сообщение",
    messagesetting_Activewelcomemessageexplain:
      "Это сообщение будет отправлено в Instagram Direct как <приветственное сообщение> людям, которые вас фоловят.",
    messagesetting_Sentmessages: "Отправленное сообщение",
    message: "сообщение",
    messagesetting_Activewelcomingmessage: "Приветственное сообщение",
    receivedmessage: "Полученное сообщение",
    Messageresponse: "Ответ на сообщение",
    receivedcomment: "Полученный комментарий",
    commentresponse: "Ответ на комментарий",
    Likethereceivedcomment: "Лайкнуть полученный комментарий",
    unreadmessage: "Непрочитанные сообщения",
    specifickeywords: "Конкретные слова",
    unreadcomment: "Непрочитанные комментарии",
    hiddencommenttooltip:
      "Этот комментарий скрыт от просмотра. Только администраторы могут видеть скрытые комментарии.",
    vanishmode: "Скрытый режим",
    vanishmodeexplain:
      "В скрытом режиме сообщения, на которые не ответили и которые не были проигнорированы или скрыты, будут показаны.",
    totalcomments: "Всего Комментариев",
    unansweredcomments: "Без Ответов",
    totalcommenters: "Всего Комментаторов",
    commentmanagement: "Добро пожаловать в управление комментариями",
    ticketmanagement: "Добро пожаловать в раздел управления клиентскими тикетами",
    flowmanagement: "Создайте Flow и сделайте ответы в Instagram умными и автоматическими",

    QuickReplyexplain: "Все полученные комментарии автоматически отвечаются.",
    autocommentReply: "Автоматический Ответ на Комментарии",
    Sendresponseifthepageisfollowed: "Отправить ответ, если страница была зафолловлена",
    Likethereceivedmessage: "Лайкнуть полученное сообщение",
    messagesetting_welcometext:
      "Привет! 🌟\nДобро пожаловать в наш мир! 🎉 Мы очень рады, что вы присоединились к нашему сообществу фолловеров. Мы уверены, что вместе нас ждут удивительные моменты. 🤗\n\nМы надеемся, что содержание этой страницы будет для вас интересным и полезным, и что вы останетесь с нами. Если у вас есть вопросы или предложения, мы будем рады помочь вам. 😊\n\nСпасибо за выбор нашей страницы и за то, что вы с нами. Мы с нетерпением ждем вас в нашем удивительном мире.✨\n\nС уважением и благодарностью 💫",
    messagesetting_goodbyetext:
      "Привет! 👋\nНам жаль, что вы покинули нашу страницу. 😢 Мы ценим каждого из наших фолловеров, и ваше мнение и предложения для нас очень важны.\n\nЕсли ваше решение связано с какой-то конкретной причиной, мы будем рады, если вы поделитесь ею с нами. Мы готовы выслушать ваши мысли и предложения, чтобы улучшить наш опыт для наших фолловеров. 🫡\n\nВ любом случае, мы желаем вам всего наилучшего и надеемся, что вы снова присоединитесь к нам в будущем. 💫",
    messagesetting_ActiveFarewellmessage: "Прощальное сообщение",
    messagesetting_ActiveFarewellmessageexplain:
      "Это сообщение будет отправлено в Instagram Direct как <Прощальное сообщение> людям, которые отписались от вас.",
    messagesetting_businessmessagefilter: "Фильтр деловых сообщений",
    messagesetting_businessmessagefiltering: "Фильтрация деловых сообщений",
    messagesetting_businessmessagefilteringexplain:
      "Желаемый чат будет автоматически отправлен в раздел <Деловые сообщения> на вкладке Direct.",
    messagesetting_specificwords: "настроенные слова",
    messagesetting_autofiltering: "автоматическая фильтрация (ИИ)",
    messagesetting_specificwordsexplain: "Можно ввести несколько слов, разделите каждое слово символом <Enter>.",
    messagesetting_Createanewsupportticket: "Создать тикет поддержки",
    messagesetting_CreateanewsupportticketExplain:
      "Пользователи могут использовать эту опцию для создания тикета поддержки в своем Direct. Вы также можете ответить на него через панель Brancy или напрямую в Direct.",
    messagesetting_Changeapplicationlanguage: "Изменить язык параметров Direct",
    messagesetting_ChangeapplicationlanguageExplain:
      "При включении этой опции пользователи смогут просматривать все функции Direct на семи языках (английский, персидский, арабский, французский, русский, турецкий и немецкий). Система автоматически выполнит необходимые переводы.",
    messagesetting_ViewStoreandproducts: "Просмотр магазина и товаров",
    messagesetting_ViewStoreandproductsExplain:
      "С помощью этой опции пользователи могут просматривать ваш каталог товаров в виде списка или альбома, а также детали, такие как наличие, цена и другие характеристики.",
    messagesetting_Visityourwebsite: "Просмотр веб-сайта",
    messagesetting_VisityourwebsiteExplain:
      "Пользователи могут просмотреть адрес вашего веб-сайта и его краткое описание, а при необходимости перейти на него напрямую. (Скорость загрузки страницы будет очень высокой.)",
    messagesetting_Viewuserrolesandpermissions: "Правила и Регламенты бизнеса",
    messagesetting_ViewuserrolesandpermissionsExplain:
      "При включении этой опции пользователи смогут просматривать правила, регламенты и ограничения вашего бизнеса, заданные в настройках Brancy.",
    messagesetting_Viewbusinesshourschart: "Часы работы бизнеса",
    messagesetting_ViewbusinesshourschartExplain:
      "Пользователи могут использовать эту опцию для просмотра ваших рабочих часов. Эта функция помогает уменьшить количество сообщений, отправляемых вне рабочего времени.",
    messagesetting_Viewpricinginformation: "Цены на рекламные услуги",
    messagesetting_ViewpricinginformationExplain:
      "При включении этой опции пользователи смогут видеть актуальные цены на каждую из ваших рекламных услуг. Эта функция помогает уменьшить повторяющиеся запросы.",
    messagesetting_Searchforproducts: "Поиск товаров",
    messagesetting_SearchforproductsExplain:
      "Пользователи могут отправить название продукта, номер поста или часть подписи, чтобы получить полные сведения о товаре и, при желании, сразу совершить покупку. Эта функция положительно влияет на рост продаж.",
    messagesetting_addautomaticreplysystemsystem: "Единый системный ответ для всех разделов страницы",
    messagesetting_HideRobotReply: "Скрывать автоматические сообщения и сообщения ботов",
    messagesetting_HideRobotReplyExplain:
      "Автоматические сообщения ботов скрываются, а в Direct отображаются только реальные сообщения",
    messagesetting_LikeRobotReply: "Автоматический лайк комментариев Story",
    messagesetting_HideRobotReplytooltip:
      "Сообщения не удаляются, а только скрываются, чтобы упростить управление Direct",
    messagesetting_LikeRobotReplyExplain: "Комментарии Story автоматически получают like для повышения вовлеченности",
    messagesetting_automaticreplysystem: "Управление автоматическими ответами",
    messagesetting_automaticreplysystemforallpost:
      "Включить или отключить автоматические ответы на комментарии для всех Post",
    messagesetting_automaticreplysystemforallposttooltip:
      "Если для разных Post настроены автоматические ответы на комментарии, с помощью этой опции их можно включить или отключить сразу. Для настройки необходимо открыть страницу каждого Post отдельно",

    messagesetting_messagePanellanguage: "Язык по умолчанию для Direct",
    messagesetting_messagePanellanguageExplain: "Язык бота Direct по умолчанию для ответа на сообщения.",
    messagesetting_AutoReplyPerFollow: "Пользовательский шаблон FollowUp",
    messagesetting_AutoReplyPerFollowExplain:
      "Используйте этот шаблон, когда просите пользователя подписаться на страницу.",
    messagesetting_AutoReplyPerFollowtooltip:
      "Пользователи, которые не follow вас, сначала получат запрос на Follow. После этого им автоматически будет отправлено сообщение",
    messagesetting_AutoReplyPerFollowtitle: "Текст сообщения",
    messagesetting_AutoReplyPerFollowtitlesample: "Пример: Чтобы получить сообщение, сначала Follow нашу страницу",
    messagesetting_AutoReplyPerFollowbtn: "Текст кнопки",
    messagesetting_AutoReplyPerFollowbtnsample: "Пример: Я Follow, отправьте сообщение",
    messagesetting_automaticreplysystemexplain:
      "Система автоматически отвечает заданным текстом при получении любого сообщения или комментария в любом разделе страницы (Лента, История, Рилс, Прямой эфир и т. д.).",

    messagesetting_KeywordSensitive: "Чувствительность к слову",
    messagesetting_KeywordsSensitive: "Чувствительность к словам",
    sendreplydirectedsuccessfully: "Подтверждающее сообщение отправлено в comment после Direct",

    autoReplyFor: "Автоответ в",
    messagesetting_selectedwords: "Выбранные элементы",
    autocommentReplyExplain: "Система автоматически отвечает на полученные комментарии и сообщения.",
    selectnewmessage: "Чтобы отправить ответ, выберите сообщение.",
    sendreplyticket: "Отправить ответы",
    emptyticketdirect: "Нет тикетов от клиентов через Direct вашей страницы",
    emptysystemticket: "Нет тикетов от клиентов системы Brancy",
    emptycomment: "Пока нет комментариев для отображения",
    emptydirect: "Пока нет сообщений в Direct для отображения",

    respondToAllComments: "Ответить на Все Комментарии",
    sensitiveToSpecificKeywords: "Чувствительность к Определённым Ключевым Словам",
    sensitiveToSpecificKeywordsExplain:
      "Если эти ключевые слова встречаются в тексте комментария, система автоматически отвечает",
    contain: "Содержит ключевое слово",
    containExplain:
      "Если включено, ответ отправляется, когда ключевое слово встречается в комментарии. Если выключено, ответ отправляется, только когда весь комментарий точно совпадает с ключевым словом.",
    replyMethod: "Метод Ответа",
    respondInSameComment: "Ответить в Тот Же Комментарий",
    respondDirectly: "Ответить Через Личное Сообщение",
    ticketID: "ID Тикета",
    noNewAnsweredTickets: "У вас нет новых отвеченных тикетов",
    noNewPendingTickets: "У вас нет новых тикетов в процессе рассмотрения",
    noNewClosedTickets: "У вас нет закрытых тикетов",

    Ticketclosedby: "Тикет закрыт",
    waitingforuserresponse: "Ожидание ответа пользователя",
    automaticreply: "Автоматический ответ",
    inactiveticketexpired: "Этот тикет был деактивирован из-за отсутствия активности в течение последних 24 часов.",
    autodirectexplain:
      "Когда в Директ поступает определенное ключевое слово, ваш заранее заданный ответ будет автоматически отправлен в Директ",
    adddirectexplain: "Добавить количество автоматических ответов в Директ",
    autocommentexplain:
      "Когда в комментарий поступает конкретное ключевое слово, ваш заранее определенный ответ будет автоматически отправлен в тот же комментарий",
    addcommentexplain: "Добавить автоматические ответы на комментарии",
    messagesetting_icebreaker: "Кнопка быстрого начала чата",
    messagesetting_addNewButton: "Добавить Новую Кнопку",
    messagesetting_icebreakerexplain:
      "Когда пользователь впервые входит в Direct, отображаются четыре кнопки, и при выборе каждой отправляется соответствующий ответ.",
    messagesetting_addicebreakerexplain: "Добавьте до 4 кнопок быстрого начала чата",
    messagesetting_PersistentMenu: "Постоянное меню Дайрект",
    messagesetting_PersistentMenuexplain:
      "Меню, которое всегда доступно, делая взаимодействие клиентов с вашим брендом быстрым, удобным и без необходимости ввода текста.",
    messagesetting_addPersistentMenuexplain: "Добавьте до 3 кнопок постоянного меню",
    Welcometodirectmessages: "Добро пожаловать в прямые сообщения Instagram!",
    messagesetting_UseSystemButtonsExplain:
      "Используйте готовые системные кнопки для предоставления стандартной информации, такой как просмотр магазина, тикет поддержки и смена языка",
    messagesetting_UseAIPromptsExplain:
      "Используя AI Prompt, предоставляйте умные и персонализированные ответы пользователям в вашем собственном стиле",
    messagesetting_ButtonTitle: "Название кнопки",
    messagesetting_NoPromptsFound: "Промпты не найдены. Вы будете перенаправлены на страницу создания нового Prompt.",
    messagesetting_CreateNewPrompt: "Создать новый Prompt",
    messagesetting_SelectYourPrompt: "Выберите свой Prompt",
    messagesetting_DefineCustomResponseExplain:
      "Определите собственный текст ответа, чтобы он автоматически отправлялся пользователям",
    messagesetting_SelectPredefinedFlowExplain:
      "Выберите заранее заданный Flow, чтобы начать умный и автоматический диалог с пользователем",
    messagesetting_NoFlowsFound: "Flow не найдены. Вы будете перенаправлены на страницу создания нового Flow.",
    messagesetting_CreateNewFlow: "Создать новый Flow",
    messagesetting_SelectFlow: "Выбрать Flow",
    messagesetting_ViewFlow: "Просмотр Flow",
    messagesetting_UseGeneralAIExplain:
      "Использовать общий ИИ для свободного и неограниченного взаимодействия с пользователями",
    tool_token_usage_guide: "Примерное потребление токенов при запуске этого инструмента",
    tool_how_use: "Как использовать инструмент",
    tool_how_work: "Как работает инструмент",
    send_sms_ir_code_description: "Отправка SMS на телефон пользователя через платформу SMS.ir",
    send_sms_ir_code_completeDescription:
      "Этот инструмент используется для отправки SMS пользователям: коды подтверждения, регистрация или уведомления. Позволяет получать номера телефонов и использовать их в SMS-сервисе.",
    send_sms_ir_code_howUse: `1- Получите ApiKey в SMS.ir и введите его.
2- Укажите шаблон SMS в поле TemplateId.
3- Везде где есть {CODE}, система автоматически подставляет OTP код.
`,
    send_sms_ir_code_howWork: `1- Пользователь отправляет номер телефона в Direct.
2- Отправляется SMS. Если есть {CODE}, он заменяется OTP кодом.
3- Пользователь отправляет код AI.
4- AI проверяет код и подтверждает номер.
`,

    send_to_telegram_description: "Отправка сообщения в Telegram через бота",
    send_to_telegram_completeDescription:
      "Инструмент отправляет сообщения в Telegram через Bot Token в канал или чат. Используется для уведомлений и оповещений.",
    send_to_telegram_howUse:
      "1- Введите Token бота.\n2- Введите ID чата или канала.\n3- Запустите инструмент для отправки сообщения.",
    send_to_telegram_howWork:
      "1- Пользователь вводит Token и Channel.\n2- Система формирует запрос Telegram Bot API.\n3- Сообщение отправляется в чат или канал.",

    sender_username_description: "Использование имени пользователя отправителя в Prompt",
    sender_username_completeDescription:
      "Этот инструмент позволяет использовать имя пользователя отправителя в AI prompt. При добавлении {SENDER_USERNAME} оно заменяется автоматически.",
    sender_username_howUse:
      "1- Добавьте {SENDER_USERNAME} в prompt.\n2- Оно заменяется на имя пользователя при выполнении.",
    sender_username_howWork:
      "1- Пользователь добавляет {SENDER_USERNAME}.\n2- Система заменяет его на имя пользователя.\n3- AI генерирует ответ с этим именем.",
    // #endregion Message Section
    // #region 5️⃣market Section
    // 5️⃣ Market -> home
    filter_most_expensive: "Самые дорогие",
    filter_cheapest: "Самые дешёвые",
    filter_newest: "Новейшие",
    filter_highest_discount: "Максимальная скидка",
    filter_all_products: "Все товары",
    filter_only_available: "Только в наличии",
    filter_reset: "Сбросить",
    filter_sortby: "Сортировать по",
    filter_category: "Категория",
    filter_price: "Цена",
    Pricerange: "Диапазон цен",
    from: "От",
    to: "До",
    filter_rating: "Рейтинг",
    filter_followers: "подписчики",
    default: "По умолчанию",
    lowtohigh: "От низкого к высокому",
    hightolow: "От высокого к низкому",

    biolinkHomerating: "Оценка",
    biolinkHomefollower: "Фолловер",
    biolinkHomepost: "Пост",
    biolinkHomeAllMarkets: "Все",
    biolinkHomeAdvertise: "Рекламодатель",
    biolinkHomeStore: "Магазин",
    biolinkStatisticsAllLinkclicks: "Все клики по ссылкам",
    biolinkStatisticsMarketviews: "Просмотры рынка",
    biolinkStatisticsmostview: "самый просматриваемый",
    biolinkStatisticscouponcodeused: "использован промокод",
    biolinkStatisticslastupdate: "последнее обновление",
    biolinkStatisticsAllsearches: "Все поиски",
    biolinkStatisticsfeatures: "функции",
    biolinkStatisticsVisits: "Посещения",
    biolinkStatisticsClicksAndInteractions: "Клики и взаимодействия",
    biolinkStatisticsVisitsConverted: "Посещения, преобразованные в клики",
    biolinkStatisticsQuickUserExitAfterEntry: "Быстрый выход пользователей после входа",
    biolinkStatisticsNoInteractionExit: "Выход без взаимодействия",
    biolinkStatisticsMaxClicksPerVisit: "Максимум кликов одного пользователя за один визит",
    biolinkStatisticsAvgClicksAndInteractionsPerVisitor: "Среднее число кликов и взаимодействий на посетителя",
    biolinkStatisticsTotalVisitTime: "Общее время посещения",
    biolinkStatisticsAvgVisitTime: "Средняя длительность посещения",
    biolinkStatisticsVideoPlatformsComparison: "Сравнение видеоплатформ",
    biolinkStatisticsYoutube: "YouTube",
    biolinkStatisticsAparat: "Aparat",
    biolinkStatisticsTwitch: "Twitch",
    biolinkStatisticsPlatformEntry: "Вход на платформу",
    biolinkStatisticsRedirectEvent: "Событие перенаправления",
    biolinkStatisticsPlayVideo: "Воспроизведение видео",
    biolinkStatisticsPlayEvent: "Событие воспроизведения",
    biolinkStatisticsUniqueVisit: "Уникальный визит",
    biolinkStatisticsDedicatedLinkVisits: "Визиты по отдельной ссылке",
    biolinkStatisticsCombinedLinkVisits: "Сводный график визитов по ссылкам",
    // 5️⃣ Market -> Properties
    biolinkPropertiesfeatures: "Функции",
    biolinkPropertiesProfileInfoBanner: "Информация о профиле и баннер",
    biolinkPropertiesFeaturebox: "Блок функций",
    biolinkPropertiesTermsAndActiveTime: "Правила и часы работы",
    biolinkPropertiesFeatureboxexplain:
      "Активируя каждую функцию, вы можете отображать важную информацию для посетителей вашей страницы ссылки",
    biolinkPropertiesBanner: "Баннер",
    biolinkPropertiesFeaturesBox: "Коробка функций",
    biolinkPropertiesReviews: "Отзывы",
    biolinkPropertiesAnnouncements: "Объявления",
    biolinkPropertiesAnnouncementsexplain:
      "Вы можете написать описание в этом разделе, чтобы сообщить важную информацию посетителям вашей страницы ссылки",

    biolinkPropertiesOnlineStream: "Онлайн-Трансляция",
    biolinkPropertiesOnlineStreamexplain:
      "При включении этой опции любой запущенный вами прямой эфир будет автоматически отображаться на вашей персональной ссылке",

    biolinkPropertiesLastVideo: "Последнее Видео",
    biolinkPropertiesLastVideoexplain:
      "При включении этой опции, каждый раз когда вы публикуете новое видео на вашем канале, последнее видео будет автоматически отображаться на вашей персональной ссылке и всегда обновляться",

    biolinkPropertiesProducts: "Продукты",
    biolinkPropertiesProduct: "Продукт",
    biolinkProperties_showLast10Products: "Показать последние 10 товаров",
    biolinkProperties_showBestSellingProducts: "Показать самые продаваемые товары",
    biolinkPropertiesAdsTimeline: "Хронология Рекламы",
    biolinkPropertiesQandABox: "Ящик Вопросов и Ответов",
    biolinkPropertiesLinkShortcut: "Ярлык Ссылки",
    biolinkPropertiesContactAndMap: "Контакты и Карта",
    biolinkPropertieslinks: "Ссылки",
    clickonstreamvideo: "Нажмите на видео, чтобы посмотреть прямой эфир",
    livestarted: "Прямая Трансляция Идёт",
    live: "Прямой Эфир",
    biolinkPropertiesaddnew: "Добавить Новую Ссылку",
    biolinkProperties_DomainManager: "Управление Доменом",
    biolinkProperties_DomainManagerexplain: "Ваш персональный сайт",
    biolinkProperties_DomainManagerexplain2:
      "Вы можете разместить эту ссылку в Bio Instagram или поделиться ею с другими пользователями",

    biolinkProperties_explain: "Когда имя пользователя Instagram изменяется, эта ссылка автоматически обновляется.",
    biolinkProperties_rejected: "Ваш домен был отклонен (пожалуйста, свяжитесь с нами)",
    customDomain_inactive_title: "Пользовательский домен неактивен",
    customDomain_inactive_desc:
      "Ваш домен в настоящее время неактивен. Пожалуйста, отправьте заявку в поддержку для его активации.",
    customDomain_noPackage_title: "Пакет пользовательского домена не найден",
    customDomain_noPackage_desc:
      "Ваш текущий пакет не включает поддержку пользовательского домена. Пожалуйста, обновите пакет для использования этой функции.",
    customDomain_rule_validChars: "Разрешены только буквы и цифры",
    customDomain_rule_noUnderscore: "Символы (_) и (-) не допускаются",
    customDomain_rule_noSubdomain: "Поддомены (Subdomain) не допускаются",
    biolinkProperties_Request: "Запрос",
    biolinkProperties_Requested: "Запрошено",
    biolinkProperties_Checking: "Проверка",
    biolinkProperties_yourstore: "Магазин (ссылка на ваш магазин)",
    biolinkProperties_yourads: "Ссылка на заказ рекламы",
    biolinkProperties_yourlottery: "Проведенные вами розыгрыши",
    biolinkProperties_yourtariff: "Тариф (ваш прайс-лист)",
    biolinkProperties_yourBusinesshours: "Ваши Активные Часы Работы",
    biolinkProperties_yourBusinessTerms: "Ваши Условия Бизнеса",
    biolinkProperties_defaultAddress: "Адрес Домена по Умолчанию ",
    biolinkProperties_CustomAddress: "Ваш Пользовательский Адрес Домена",
    biolinkPropertiespopup_GeneralCustom: "Общий",
    biolinkPropertiespopup_socialmedia: "Социальные сети",
    biolinkPropertiespopup_mediastream: "Медиа и поток",
    biolinkPropertiespopup_clouddrivecontent: "Облачное хранилище",
    biolinkPropertiespopup_Finance: "Финансы",
    biolinkProperties_followersrate: "Количество подписчиков",
    biolinkProperties_followersrateExplain: "Отображает количество подписчиков вашей страницы Instagram",
    biolinkProperties_successRating: "Рейтинг успеха",
    biolinkProperties_successRatingExplain: "Отображает ваш показатель успешного выполнения заказов",
    biolinkProperties_bussinessHours: "Активные рабочие часы",
    biolinkProperties_bussinessHoursExplain: "Отображает рабочие часы вашего бизнеса",
    biolinkProperties_Enamadverified: "Проверка E-Namad",
    biolinkProperties_EnamadverifiedExplain: "Отображает статус проверки вашего значка доверия E-Namad",
    biolinkProperties_BusinessTerms: "Условия бизнеса",
    biolinkProperties_BusinessTermsExplain: "Отображает условия и правила вашего бизнеса",
    biolinkProperties_tariff: "Тариф",
    biolinkProperties_TariffExplain: "Отображает стоимость ваших услуг",
    biolinkProperties_StartADS: "Начать рекламный запрос",
    biolinkProperties_StartADSExplain: "Пользователь может начать рекламу согласно вашим тарифам",
    biolinkProperties_StartSALES: "Начать покупку",
    biolinkProperties_StartSALESExplain: "Пользователь может начать покупку на основе ваших продуктов",
    biolinkProperties_NameServers: "Серверы Имен Домена",
    biolinkProperties_NameServersExplain: "Зарегистрируйте серверы имен в панели управления вашего регистратора домена",
    customDomain_dnsError:
      "Серверы имен домена еще не зарегистрированы у вашего регистратора. Пожалуйста, попробуйте снова",
    customDomain_active_desc:
      "Чтобы изменить или удалить этот домен, отправьте запрос через раздел Тикеты поддержки в настройках",
    biolinkProperties_NameServerstooltip:
      "Обработка вашего запроса может занять до 12 часов, пока серверы имен распространятся в Интернете и ваш домен станет активным.",
    linkURL: "ссылка URL",
    searchID: "Добавить канал",
    searchIDexplain: "Введите ID пользователя или название канала",

    Browse: "Обзор",
    biolinkPropertiespopup_yourcustomIcon: "Ваш пользовательский значок",
    Boldit: "Привлеки внимание!",

    Scheduletime: "Автоматическое удаление по расписанию",
    biolinkPropertiespopup_ProfileInfo: "Информация профиля",
    biolinkPropertiespopup_Banner: "Баннер",
    biolinkPropertiespopup_Personal: "Личное",
    biolinkPropertiespopup_SameasInstagramProfile: "Как в профиле Instagram",
    marketpropertise_aboutus: "Этот сайт создан с помощью платформы Brancy",
    marketpropertise_copyright: "Все права на этот сайт принадлежат",
    marketpropertise_aboutusslogan:
      "Brancy — лучший выбор для создания умной Biolink и управления страницей в Instagram",
    marketpropertise_madeby: "Создано с 🤍 от",

    custom: "Пользовательский",
    advertiseProperties_biography: "Биография",
    uploadbannerexplain: "Загрузка нескольких изображений может повлиять на скорость загрузки.",
    Embed: "Встроить видео",
    Embedexplain:
      "При включении этой опции видео будет отображаться и воспроизводиться напрямую на вашей персональной ссылке, и пользователи смогут смотреть его, не покидая страницу и не переходя на другую платформу",

    notfound: "не найдено",
    showsavecontactbutton: "Показать кнопку сохранения контакта",
    Map: "Карта",
    Contact: "Контакт",
    Showmap: "Показать карту",
    location: "Местоположение",
    phone: "Телефон",
    invalidphone: "Неверный телефон",
    email: "Электронная почта",
    invalidemail: "Неверная электронная почта",
    Address: "Адрес",
    // #endregion market Section
    // #region 6️⃣advertise Section
    advertise_ADDetail: "Детали рекламы",
    content: "содержание",
    advertise_orderdate: "дата заказа",
    advertise_duration: "продолжительность",
    Remaining: "Осталось",
    ago: "назад",
    // advertise -> calendar
    advertisecalendar_calendar: "Календарь",
    advertisecalendar_nextday: "Следующие объявления на этот день",
    advertisecalendar_TODAY: "Сегодня",
    advertisecalendar_BookaTime: "Забронировать время",
    advertisecalendar_TIMELINEZOOM: "Масштабирование временной шкалы",
    advertisecalendar_Timeline: "Хронология",
    // advertise -> statistics
    advertisestatistics_lasttwomonth: "Последние два месяца",
    advertisestatistics_lastmonth: "Прошлый месяц",
    advertisestatistics_thismonth: "Этот месяц",
    advertisestatistics_ads: "Реклама",
    advertisestatistics_fromlast: "% С прошлого месяца",
    advertisestatistics_totalADSstatistics: "Общая Статистика Реклам",
    advertisestatistics_TotalAds: "Всего Реклам",
    advertisestatistics_TotalIncome: "Общий Доход",
    advertisestatistics_totaladsreport: "Общий Отчет По Рекламе",
    advertisestatistics_adno: "Номер Рекламы",
    advertisestatistics_advertiser: "Рекламодатель",
    advertisestatistics_type: "Тип",
    advertisestatistics_status: "Статус",
    advertisestatistics_price: "Цена",
    advertisestatistics_date: "Дата",
    advertisestatistics_share: "Поделиться",
    // advertise -> adlist
    advertiseadlist_activeAd: "Опубликованных Реклам",
    advertiseadlist_AwaitingApproval: "Реклам в Ожидании Одобрения",
    advertiseadlist_AwaitingPublication: "Запланированных Реклам",
    advertiseadlist_rejectedlist: "Отклоненных Реклам",
    // advertise -> Properties
    advertiseProperties_Concurrentads: "Одновременные Рекламы",
    advertiseProperties_Concurrentadsexplain: "Количество активных реклам в данное время",
    advertiseProperties_numberofads: "Количество Рекламных Страниц",
    advertiseProperties_numberofadsexplain: "Количество активных реклам в течение дня",
    advertiseProperties_campaign: "Кампания",
    advertiseProperties_campaignexplain: "Возможность участвовать в рекламных кампаниях через Brancy",
    advertiseProperties_adsoptions: "Опции Рекламы",
    advertiseProperties_rejectreasonheader1: "Причина 1 (Несоответствующий контент)",
    advertiseProperties_rejectreasonheader2: "Причина 2 (Нездоровый контент)",
    advertiseProperties_rejectreasonheader3: "Причина 3 (Нарушение политики)",
    advertiseProperties_rejectreasonheader4: "Причина 4 (Отрицательная обратная связь)",
    advertiseProperties_rejectreason1:
      "К сожалению, предоставленный контент не соответствует ценностям и целям нашей страницы, не является актуальным для нашей широкой аудитории или не содержит необходимой информации. Поэтому мы не можем принять эту рекламу.",
    advertiseProperties_rejectreason2:
      "К сожалению, предоставленный контент может быть нездоровым, вводящим в заблуждение или содержать сложную информацию для нашей аудитории. Требуются значительные изменения, поэтому мы не можем принять эту рекламу.",
    advertiseProperties_rejectreason3:
      "К сожалению, предоставленный контент не соответствует нашим правилам или правилам Instagram и может быть сочтен неразумным, оскорбительным, спорным или криминальным. Поэтому мы не можем принять эту рекламу.",
    advertiseProperties_rejectreason4:
      "К сожалению, из-за большого объема аналогичных объявлений, конфликтов расписания, негативных отзывов пользователей о предыдущем опыте или низкого качества предоставленного контента, мы не можем принять эту рекламу.",
    advertiseProperties_AdvertisingTerms: "Условия рекламы",
    advertiseProperties_AdvertisingTermsexplain:
      "Рекламодатели должны принять эти правила, чтобы размещать рекламу на вашей странице.",
    advertiseProperties_AdvertisingTerm1: "Условие вашей страницы 1",
    advertiseProperties_AdvertisingTerm2: "Условие вашей страницы 2",
    advertiseProperties_AdvertisingTerm3: "Условие вашей страницы 3",
    advertiseProperties_AdvertisingTerm4: "Условие вашей страницы 4",
    advertiseProperties_AdvertisingTermsave: "Сохранить",
    advertiseProperties_businesshours: "Часы работы администратора",
    advertiseProperties_24hours: "24 часа активно",
    advertiseProperties_close: "24 часа неактивно",
    advertiseProperties_notifications: "Уведомления",
    advertiseProperties_notificationsSMS: "СМС",
    advertiseProperties_notificationsEmail: "Электронная почта",
    advertiseProperties_notificationssystem: "Системное уведомление",
    advertiseProperties_notificationsinstagramdirect: "Instagram Direct",
    advertiseProperties_notificationssystemticket: "Тикет",
    advertiseProperties_advertisetariff: "Тариф на рекламу",
    advertiseProperties_onlyToday: "Только на сегодня",
    advertiseProperties_onlyTodayexplain: "Тариф на рекламу только на сегодня",
    advertiseProperties_tariff12hours: "12 часов",
    advertiseProperties_tariff24hours: "24 часа",
    advertiseProperties_otherdays: "Основной (другие дни)",
    advertiseProperties_otherdaysexplain: "Тариф на рекламу на другие дни",
    advertiseProperties_Campaign: "Кампания",
    advertiseProperties_Campaignexplain: "Тариф на рекламу для кампании",
    advertiseProperties_lastModified: "Последнее изменение",
    advertiseProperties_userreport: "Отчет пользователя",
    advertiseProperties_userID: "ID пользователя",
    advertiseProperties_reportexplain: "Ваш отчет будет отправлен в поддержку Brancy.",
    advertiseProperties_reportsubmit: "Отправить",
    Apply: "Применить",
    signinyouradvertise: "Активировать Рекламу",
    signinyouradvertiseExplain: "Активируйте свою рекламу всего за несколько кликов",

    // #endregion advetise Section
    // #region 7️⃣Store Section
    // Store -> product
    Storeproduct_activatestore: "Активировать магазин",
    signinyourstore: "Создайте свой магазин",
    signinyourstoreExplain: "Создайте магазин всего за несколько кликов",

    Storeproduct_needyourID: "Подтверждение личности",
    Storeproduct_needyourIDExplain: "Загрузите удостоверение личности",
    Storeproduct_successyourID: "Ваша личность успешно подтверждена",
    Storeproduct_NationalCardexplain:
      "Эта карта должна принадлежать человеку, который зарегистрировался со своим мобильным номером в Brancy.",
    Storeproduct_addcreditnumber: "Финансовая информация",
    Storeproduct_addcreditnumberExplain: "Введите свою банковскую карту",
    Storeproduct_successnumber: "Ваша банковская информация успешно подтверждена",
    Storeproduct_shippingmethod: "Способ доставки",
    Storeproduct_shippingmethodExplain: "Выберите предпочтительный способ доставки",
    Storeproduct_shippingmethodsuccess: "Выбранный способ доставки успешно зарегистрирован",
    Storeproduct_shippingmethodtooltip:
      "Рекомендуемые методы выбраны на основе вашего местоположения. Вы можете изменить их позже в настройках магазина.",
    Storeproduct_uploadimagefirst: "Сначала загрузите фото вашего национального удостоверения личности",
    Storeproduct_creditcardsameidcard: "Номер банковской карты должен принадлежать владельцу удостоверения личности",
    Storeproduct_postalcode: "Адрес бизнеса",
    Storeproduct_postalcodeExplain: "Введите почтовый индекс",
    Storeproduct_postalcodesuccess: "Адрес и местоположение успешно зарегистрированы",
    Storeproduct_postalcodeinputExplain:
      "Стоимость доставки рассчитывается на основе этого адреса, пожалуйста, введите почтовый индекс точно.",
    Storeproduct_TermsAndCondition: "Условия и положения",
    Storeproduct_TermsAndConditionExplain: "Прочтите и примите условия",
    Storeproduct_TermsAndConditionesuccess: "Принятие условий успешно зарегистрировано",
    Storeproduct_AcceptTermsAndCondition:
      "Я прочитал(а) и принимаю все правила и положения, касающиеся создания магазина в Brancy.",
    Storeproduct_notyet: "Вы еще не добавили ни одного товара!",
    Storeproduct_addnow: "ДОБАВЬТЕ ТОВАРЫ СЕЙЧАС",
    Storeproduct_addexplain: "Они будут автоматически добавлены с вашей страницы Instagram.",
    Storeproduct_productlist: "Список продуктов",
    Storeproduct_search: "Поиск 'Название продукта' или 'PID'",
    Storeproduct_importproduct: "Импортировать продукт",
    Storeproduct_importfrominsta: "Импортировать из вашего Instagram",
    Storeproduct_newproduct: "Новый продукт",
    Storeproduct_addnewproduct: "Добавить новый продукт",
    Storeproduct_name: "Имя продукта",
    Storeproduct_weight: "Вес",
    Storeproduct_size: "Размер",
    Storeproduct_color: "Цвет",
    Storeproduct_stock: "Запас",
    Storeproduct_price: "Цена",
    Storeproduct_active: "Активный",
    Storeproduct_gram: "Грамм",
    bulkProduct: {
      title: "Управление выбранными товарами",
      selectedCount: "Выбрано товаров: {{count}}",
      priceChange: "Изменить цену",
      valueType: "Тип значения",
      amount: "Сумма",
      increase: "Увеличить",
      decrease: "Уменьшить",
      applyAll: "Применить одно изменение ко всем",
      applyIndividual: "Настроить каждый товар отдельно",
      allProducts: "Применить ко всем товарам: {{count}}",
      discountAllHint: "Укажите процент или фиксированную сумму скидки для всех выбранных товаров.",
      priceAllHint: "Увеличьте или уменьшите все цены на процент или фиксированную сумму.",
      currentDiscount: "Текущая скидка",
      saving: "Сохранение...",
    },
    loadingmoreproducts: "Загрузка дополнительных продуктов...",
    noMoreProducts: "Больше продуктов не найдено",
    storestatistics_lasttwomonth: "Последние Два Месяца",
    storestatistics_lastmonth: "Прошлый Месяц",
    storestatistics_thismonth: "Этот Месяц",
    storestatistics_sales: "Продажи",
    storestatistics_fromlast: "% по сравнению с прошлым месяцем",
    storestatistics_totalSalesstatistics: "Общая Статистика Продаж",
    storestatistics_TotalSales: "Общие Продажи",
    storestatistics_TotalIncome: "Общий Доход",
    storestatistics_totalsalesreport: "Лучшие Покупатели",
    storestatistics_buyer: "Информация о Покупателе",
    storestatistics_totalPurchases: "Общее Количество Покупок",
    storestatistics_totalAmount: "Общая Сумма Покупок",
    storestatistics_lastPurchase: "Дата Последней Покупки",
    storestatistics_saleno: "Номер Продажи",
    storestatistics_seller: "Продавец",
    storestatistics_type: "Тип",
    storestatistics_status: "Статус",
    storestatistics_price: "Цена",
    storestatistics_date: "Дата",
    storestatistics_share: "Поделиться",
    storestatistics_couponTitle: "Скидки",
    storestatistics_addCoupon: "Добавить промокод",
    storestatistics_noCoupons: "Промокоды пока не созданы.",
    storestatistics_couponCode: "Промокод",
    storestatistics_discountPercent: "Процент скидки",
    storestatistics_maxUses: "Максимальное число использований",
    storestatistics_phoneNumber: "Номер телефона",
    storestatistics_maxDiscountOptional: "Максимальная скидка (необязательно)",
    storestatistics_couponExpiry: "Время окончания (должно быть не менее чем через 1 час)",
    storestatistics_showInBio: "Показывать в профиле",
    storestatistics_couponDeleted: "Удален",
    storestatistics_couponExpired: "Истек",
    storestatistics_couponExhausted: "Использован полностью",
    storestatistics_couponActive: "Активен",
    storestatistics_unlimited: "Без ограничений",
    storestatistics_couponUsage: "Использовано {{used}} из {{max}}",
    storestatistics_discountValue: "Скидка {{discount}}%",
    storestatistics_maxDiscountValue: "Максимум: {{value}}",
    storestatistics_expiryValue: "Истекает: {{date}}",
    storestatistics_private: "Частный",
    storestatistics_public: "Публичный",
    // Store -> order
    incartcount: "В корзине",
    addtocart: "Добавить в корзину",
    AllProducts: "Все продукты",
    Storeproduct_inQueue: "Ожидает Одобрения",
    Storeproduct_inprogress: "В Процессе",
    Storeproduct_pickingup: "Сбор",
    Storeproduct_sent: "Отправлено",
    Storeproduct_delivered: "Доставлено",
    Storeproduct_failed: "Неудача",
    Storeproduct_canceledbyuser: "Отменено покупателем",
    Storeproduct_canceledbyadmin: "Отменено администратором",

    Storeproduct_returned: "Возвращено",
    Storeproduct_yourcartisempty: "Ваша корзина пуста",
    Storeproduct_noitemfounded: "Товары не найдены",
    Storeproduct_incart: "В Корзине",
    ShowUnprocessedItemsOnly: "Непереработанные предметы",
    pageStatistics_fromstore: "Из магазина",
    ordernumber: "Номер заказа",
    order_addressSubject: "Дом, Работа",
    order_addressReceiver: "Имя получателя по этому адресу",
    order_addressNote: "Примечание к адресу",

    Storeorder_all: "Все",
    Storeorder_ORDERID: "ID Заказа",
    Storeorder_CUSTOMER: "Клиент",
    Storeorder_ITEMS: "Позиции",
    Storeorder_ITEM: "Товар",
    Storeorder_PRICE: "Цена",
    Storeorder_OrderDATE: "Дата Заказа",
    copytrackingcode: "Копировать код отслеживания",
    Storeorder_SentDATE: "Дата Отправки",
    Storeorder_deliverdate: "Дата Доставки",
    Storeorder_DELIVERY: "Отправлено через",
    Storeorder_bymyself: "Отправлено мной",
    Storeorder_Envelope: "Конверт",
    Storeorder_Invoice: "Счёт-фактура",

    Storeorder_DeliveryAmount: "Стоимость доставки",
    Storeorder_InsuranceAmount: "Стоимость страховки",
    Storeorder_Coupon: "Промокод",
    Storeorder_RemoveCoupon: "Удалить промокод",
    Storeorder_Productsinyourshoppingcart: "Товары в вашей корзине",
    Storeorder_SendtotheAddress: "Отправить по адресу",
    Storeorder_changeofaddress: "Изменение адреса",

    Storeorder_postparselbox: "Почтовая коробка",
    Storeorder_pocketenveloptitle: "Количество товаров в одном конверте",
    Storeorder_pocketenveloptitleExplain:
      "Пожалуйста, укажите, сколько единиц этого товара помещается в стандартный конверт (или вашу обычную упаковку). Это поможет нам точнее рассчитать склад, упаковку и доставку.",
    Storeorder_Destination: "Место назначения",
    Storeorder_STATUS: "Статус",
    Storeorder_DETAILS: "Подробности",
    Storeorder_PickupRequest: "Запрос на забор",
    Storeorder_PrintWaybill: "Печать накладной",
    Storeorder_Waybill: "Накладная",
    Storeorder_WaybillExplain:
      "Пожалуйста, распечатайте накладную и прикрепите её к упаковке чётко, ровно и надёжно перед подачей запроса на забор.",
    Storeorder_noneSendExplain:
      "Поскольку эту посылку нельзя было отправить через систему доставки Brancy, и вы отправили её лично под свою ответственность, необходимо подтвердить этот этап.  После подтверждения покупатель будет уведомлён, что посылка отправлена.",
    Storeorder_ManualTrackingExplain:
      "Поскольку вы передали посылку напрямую перевозчику, пожалуйста, после получения кода отслеживания введите его в соответствующее поле и подтвердите этот этап.  Таким образом, Brancy автоматически уведомит покупателя о коде отслеживания и информации об отправке.",
    Storeorder_SendExplain: "Информация в этом разделе будет обновляться автоматически",

    Storeorder_requestedpickup: "Ожидает забора",
    Storeorder_TrackingCode: "Код отслеживания",
    Storeorder_PostMan: "Почтальон",
    Storeorder_from: "Отправлено из",
    Storeorder_currentLocation: "Текущее местоположение",
    Storeorder_lastUpdateTime: "Последнее обновление",
    Storeorder_sender: "Отправитель",

    Storeorder_IssuingTrackingCode: "Выдача кода отслеживания",
    Storeorder_orderDetailsStep: "Информация о заказе",
    Storeorder_orderconfirmStep: "Размер посылки и накладная",
    Storeorder_orderlist: "Список заказов",
    Storeorder_singleorder: "Заказ",
    Storeorder_quantityorder: "Количество",
    Showmore: "Показать больше",
    totalprice: "Общая цена",
    note: "Примечание",
    navbar_PaymentNumber: "Код отслеживания платежа",
    Storeorder_receiver: "Получатель",
    Storeorder_AcceptthisOrder: "Подтвердить этот заказ",
    Storeorder_ParselisConfirmed: "Я подтверждаю, что введенные данные верны",
    Storeorder_ParselisConfirmedExplain:
      "Ошибка в указании размера или веса может привести к штрафу и возврату посылки",
    Storeorder_CancelOrder: "Отменить заказ",
    Storeorder_nextWaybill: "Продолжить (получить накладную)",
    Storeorder_Pickedup: "Забрано",
    SelectProduct: "Выбрать продукт",
    SelectedPosts: "Выбранные посты:",
    product_BasicDetail: "Основные данные",
    BacktoProductList: "Вернуться к списку продуктов",
    Backtocart: "Вернуться в корзину",
    product_ProductID: "ID продукта",
    product_Producttitle: "Название продукта",
    product_Product: "Продукты",
    product_Categories: "Категории",
    product_MainCategory: "Основная категория",
    product_Subcategory: "Подкатегория",
    product_Subset: "Подмножество",
    product_Group: "Группа",
    product_Branch: "Отделение",
    product_Subbranch: "Подотделение",
    product_Dependency: "Зависимость",
    product_Brand: "Бренд",
    product_instagramcaption: "Подпись в Instagram",
    product_productDescription: "Описание продукта",
    product_Informationplaceholder:
      "В этом разделе вы можете написать описание продукта.\n\n Это описание может включать полную и привлекательную информацию, такую как\n характеристики, преимущества, ключевые детали о продукте или способы его использования, ингредиенты\n кратко и эффективно.\n\n Клиенты лучше познакомятся с характеристиками продукта, и шансы на продажу продукта возрастут.",
    product_General: "Общее",
    product_Specifications: "Спецификации",
    product_Information: "Информация",
    product_addNewTable: "Добавить новую таблицу",
    product_EditTable: "Редактировать таблицу",
    product_PreviewTable: "Таблица",
    product_addtable: "Создать таблицу",
    product_tabletitle: "Заголовок таблицы (необязательно)",
    product_tabletitleExplain: "Например: Таблица размеров",
    product_tableheaderoption: "Первая строка как заголовок",
    product_AddColumn: "Добавить столбец рядом",
    product_DeleteColumn: "Удалить этот столбец",
    product_AddRow: "Добавить строку ниже",
    product_DeleteRow: "Удалить эту строку",
    rowheader: "Заголовок",
    cell: "Ячейка",
    product_Media: "Медиа",
    Nodescriptionavailable: "Нет доступного описания",
    NoSpecificationsavailable: "Нет доступного описания",
    product_Properties: "Свойства",
    product_Setting: "Настройка",
    product_productdeleted: "продукт удален",
    product_SetProperties: "Установить свойства",
    product_SetPropertiesexplain: "Вы можете выбрать 1-3 свойства, одно из которых может быть настроено",
    product_AddNewproperty: "Добавить новое свойство",
    product_Nopropertyisset: "Свойство не установлено",
    product_Variation: "Вариация",
    product_Discount: "Скидка",
    product_PricewithDiscount: "Цена со скидкой",
    product_AddNewVariation: "Добавить новую вариацию",
    product_Definenew: "Определить новое (пользовательское)",
    product_systemlist: "Умный список по умолчанию",
    product_itemlist: "Список элементов",
    product_Available: "Доступно",
    product_supplying: "В Поставке",
    product_OutOfStock: "Нет в Наличии",
    product_Stoppedsale: "Продажа Остановлена",
    product_draft: "черновик",
    product_Amount: "Количество",
    product_NUMBEROFUSES: "Количество использований",
    product_UNLIMITED: "Неограничено",
    product_LIMITED: "Ограничено",
    product_USINGTIMES: "Продолжительность использования",
    product_UNLIMITEDTIME: "Неограниченное время",
    permanent: "Постоянный",
    product_LIMITEDTIME: "Ограниченное время",
    product_mediatitle: "Управление изображениями и видео продукта",
    product_clicktoupload: "Нажмите, чтобы загрузить",
    product_SuggestedImages: "Рекомендуемые изображения",
    product_SuggestedImagesExplain:
      "Улучшите галерею вашего продукта, используя рекомендуемые изображения, или загрузите свои собственные",
    product_ordragdrop: "или перетащите",
    product_productspecifications: "характеристики продукта",
    product_choosesystemlist: "выберите из списка систем",
    product_choosesystemlistexplain: "Ищите и выбирайте любые необходимые спецификации",
    product_Definenewexplain: "Если вы не можете найти спецификации, создайте их",
    product_importbatch: "импорт партии",
    product_importbatchexplain: "Добавьте все спецификации из предыдущего продукта",
    Value: "Значение",
    Undefined: "Неопределено",
    product_original: "Оригинал",
    product_HighCopy: "Высокая Копия",
    product_notoriginal: "Не оригинал",
    product_Corporate: "Корпоративный",
    product_Miscellaneous: "Разное",
    product_fake: "Подделка",
    tomorrow: "Завтра",
    NotSet: "Не установлено",
    Yes: "Да",
    No: "Нет",
    "Video generation request sent.": "Запрос на создание видео отправлен.",
    "Image generation request sent.": "Запрос на создание изображения отправлен.",
    ", Image generation failed.": ", не удалось создать изображение.",
    "Create and manage AI-generated images and videos.":
      "Создавайте и управляйте изображениями и видео, созданными ИИ.",
    Storeproduct_OutOfStandardSize: "Вне стандартного размера",
    product_box: "Размер коробки",
    Product_Availablity: "Наличие",
    Product_maxincart: "Максимум в корзине",
    Product_originality: "Оригинальность",
    Product_preperingforship: "Подготовка к отправке",
    Product_Evat: "НДС",
    Product_Evatcount: "Значение НДС",
    Product_Guarantee: "Гарантия",
    Product_Guaranteelength: "Срок гарантии",
    Product_packageshipping: "Упаковка и доставка",
    Product_packageshippingexplain:
      "Отключив эту опцию, вы будете нести ответственность за доставку товаров и связанные с этим услуги",
    Product_titleExplain:
      "Предложенные заголовки основаны на характеристиках вашего товара и средних названиях на рынке, чтобы увеличить его видимость в поиске и среди похожих товаров.\n (Эти заголовки могут содержать ошибки)",
    Product_Breakable: "Хрупкий",
    Product_Luquid: "Жидкий",
    Product_sack: "Мешок / Сумка",
    Product_sackExplain:
      "Если ваш товар отправляется в мешке, сумке или другом мягком гибком пакете, выберите этот вариант. Это поможет нам лучше организовать размещение, транспортировку и упаковку.",
    Product_Productweights: "Вес продукта",
    Product_Productweightsexplian: "Чистый вес продукта без упаковки",
    Product_packaging: "Упаковка",
    Product_packagingexplian:
      "Вес упаковки продукта без внутреннего содержимого, включая картон для упаковки, скотч и транспортную накладную, рассчитывается системой",
    Product_shippingSize: "Размеры для доставки",
    product_SuggestedPrice: "Анализ цен на этот продукт на всем рынке",
    product_MinimumPrice: "Минимальная цена",
    product_AveragePrice: "Средняя цена",
    product_MaximumPrice: "Максимальная цена",
    length: "Длина",
    width: "Ширина",
    height: "Высота",
    Weight: "Вес",
    finalWeight: "Окончательный вес",
    product_deleteproductexplain: "Вы пытаетесь удалить этот продукт.",
    // #endregion Store Section
    // #region 8️⃣Setting Section
    // Setting -> General -> System
    SettingGeneralSystemTitle: "Система",
    SettingGeneralSystemlanguage: "Язык",
    SettingGeneralSystemcalendar: "Календарь",
    SettingGeneralSystemGregorian: "Григорианский",
    SettingGeneralSystemshamsi: "Шамси",
    SettingGeneralSystemHijri: "Хиджри",
    SettingGeneralSystemHindi: "Хинди",
    SettingGeneralSystemStartWeek: "Начало недели",
    SettingGeneralSystemsaturday: "Суббота",
    SettingGeneralSystemmonday: "Понедельник",
    SettingGeneralSystemtuesday: "Вторник",
    SettingGeneralSystemwednesday: " Среда",
    SettingGeneralSystemthursday: " Четверг",
    SettingGeneralSystemfriday: "Пятница",
    SettingGeneralSystemsunday: "Воскресенье",
    SettingGeneralSystemtheme: "Тема",
    SettingGeneralSystemDarkmode: "Темный режим",
    SettingGeneralSystemlightmode: "Светлый режим",
    SettingGeneralSystemPrice: "Ценовая модель",
    SettingGeneralSystemDollar: "Доллар",
    SettingGeneralSystemeuro: "Евро",
    SettingGeneralSystempound: "Фунт",
    SettingGeneralSystemrial: "Риал",
    SettingGeneralSystemtoman: "Томан",
    SettingGeneralAiModelsTitle: "Модели ИИ",
    SettingGeneralAiModelsTextModels: "Текстовые модели",
    SettingGeneralAiModelsVoiceModels: "Модели голос в текст",
    SettingGeneralAiModelsDirectVoiceSupport: "Прямая голосовая поддержка",
    // Setting -> General -> Profile
    SettingGeneralProfileTitle: "Профиль",
    SettingGeneral_activedevice: "Активные устройства",
    SettingGeneral_leatestentery: "История активности пользователя",
    SettingGeneral_cantdeletesession: "Сеансы, созданные менее 24 часов назад, не могут быть удалены.",
    SettingGeneral_deletesession: "Вы пытаетесь удалить этот сеанс.",
    SettingGeneral_addSubAdmin: "Добавить суб-администратора",
    SettingGeneral_addSubAdminExplain: "Добавить суб-админа с ограниченным доступом",
    SettingGeneral_addSubAdminExplain2:
      "Пригласите Админа с Ограниченным и Безопасным Доступом, без входа в Instagram.",

    SettingGeneral_addSubAdmintitleExplain:
      "Введите номер нового администратора, чтобы отправить приглашение. После подтверждения доступ будет активирован.",
    SettingGeneral_accesslevel: "Уровень доступа",
    SettingGeneral_access: "Доступ",
    SettingGeneral_partnertitle: "Название Админа-Сотрудника",
    SettingGeneral_partnernumberexplain:
      "Приглашение будет отправлено на этот номер, и админ-сотрудник должен подтвердить его в своей панели (админ должен зарегистрироваться в Brancy, чтобы принять приглашение).",
    SettingGeneral_contentTooltip: "Публикации, истории, Reels, IGTV и карусели.",
    SettingGeneral_publishTooltip:
      "Создавать публикации и истории, а также создавать контент. Требуется доступ к контенту.",
    SettingGeneral_automaticsTooltip:
      "ИИ, сценарии, автоматизированные процессы и задачи. Требуется доступ к контенту.",
    SettingGeneral_messageTooltip: "Директ Instagram, внутренние сообщения и связанные инструменты.",
    SettingGeneral_commentTooltip: "Комментарии, ответы и связанные инструменты.",
    SettingGeneral_transactionTooltip:
      "Управление платёжным аккаунтом, транзакциями, кошельком и связанные инструменты.",
    SettingGeneral_adsTooltip:
      "Управление календарём, рекламодателями, одобрением рекламы, ценами и связанные инструменты.",
    SettingGeneral_ordersTooltip: "Товары, цены, складские запасы, заказы, накладные и связанные инструменты.",
    SettingGeneral_bioTooltip: "Содержимое и оформление био, ссылки и ярлыки стороннего контента.",
    SettingGeneral_ticketTooltip: "CRM, системные тикеты и поддержка.",
    SettingGeneral_productsTooltip: "Инструменты управления товарами.",

    // Setting -> General -> support
    SettingGeneral_GeneralSupport: "Общая Поддержка",
    SettingGeneral_Customerservices: "Обслуживание Клиентов",
    SettingGeneral_ReportBug: "Сообщить об Ошибке",
    SettingGeneral_Advertise: "Реклама",
    SettingGeneral_Store: "Магазин",
    SettingGeneral_biolink: "Ссылка в био",
    SettingGeneral_Walletandfinance: "Кошелек и Финансы",
    SettingGeneral_MessageingandComment: "Сообщения и Комментарии",
    SettingGeneral_Support: "Поддержка",
    SettingGeneral_Department: "Отдел",
    SettingGeneral_Title: "Название",
    SettingGeneral_Description: "Описание",
    SettingGeneral_Send: "Отправить",
    // #endregion Setting Section
    userpanel_market: "Рынок",
    userpanel_order: "Заказ",
    userpanel_Messages: "Сообщения",
    userpanel_Settings: "Настройки",
    userpanel_PersonalInfo: "Личная информация",
    userpanel_UploadNewPicture: "Загрузить новое изображение",
    userpanel_Instagramid: "ID Instagram",
    userpanel_Nameandfamily: "Имя и фамилия",
    userpanel_NationalCode: "Национальный код",
    userpanel_BirthDay: "Дата рождения",
    userpanel_MobileNumber: "Номер мобильного телефона",
    userpanel_Email: "Электронная почта",
    userpanel_CreditNumber: "Кредитный номер",
    userpanel_Addresses: "Адреса",
    userpanel_AddNewAddress: "Добавить новый адрес",
    userpanel_ZipCode: "Почтовый индекс",
    userpanel_Address: "Адрес",
    userpanel_EditAddress: "Редактировать адрес",
    userpanel_AddNewAddressexplain: "Ваш пакет будет доставлен по этому адресу и человеку",
    startbusiness: "Создать бизнес",
    AI: "ИИ",
    ExtraTokens: "Доп. токены",
    TokenUsage: "Использование токенов",
    AdvancedAnalytics: "Расширенная аналитика",
    AIResponse: "AI-ответы в Instagram",
    CustomSupport: "Индив. поддержка",
    CustomDomain: "Индивидуальный домен",
    WinnerPicker: "Выбор победителя",
    WinnerPickerReserve: "Резервный розыгрыш",

    dataTable1_feature1: "Управление Post и профессиональная аналитика",
    dataTable1_tooltip1:
      "Простое планирование публикаций. Подробная аналитика для каждого Post: (Лайк, Поделиться, Коммент, Сохранить, Уровень вовлеченности, Охват, Показ, Просмотры, Удержание, Follow/Unfollow, Активность профиля, Используемые Хэштеги), и многое другое...",

    dataTable1_feature2: "Создать новый Post",
    dataTable1_tooltip2:
      "Предложение лучшего времени и даты на основе вашей страницы. Планирование Post. Сохранение хэштегов для повторного использования. Автоответы на Comments. Сохранение черновиков и др.",

    dataTable1_feature3: "Управление Story и точная аналитика",
    dataTable1_tooltip3:
      "Планирование Story. Полная графическая аналитика для каждого Story: (Лайк, Поделиться, Коммент, Сохранить, Вовлеченность, Охват, Показ, Просмотры, Удержание, Follow/Unfollow, Активность профиля, Direct, Скриншоты) и др.",

    dataTable1_feature4: "Создать новый Story",
    dataTable1_tooltip4:
      "Предложение лучшего времени. Планирование Story. Автоответы на Comments. Сохранение как черновик и др.",

    dataTable1_feature5: "Общая статистика страницы",
    dataTable1_tooltip5:
      "Количество Posts и Stories. Сортировка по просмотрам, Comments и лайкам. Лучшее и худшее время для публикации (с графиком). История лайков, Follow/Unfollow, просмотров, Comments, призрачные посетители. Лучшие Followers. Сравнение со старыми данными и многое другое.",

    dataTable1_feature6: "Управление хэштегами",
    dataTable1_tooltip6:
      "Создание неограниченных списков. Умная генерация по изображениям и странице (ИИ). Просмотр использованных хэштегов. Трендовые хэштеги (по дню, неделе, месяцу, языку: английский, персидский, арабский и др.) и т.д.",

    dataTable1_feature7: "Авто-лайк новых Comments",
    dataTable1_tooltip7:
      "Автоматически ставить лайк новым Comments от Followers. Просмотр истории в графиках и списках.",

    dataTable1_feature8: "Случайная лотерея среди Followers",
    dataTable1_tooltip8:
      "Выбор лучших Followers по лайкам и Comments. Случайный выбор победителей. Публикация Story результатов. Отслеживание по коду и др.",

    dataTable1_feature9: "Бальная лотерея среди Followers",
    dataTable1_tooltip9:
      "Установка заданий для участия (лайк, Comment, Mention, Follow). Автоматическое создание и публикация условий. Напоминания. Публикация результатов и многое другое.",
    WithStrongCallToAction: "С сильным призывом к действию",
    WithProsAndCons: "С плюсами и минусами",
    ForComparison: "Для сравнения",
    WithKeyPoints: "С ключевыми моментами",
    ForPromotionalPost: "Для рекламного поста",
    WithDetailedExplanation: "С подробным объяснением",
    PersuasiveStyle: "В убедительном стиле",
    ForProductIntroduction: "Для представления продукта",
    LongText: "В виде длинного текста",
    Aipromptexplain:
      "Brancy анализирует контент вашей страницы, чтобы понять ваш тон и стиль письма; дополнительное объяснение не требуется!",
    ImagineSomething: "Представь что-то... ✦",
    Generating: "Генерация...",
    AccessAndManageComments: "Доступ и управление комментариями",
    AccessAndManageMessages: "Доступ и управление сообщениями",
    AccessAndPublishContent: "Доступ и публикация контента",
    AccessAndManageInsights: "Доступ и управление статистикой и отчетами",
    AccessAndManageCommentsExplain:
      "Чтобы управлять комментариями Instagram, нажмите «Включить разрешение» и подтвердите на открывшейся странице.",
    AccessAndManageMessagesExplain:
      "Чтобы управлять сообщениями Instagram, нажмите «Включить разрешение» и подтвердите на открывшейся странице.",
    AccessAndPublishContentExplain:
      "Чтобы просматривать и публиковать контент Instagram, нажмите «Включить разрешение» и подтвердите на открывшейся странице.",
    AccessAndManageInsightsExplain:
      "Чтобы управлять статистикой Instagram, нажмите «Включить разрешение» и подтвердите на открывшейся странице.",
    EnablePermission: "Включить разрешение",
    instagramTutorialTitle: "Руководство по подключению Instagram",
    instagramTutorialStep1Title: "Шаг 1: Безопасный вход в Instagram",
    instagramTutorialStep1Text:
      "Нажмите «Подключить аккаунт Instagram», вы будете перенаправлены на instagram.com. Войдите в аккаунт для безопасного и корректного подключения.",
    instagramTutorialStep2Title: "Шаг 2: Подтверждение доступа",
    instagramTutorialStep2Text:
      "После входа Instagram запросит доступ к публичной информации. Разрешите всё для корректной работы системы.",
    instagramremoveStep1Title: "Шаг 3: Проверка доступа",
    instagramremoveStep1text: "Перейдите в настройки, чтобы увидеть все активные разрешения аккаунта.",
    instagramremoveStep2Title: "Шаг 4: Управление и удаление лишнего доступа",
    instagramremoveStep2text:
      "Brancy — официальный партнёр Instagram, другие сервисы не нужны. Для безопасности удалите лишние доступы.",

    understood: "Понял",
    previous: "Назад",
    connectTutorial: "Доступ к обучению",
    invalidcode: "Недействительный код",
    wearesorry: "Нам жаль!",
    PaymentFailed: "Платёж не прошёл!",
    thankyou: "Спасибо!",
    Paymentsuccess: "Оплата прошла успешно!",

    TransactionNumber: "Номер транзакции:",
    TransactiontrackingNumber: "Номер отслеживания транзакции:",
    InvoiceNumber: "Номер счета:",

    mainSubscriptionPlan: "Основная подписка",
    Tokens: "Токены",
    tokenExplain:
      "Токен — это единица потребления услуг искусственного интеллекта; в среднем обработка 100 запросов требует около 1000 токенов.",
    ReserveToken: "Резервный токен",
    packageTokenExplain:
      "Бесплатные токены, активируемые вместе с пакетом и действующие до окончания срока действия пакета; после этого они истекают.",
    ReserveTokenExplain: "Приобретённые резервные токены, срок действия которых не истекает со временем.",

    pageTools_Months: "Месяцы",
    subscriptionExpired: "Ваша подписка истекла, продлите её",
    subscriptionExpireSoon: "Ваша подписка скоро истечет",
    subscriptionManagement: "Управление подпиской",
    subscription: "Подписка",
    AIAssisment: "AI Ассистент",
    timeperiod: "Оставшийся период",
    domain: "Домен",
    winnerpickerexpired: "Вы больше не можете проводить Lottery, пожалуйста, пополните",
    winnerpickerexpiresoon: "Ваши попытки Lottery скоро закончатся",
    Aiexpired: "У вас больше нет доступа к ИИ. Пожалуйста, пополните баланс.",
    Aiexpiresoon: "Ваши токены ИИ почти закончились.",

    followercount: "Количество фалоров",
    yourCurrentSubscription: "Ваше текущее подписка",
    noItemsAvailableContactSupport:
      "Этот раздел временно недоступен. Пожалуйста, обратитесь в поддержку Brancy, отправив тикет.",

    // #region AIFlow Section
    AIAssismentexplain:
      "С помощью ИИ-ассистента Brancy вы можете создавать умные сценарии диалогов для автоматических ответов на сообщения и комментарии в Instagram",
    livetest: "Живой тест",
    testlab: "Тестовая лаборатория",
    promptmode: "Режим Prompt",
    promptanalysis: "Анализ Prompt",
    promptanalysisExplain:
      "Подробно введите свой промпт; Brancy проанализирует его с учётом вашей личности, тона и стиля взаимодействия.",
    promptanalysisplaceholder: "Введите не менее 20 символов для анализа Prompt",
    reanalyze: "Повторный анализ",
    shouldFollowerexplain: "Ответы отправляются только пользователям, которые follow вас",
    RenewForThread: "Обновить поток диалога",
    RenewForThreadexplain:
      "В каждом диалоге, если пользователь отправляет новое сообщение, поток диалога начинается заново",
    prompt: "Prompt",
    promptanalysisexplain: "Brancy анализирует ваш Prompt и предлагает лучшие настройки для умных ответов",

    autosave: "Автосохранение",
    Restrictorzoom: "Ограничение Масштаба",
    snapGrid: "Привязка к Сетке",
    PanningBoundary: "Граница Перемещения",
    Flow: "Поток (Flow)",
    flowtitle: "Заголовок Потока",
    AIFlow_input: "Ввод",
    AIFlow_input_message_block: "Сообщение Пользователя",
    AIFlow_output: "Вывод",
    AIFlow_output_title: "Заголовок Вывода",
    AIFlow_text: "Текст",
    AIFlow_item_text: "Элемент",
    AIFlow_block_title_required: "Пожалуйста, введите заголовок блока (обязательно)",
    AIFlow_item_title: "Заголовок Элемента:",
    AIFlow_show_graph: "Показать график потока",
    AIFlow_connect_post: "Подключить к публикации",
    AIFlow_connect_post_access:
      "Нужны разрешения Instagram на комментарии и сообщения и доступ к автоматизации и комментариям.",
    AIFlow_connect_post_save_first: "Сохраните поток перед подключением к публикации.",
    AIFlow_connect_post_confirm:
      "Этот поток заменит текущий автоответ публикации и будет активирован. Ключевые слова и режим сопоставления сохраняются; без ключевых слов поток отвечает на все комментарии.",
    AIFlow_connect_post_resume: "Связь с потоком сохранена, но активация не удалась. Попробуйте активировать снова.",
    AIFlow_connect_post_incompatible:
      "Этот поток несовместим с личными ответами на комментарии. Измените и сохраните его перед подключением.",
    AIFlow_retry: "Повторить",
    AIPrompt_connect_post_access: "Нужны разрешение Instagram на комментарии и доступ к автоматизации и комментариям.",
    AIPrompt_connect_post_confirm:
      "Этот ИИ заменит текущий автоответ публикации и будет активирован. Ключевые слова и режим сопоставления сохраняются; без ключевых слов ответ получают все комментарии. Личная отправка сохраняется только при наличии разрешения на сообщения; иначе ответы отправляются как комментарии.",
    AIPrompt_connect_post_resume: "Связь с ИИ сохранена, но активация не удалась. Попробуйте активировать снова.",
    messagesetting_PhoneNumbers: "Номера телефонов",
    messagesetting_PhoneNumbersExplain: "Номера телефонов, собранные у ваших клиентов через потоки",
    messagesetting_PhoneNumbersEmpty: "Номера телефонов пока не собраны",
    AIFlow_item_subtitle: "Подзаголовок Элемента:",
    AIFlow_option_title: "Заголовок Опции",
    AIFlow_option_default: "Опция",
    AIFlow_quick_reply: "Быстрый Ответ",
    AIFlow_quick_reply_validation_error: "Все поля быстрого ответа должны быть заполнены!",
    AIFlow_quick_reply_block_title_empty: "Блок {label}\n Заголовок не введен",
    AIFlow_quick_reply_option_title_empty: "Блок {label}\n Опция {index} без заголовка",
    AIFlow_delete_image: "🗑️ Удалить Изображение",
    AIFlow_delete_image_button_text: "🗑️ Удалить Изображение",
    AIFlow_delete_all_block: "🗑️ Удалить Блок",
    AIFlow_delete_all_blocks: "Удалить весь Поток",
    AIFlow_save_all_blocks: "Сохранить весь Поток",
    AIFlow_delete: "🗑️ Удалить",
    AIFlow_upload_image: "📷 Загрузить Изображение",
    AIFlow_image_uploaded: "Изображение Загружено ✓",
    AIFlow_add_image: "📷 Добавить Изображение",
    AIFlow_voice_recorded: "🎵 Записанный Голос",
    AIFlow_record_voice: "🎤 Записать Голос",
    AIFlow_record_voice_confirm: "Готовы к записи? (минимум 3 секунды)",
    AIFlow_play_voice: "▶️ Воспроизвести Голос",
    AIFlow_add_output: "Добавить Новый Вывод",
    AIFlow_add_subtitle: "➕ Добавить Подзаголовок",
    AIFlow_subtitle_input: "Пожалуйста, введите подзаголовок:",
    AIFlow_link: "Ссылка:",
    AIFlow_general_block: "Общий Блок",
    AIFlow_text_block: "Текстовый Блок",
    AIFlow_image_block: "Блок Изображения",
    AIFlow_voice_block: "Аудио Блок",
    AIFlow_quick_reply_block: "Блок Быстрого Ответа",
    AIFlow_weblink_block: "Блок Ссылки",
    AIFlow_add_text_block: "Добавить Текстовый Блок",
    AIFlow_add_image_block: "Добавить Блок Изображения",
    AIFlow_add_voice_block: "Добавить Аудио Блок",
    AIFlow_add_quick_reply_block: "Добавить Быстрый Ответ",
    AIFlow_add_general_block: "Добавить Общий Блок",
    AIFlow_add_weblink_block: "Добавить Ссылку",
    AIFlow_generic_block: "Универсальный Блок",
    AutoLayout_block: "Авто-Раскладка",
    AIFlow_live_test_block: "Живое Тестирование Потока",
    AIFlow_Deleteallblocks_alert: "Вы уверены, что хотите удалить весь поток?",
    AIFlow_add_output_error_alert: "Ошибка при добавлении выхода: {error}",
    AIFlow_unknown_block_type_alert: "Неизвестный тип блока:",
    AIFlow_multiple_flow_for_private_reply_alert: "Найдено несколько потоков для личного ответа",
    AIFlow_empty_title_for_flow_alert: "Название потока пустое",
    AIFlow_weblink_has_hyphen_alert: "Блок {label}\n Ссылка не должна содержать '-'",
    AIFlow_min_output_required: "Должен остаться как минимум один выход",
    AIFlow_max_quick_reply_outputs: "Разрешено максимум 15 выходов",
    AIFlow_max_generic_outputs: "Разрешено максимум 10 выходов",
    AIFlow_generic_item_connection_only: "Этот блок соединяется только с общими блоками",
    AIFlow_weblink_generic_item_only: "Этот блок соединяется только с общими подэлементами",
    AIFlow_voice_record_failed: "❌ Ошибка записи голоса (звук не записан)",
    AIFlow_voice_upload_failed: "✅ Запись прошла успешно, но загрузка не удалась",
    AIFlow_voice_record_empty: "❌ Запись голоса пуста",
    AIFlow_voice_record_start: "🎙️ Запись началась...",
    AIFlow_session_invalid: "Недействительная сессия пользователя, пожалуйста, войдите снова",
    AIFlow_no_on_message_node: "Не найден стартовый узел сообщения!",
    AIFlow_validation_warning: "⚠️ Предупреждение валидации",
    AIFlow_generic_item_validation_error: "Пожалуйста, заполните все поля общего блока",
    AIFlow_weblink_validation_error_alert: "Все поля ссылки должны быть заполнены",
    AIFlow_generic_item_title_empty_alert: "Элемент {label}\n Название пустое",
    AIFlow_generic_item_output_title_empty_alert: "Элемент {label}\n Выход {index} без названия",
    AIFlow_weblink_empty_alert: "Блок {label}\n Ссылка пуста",

    AIFlow_weblink_incomplete_alert: "Блок {label}\n Ссылка неполная (введён только протокол)",
    AIFlow_weblink_invalid_format_alert: "Блок {label}\n Неверный формат ссылки",
    AIFlow_weblink_non_english_alert: "Блок {label}\n Ссылка должна быть на английском",
    AIFlow_editor_init_error: "❌ Ошибка инициализации редактора",
    AIFlow_unexpected_error: "⚠️ Произошла непредвиденная ошибка",
    AIFlow_server_error: "❌ Ошибка сервера",
    AIFlow_connection_error: "⚠️ Проблема с подключением",
    AIFlow_generic_connection_error: "Ошибка подключения общего блока к подэлементу",
    AIFlow_weblink_connection_error: "Ошибка подключения узла",
    AIFlow_voice_fetch_error: "Ошибка получения аудиофайла",
    AIFlow_voice_record_error: "Ошибка записи голоса",
    AIFlow_voice_play_error: "Ошибка воспроизведения голоса",
    AIFlow_media_recorder_error: "Ошибка в медиарекордере",
    AIFlow_upload_error: "❌ Ошибка загрузки",
    AIFlow_add_output_error: "❌ Ошибка добавления выхода",
    AIFlow_json_parse_error: "Ошибка обработки JSON",
    AIFlow_position_error: "Ошибка обработки позиции стартового сообщения",
    AIFlow_node_remove_error: "Ошибка удаления узла",
    AIFlow_node_connection_warning: "Невозможно установить соединение:",
    AIFlow_unknown_value_type: "Неизвестный тип значения в кнопке",
    AIFlow_success: "✅ Операция успешно выполнена",
    AIFlow_subtitle_success: "✓ Подзаголовок успешно добавлен",
    AI_live_test: "Тестируйте свои AI-промпты в реальном времени",

    New_Flow_input_message_block: "Входящее сообщение пользователя",
    New_Flow_general_block: "Общий блок",
    New_Flow_text_block: "Текстовый блок",
    New_Flow_voice_block: "Аудиоблок",
    New_Flow_imageorvideo_block: "Блок изображения / видео",
    New_Flow_quick_reply_block: "Блок быстрого ответа",
    New_Flow_weblink_block: "Блок ссылки",
    New_Flow_phonenumbergrabber_block: "Сбор номера телефона",
    New_Flow_ai_block: "ИИ",
    New_Flow_ai_select: "Выберите ИИ",
    New_Flow_ai_livetest: "Ваш ИИ-блок выполняется здесь",
    New_Flow_masterflow_block: "Подпоток",
    New_Flow_masterflow_select: "Выберите поток",
    New_Flow_masterflow_livetest: "Выбранный подпоток продолжается отсюда",
    New_Flow_Tutorials_buttongroup_title: "Блок группы кнопок",
    New_Flow_Tutorials_buttongroup_description:
      "Этот блок отправляет сообщение с не более чем тремя кнопками; у каждой кнопки свой выход, а у блока есть и обычный выход, продолжающий сценарий.",
    New_Flow_Tutorials_buttongroup_usageType:
      "Подходит для предложения нескольких понятных вариантов, меню, быстрой навигации и направления пользователя по ссылке или на следующий шаг.",
    New_Flow_Tutorials_buttongroup_feature_1: "Текст сообщения до 640 символов",
    New_Flow_Tutorials_buttongroup_feature_2: "До 3 кнопок, у каждой свой независимый выход",
    New_Flow_Tutorials_buttongroup_feature_3: "Обычный выход продолжает сценарий, не дожидаясь нажатия кнопки",
    New_Flow_Tutorials_buttongroup_tip_1: "Пишите текст и надписи кнопок ясно и кратко",
    New_Flow_Tutorials_buttongroup_tip_2: "Подключайте каждую кнопку к блоку, который должен следовать после её выбора",
    New_Flow_Tutorials_buttongroup_tip_3: "К блоку «Ссылка» можно подключить только выходы кнопок",
    New_Flow_Tutorials_buttongroup_limitation_1: "Максимум 3 кнопки",
    New_Flow_Tutorials_buttongroup_limitation_2: "Текст сообщения: максимум 640 символов",
    New_Flow_Tutorials_buttongroup_limitation_3: "Название кнопки: максимум 20 символов",
    New_Flow_Tutorials_buttongroup_limitation_4: "Удаление последней кнопки удаляет блок",
    New_Flow_Tutorials_ai_title: "Блок ИИ",
    New_Flow_Tutorials_ai_description:
      "Этот блок передаёт диалог одному из созданных вами ИИ; выберите ИИ из списка внутри блока.",
    New_Flow_Tutorials_ai_usageType:
      "Подходит для автоматических ответов на свободные вопросы клиентов, поддержки, консультаций и продающих диалогов.",
    New_Flow_Tutorials_ai_feature_1: "Показывает список всех созданных вами ИИ для выбора",
    New_Flow_Tutorials_ai_feature_2: "Выбранный ИИ берёт на себя диалог с этого места сценария",
    New_Flow_Tutorials_ai_tip_1: "Сначала создайте и настройте ИИ, чтобы он появился в списке",
    New_Flow_Tutorials_ai_tip_2: "Размещайте после блока сообщения, который вводит в диалог",
    New_Flow_Tutorials_ai_limitation_1: "Имеет только вход и не имеет выхода, поэтому завершает сценарий",
    New_Flow_Tutorials_ai_limitation_2: "В одном блоке можно выбрать только один ИИ",
    New_Flow_Tutorials_ai_limitation_3: "Не может быть первым блоком потока",
    New_Flow_Tutorials_masterflow_title: "Блок подпотока",
    New_Flow_Tutorials_masterflow_description:
      "Переводит разговор в другой уже созданный поток, когда пользователь нажимает кнопку.",
    New_Flow_Tutorials_masterflow_usageType: "Повторное использование существующего потока как продолжения кнопки",
    New_Flow_Tutorials_masterflow_feature_1: "Показывает все созданные вами потоки для выбора",
    New_Flow_Tutorials_masterflow_feature_2: "Выбранный поток продолжает разговор с этого места",
    New_Flow_Tutorials_masterflow_tip_1: "Сначала создайте и сохраните целевой поток, чтобы он появился в списке",
    New_Flow_Tutorials_masterflow_tip_2: "Используйте для общих сценариев (поддержка, цены) между потоками",
    New_Flow_Tutorials_masterflow_limitation_1: "Имеет только вход и не имеет выхода, поэтому завершает этот поток",
    New_Flow_Tutorials_masterflow_limitation_2: "Подключается только к кнопкам, а не к обычным выходам",
    New_Flow_Tutorials_masterflow_limitation_3: "Редактируемый поток нельзя выбрать",
    New_Flow_Tutorials_masterflow_connection_1: "Кнопки блока быстрого ответа",
    New_Flow_Tutorials_masterflow_connection_2: "Кнопки блока группы кнопок",
    New_Flow_Tutorials_masterflow_connection_3: "Кнопки подблока галереи",
    New_Flow_generic_block: "Галерея-блок (Карусель)",
    New_Flow_add_general_block: "Добавить блок галереи",
    New_Flow_add_text_block: "Добавить текстовый блок",
    New_Flow_add_image_block: "Добавить блок изображения",
    New_Flow_add_voice_block: "Добавить аудиоблок",
    New_Flow_add_quick_reply_block: "Добавить быстрый ответ",
    New_Flow_add_weblink_block: "Добавить ссылку",
    New_Flow_upload_imageorvideo: "Загрузить изображение или видео",
    New_Flow_upload_image: "Загрузить изображение",
    New_Flow_upload_unsupported_media: "Формат медиа не поддерживается",
    New_Flow_uploadmaxsizeexceeded: "Размер файла не должен превышать 50MB",
    New_Flow_uploadfilefailed: "Ошибка загрузки файла, попробуйте снова",
    New_Flow_unsupportedbrowser: "Ваш браузер не поддерживает воспроизведение видео",
    New_Flow_micphoneaccessdenied: "Разрешите доступ к микрофону",
    New_Flow_upload_audio: "Загрузить аудиофайл",
    New_Flow_record_voice: "Записать голос",
    New_Flow_stop_record_voice: "Остановить запись",
    New_Flow_areyoureadytorecord: "Вы готовы к записи?",
    New_Flow_voice_recording_started: "Идёт запись...",
    New_Flow_add_generic_sub_block: "Добавить подблок",
    New_Flow_generic_sub: "Подблок",
    New_Flow_add_button: "Добавить кнопку",
    New_Flow_quick_reply_title_placeholder: "Название варианта быстрого ответа",
    New_Flow_buttongroup_block: "Блок группы кнопок",
    New_Flow_add_buttongroup_block: "Добавить группу кнопок",
    New_Flow_buttongroup_title_placeholder: "Текст сообщения группы кнопок",
    New_Flow_imagegallery_block: "Блок Галерея изображений",
    New_Flow_add_imagegallery_block: "Добавить галерею изображений",
    New_Flow_imagegallery_max_reached: "В этот блок можно добавить до {{max}} изображений",
    New_Flow_Tutorials_imagegallery_title: "Блок Галерея изображений",
    New_Flow_Tutorials_imagegallery_description:
      "Этот блок используется для загрузки и отправки нескольких изображений (до {{max}}) пользователям в личных сообщениях.",
    New_Flow_Tutorials_imagegallery_usageType:
      "Подходит для демонстрации нескольких товаров, фотоальбомов, фото «до и после» и коллекций изображений.",
    New_Flow_Tutorials_imagegallery_feature_1: "Принимает до {{max}} изображений в одном блоке",
    New_Flow_Tutorials_imagegallery_limitation_1:
      "Максимум {{max}} изображений на блок (этот лимит может быть увеличен в будущем)",
    New_Flow_message_title: "Заголовок сообщения",
    New_Flow_message_description: "Описание сообщения",
    New_Flow_live_test_block: "Тест живого потока",
    New_Flow_delete_all_blocks: "Удалить весь поток",
    New_Flow_shortcuts_explain: "Горячие клавиши для увеличения скорости и удобства управления рабочими процессами.",
    New_Flow_Tutorials_Not_Available: "Руководство недоступно",
    New_Flow_Tutorials_Not_Available_Description: "Для этого узла руководство недоступно.",
    New_Flow_Tutorials_Usage_Type: "Тип использования",
    New_Flow_Tutorials_Features: "Функции",
    New_Flow_Tutorials_Tips: "Практические советы",
    New_Flow_Tutorials_Limitations: "Ограничения",
    New_Flow_Tutorials_Connections: "Подключения",
    New_Flow_unsavedChanges: "У вас есть несохранённые изменения",
    New_Flow_addedNodes: "Добавленные узлы",
    New_Flow_removedNodes: "Удалённые узлы",
    New_Flow_modifiedNodes: "Изменённые узлы",
    New_Flow_invalidFlow_explain: "Флоу недействителен. Пожалуйста, проверьте узлы на наличие ошибок перед сохранением",
    sendsms: "Отправить SMS пользователю",
    sendtotelegram: "Перенаправить пользователя в Telegram",
    senderusername: "Обратиться к пользователю по имени",
    addtools: "Добавить инструмент",
    generatebyai: "Создать с помощью ИИ",

    //tutorials

    New_Flow_Tutorials_onmessage_title: "Начальная точка вашего потока",
    New_Flow_Tutorials_onmessage_description:
      "Этот блок является начальной точкой вашего потока. Когда пользователь отправляет сообщение в ваш Instagram direct, этот блок активируется и поток запускается. Это всегда первый блок в любой автоматизации и его нельзя удалить.",
    New_Flow_Tutorials_onmessage_feature_1: "Один выход для подключения к следующему блоку",
    New_Flow_Tutorials_onmessage_tip_1:
      "Подключите выход этого блока к любому другому блоку. Поток начинается, когда пользователь отправляет любое сообщение (текст, изображение, видео, аудио и т.д.)",
    New_Flow_Tutorials_onmessage_connection_1: "Можно подключить к следующим блокам:",
    New_Flow_Tutorials_onmessage_connection_2: "❌ Блок веб-ссылки",
    New_Flow_Tutorials_onmessage_connection_3: "✅ Блок голосового сообщения",
    New_Flow_Tutorials_onmessage_connection_4: "✅ Блок текстового сообщения",
    New_Flow_Tutorials_onmessage_connection_5: "✅ Блок быстрого ответа",
    New_Flow_Tutorials_onmessage_connection_6: "✅ Блок изображений и видео",
    New_Flow_Tutorials_onmessage_connection_7: "✅ Блок галереи",

    New_Flow_Tutorials_text_title: "Блок текстового сообщения",
    New_Flow_Tutorials_text_description: "Этот блок используется для отправки текстовых сообщений пользователям.",
    New_Flow_Tutorials_text_usageType:
      "Подходит для приветственных сообщений, объяснения продуктов, часто задаваемых вопросов, уведомлений и руководства пользователей.",
    New_Flow_Tutorials_text_feature_1: "Поддержка всех языков",
    New_Flow_Tutorials_text_feature_2: "Возможность использовать эмодзи и специальные символы",
    New_Flow_Tutorials_text_tip_1: "Держите сообщения короткими и понятными",
    New_Flow_Tutorials_text_tip_2: "Используйте эмодзи умеренно",
    New_Flow_Tutorials_text_tip_3: "Разделяйте длинные тексты на несколько частей",
    New_Flow_Tutorials_text_tip_4: "Сохраняйте дружелюбный тон",
    New_Flow_Tutorials_text_tip_5: "Используйте правильное форматирование абзацев",
    New_Flow_Tutorials_text_limitation_1: "Максимум 2200 символов",
    New_Flow_Tutorials_text_limitation_2: "Только текст (без файлов или медиа)",
    New_Flow_Tutorials_text_limitation_3: "Нет возможности форматирования (Жирный, Курсив)",
    New_Flow_Tutorials_text_connection_1: "✅ Блок ввода сообщений",
    New_Flow_Tutorials_text_connection_2: "❌ Блок веб-ссылки",
    New_Flow_Tutorials_text_connection_3: "✅ Блок голосового сообщения",
    New_Flow_Tutorials_text_connection_4: "✅ Блок текстового сообщения",
    New_Flow_Tutorials_text_connection_5: "✅ Блок быстрого ответа",
    New_Flow_Tutorials_text_connection_6: "✅ Блок изображений и видео",
    New_Flow_Tutorials_text_connection_7: "❌ Блок галереи",
    New_Flow_Tutorials_text_connection_8: "✅ Блок подветви галереи",

    New_Flow_Tutorials_image_title: "Блок Изображение и Видео",
    New_Flow_Tutorials_image_description:
      "Этот блок используется для загрузки и отправки изображений и видео пользователям через direct.",
    New_Flow_Tutorials_image_usageType:
      "Подходит для демонстрации продуктов, галерей изображений, логотипов, рекламных баннеров, обучающих и презентационных видео.",
    New_Flow_Tutorials_image_feature_1: "Поддержка изображений: JPEG, PNG, GIF, WebP, SVG",
    New_Flow_Tutorials_image_feature_2: "Поддержка видео: MP4, WebM, OGG, MOV, AVI, MKV",
    New_Flow_Tutorials_image_feature_3: "Автоматическое определение типа файла",
    New_Flow_Tutorials_image_tip_1: "Используйте изображения высокого качества",
    New_Flow_Tutorials_image_tip_2: "Сжимайте большие файлы перед загрузкой",
    New_Flow_Tutorials_image_tip_3: "Стандартные размеры: 1080×1080 или 1080×1350",
    New_Flow_Tutorials_image_tip_4: "Держите видео до 30 секунд",
    New_Flow_Tutorials_image_tip_5: "JPEG для обычных изображений, PNG для прозрачного фона",
    New_Flow_Tutorials_image_limitation_1: "Максимальный размер: 50 МБ",
    New_Flow_Tutorials_image_limitation_2: "Один файл на блок",
    New_Flow_Tutorials_image_limitation_3: "Необычные форматы могут не поддерживаться",
    New_Flow_Tutorials_image_connection_1: "✅ Блок ввода сообщений",
    New_Flow_Tutorials_image_connection_2: "❌ Блок веб-ссылки",
    New_Flow_Tutorials_image_connection_3: "✅ Блок голосового сообщения",
    New_Flow_Tutorials_image_connection_4: "✅ Блок текстового сообщения",
    New_Flow_Tutorials_image_connection_5: "✅ Блок быстрого ответа",
    New_Flow_Tutorials_image_connection_6: "✅ Блок Изображение и Видео",
    New_Flow_Tutorials_image_connection_7: "❌ Блок Галерея",
    New_Flow_Tutorials_image_connection_8: "✅ Подблок Галерея",
    invalidFlowDetected:
      "Обнаружен некорректный поток! Некоторые блоки не имеют входа или блок сообщения находится отдельно.",

    New_Flow_Tutorials_voice_title: "Блок голосового сообщения",
    New_Flow_Tutorials_voice_description:
      "Этот блок используется для загрузки и отправки аудиофайлов или живых записей пользователям.",
    New_Flow_Tutorials_voice_usageType:
      "Подходит для личных голосовых сообщений, озвученных уроков, коротких подкастов и голосовых инструкций.",
    New_Flow_Tutorials_voice_feature_1: "Поддержка форматов: MP3, M4A, WAV, OGG, AAC",
    New_Flow_Tutorials_voice_feature_2: "Прямое запись с микрофона",
    New_Flow_Tutorials_voice_feature_3: "Загрузка заранее записанных аудиофайлов",
    New_Flow_Tutorials_voice_tip_1: "Записывайте в тихой обстановке",
    New_Flow_Tutorials_voice_tip_2: "Лучше короткие сообщения (до 1 минуты)",
    New_Flow_Tutorials_voice_tip_3: "Проверьте качество звука перед отправкой",
    New_Flow_Tutorials_voice_tip_4: "Подготовьте текст перед записью",
    New_Flow_Tutorials_voice_limitation_1: "Максимальный размер: 50 МБ",
    New_Flow_Tutorials_voice_limitation_2: "Требуется доступ к микрофону для записи",
    New_Flow_Tutorials_voice_limitation_3: "Один файл на блок",
    New_Flow_Tutorials_voice_connection_1: "✅ Блок ввода сообщений",
    New_Flow_Tutorials_voice_connection_2: "❌ Блок веб-ссылки",
    New_Flow_Tutorials_voice_connection_3: "✅ Блок голосового сообщения",
    New_Flow_Tutorials_voice_connection_4: "✅ Блок текстового сообщения",
    New_Flow_Tutorials_voice_connection_5: "✅ Блок быстрого ответа",
    New_Flow_Tutorials_voice_connection_6: "✅ Блок Изображение и Видео",
    New_Flow_Tutorials_voice_connection_7: "❌ Блок Галерея",
    New_Flow_Tutorials_voice_connection_8: "✅ Подблок Галерея",

    New_Flow_Tutorials_quickreply_title: "Блок Быстрого ответа",
    New_Flow_Tutorials_quickreply_description:
      "Этот блок используется для создания одноразовых кнопок Quick Reply для пользователей, где каждая кнопка направляет пользователя по определенному пути потока.",
    New_Flow_Tutorials_quickreply_usageType:
      "Подходит для меню выбора, категорий продуктов, вопросов с несколькими вариантами, опросов и фильтров поиска.",
    New_Flow_Tutorials_quickreply_feature_1: "До 10 кнопок в блоке",
    New_Flow_Tutorials_quickreply_feature_2: "Каждая кнопка имеет независимый выход",
    New_Flow_Tutorials_quickreply_feature_3: "Возможность удаления и редактирования кнопок",
    New_Flow_Tutorials_quickreply_tip_1: "Пишите текст кнопок ясно и практично",
    New_Flow_Tutorials_quickreply_tip_2: "3–5 кнопок для лучшего опыта",
    New_Flow_Tutorials_quickreply_tip_3: "Держите метки короткими (менее 20 символов)",
    New_Flow_Tutorials_quickreply_tip_4: "Используйте поле заголовка для подсказок",
    New_Flow_Tutorials_quickreply_tip_5: "Приоритизируйте кнопки по важности",
    New_Flow_Tutorials_quickreply_limitation_1: "Максимум 10 кнопок",
    New_Flow_Tutorials_quickreply_limitation_2: "Заголовок кнопки: максимум 40 символов",
    New_Flow_Tutorials_quickreply_limitation_3: "Описание: максимум 140 символов",
    New_Flow_Tutorials_quickreply_limitation_4: "Требуется как минимум одна кнопка",
    New_Flow_Tutorials_quickreply_connection_1: "✅ Блок ввода сообщения",
    New_Flow_Tutorials_quickreply_connection_2: "❌ Блок веб-ссылки",
    New_Flow_Tutorials_quickreply_connection_3: "✅ Блок голосового сообщения",
    New_Flow_Tutorials_quickreply_connection_4: "✅ Блок текстового сообщения",
    New_Flow_Tutorials_quickreply_connection_5: "✅ Блок быстрого ответа",
    New_Flow_Tutorials_quickreply_connection_6: "✅ Блок изображения и видео",
    New_Flow_Tutorials_quickreply_connection_7: "❌ Блок галереи",
    New_Flow_Tutorials_quickreply_connection_8: "✅ Подблок галереи",

    New_Flow_Tutorials_generic_title: "Блок Галерея (Карусель)",
    New_Flow_Tutorials_generic_description: "Создание горизонтальной прокручиваемой галереи (карусели) из элементов",
    New_Flow_Tutorials_generic_usageType:
      "Подходит для отображения продуктов, меню услуг, категорий, представления команды, портфолио и сравнения вариантов.",
    New_Flow_Tutorials_generic_tip_1: "Используйте изображения одинакового размера (например, 1:1)",
    New_Flow_Tutorials_generic_tip_2: "Держите количество элементов от 3 до 5",
    New_Flow_Tutorials_generic_tip_3: "Пишите короткие и понятные заголовки",
    New_Flow_Tutorials_generic_tip_4: "Подходит для похожих продуктов или сравнений",
    New_Flow_Tutorials_generic_limitation_1: "Максимум 10 элементов в карусели",
    New_Flow_Tutorials_generic_connection_1: "✅ Блок ввода сообщения",
    New_Flow_Tutorials_generic_connection_2: "✅ Подблок галереи",
    New_Flow_Tutorials_generic_connection_3: "❌ Блок веб-ссылки",
    New_Flow_Tutorials_generic_connection_4: "❌ Блок голосового сообщения",
    New_Flow_Tutorials_generic_connection_5: "❌ Блок текстового сообщения",
    New_Flow_Tutorials_generic_connection_6: "❌ Блок быстрого ответа",
    New_Flow_Tutorials_generic_connection_7: "❌ Блок изображения и видео",

    New_Flow_Tutorials_genericitem_title: "Элемент Карусели",
    New_Flow_Tutorials_genericitem_description:
      "Элемент в карусели, включающий изображение, заголовок, описание, ссылку и до 3 кнопок",
    New_Flow_Tutorials_genericitem_usageType:
      "Подходит для отображения деталей продуктов, презентации услуг, команды, портфолио и ценовых пакетов.",
    New_Flow_Tutorials_genericitem_feature_1: "Веб-ссылка опционально",
    New_Flow_Tutorials_genericitem_feature_2: "Изображение опционально: JPEG, PNG, GIF",
    New_Flow_Tutorials_genericitem_feature_3: "Видео: MP4, WebM, OGG",
    New_Flow_Tutorials_genericitem_feature_4: "До 3 кнопок с независимыми выходами",
    New_Flow_Tutorials_genericitem_tip_1: "Добавляйте привлекательное изображение для каждого элемента",
    New_Flow_Tutorials_genericitem_tip_2: "Заголовок для основного сообщения, описание для деталей",
    New_Flow_Tutorials_genericitem_tip_3: "Проверяйте ссылки перед отправкой",
    New_Flow_Tutorials_genericitem_tip_4: "Текст кнопок должен быть коротким и понятным",
    New_Flow_Tutorials_genericitem_tip_5: "Лучше использовать короткие ссылки",
    New_Flow_Tutorials_genericitem_limitation_1: "Заголовок: максимум 140 символов",
    New_Flow_Tutorials_genericitem_limitation_2: "Описание: максимум 140 символов",
    New_Flow_Tutorials_genericitem_limitation_3: "Максимум 3 кнопки",
    New_Flow_Tutorials_genericitem_limitation_4: "Название кнопки: максимум 40 символов",
    New_Flow_Tutorials_genericitem_limitation_5: "Размер файла: максимум 50 МБ",
    New_Flow_Tutorials_genericitem_limitation_6: "Минимум одна кнопка обязательна",
    New_Flow_Tutorials_genericitem_connection_1: "❌ Блок ввода сообщений",
    New_Flow_Tutorials_genericitem_connection_2: "✅ Блок галереи",
    New_Flow_Tutorials_genericitem_connection_3: "✅ Блок веб-ссылки",
    New_Flow_Tutorials_genericitem_connection_4: "✅ Блок голосового сообщения",
    New_Flow_Tutorials_genericitem_connection_5: "✅ Блок текстового сообщения",
    New_Flow_Tutorials_genericitem_connection_6: "✅ Блок быстрого ответа",
    New_Flow_Tutorials_genericitem_connection_7: "✅ Блок изображений и видео",

    New_Flow_Tutorials_weblink_title: "Блок веб-ссылки",
    New_Flow_Tutorials_phonenumbergrabber_title: "Блок сбора номера телефона",
    New_Flow_Tutorials_phonenumbergrabber_description:
      "Этот блок ожидает получения номера телефона и после получения сохраняет его как действительный номер.",
    New_Flow_Tutorials_phonenumbergrabber_usageType:
      "Подходит для сбора номеров клиентов, регистрации, отслеживания заказов, консультаций и связи с отделом продаж.",
    New_Flow_Tutorials_phonenumbergrabber_feature_1: "Ожидает ответа пользователя до получения номера телефона",
    New_Flow_Tutorials_phonenumbergrabber_feature_2: "Автоматически проверяет и сохраняет полученный номер",
    New_Flow_Tutorials_phonenumbergrabber_tip_1: "Перед этим блоком попросите номер с помощью текстового блока",
    New_Flow_Tutorials_phonenumbergrabber_tip_2: "Укажите ожидаемый формат номера (например, с кодом страны)",
    New_Flow_Tutorials_phonenumbergrabber_tip_3:
      "После этого блока отправьте сообщение подтверждения или благодарности",
    New_Flow_Tutorials_phonenumbergrabber_limitation_1: "Не может быть первым блоком потока",
    New_Flow_Tutorials_phonenumbergrabber_limitation_2: "Имеет только один вход и один выход",
    New_Flow_Tutorials_phonenumbergrabber_limitation_3: "Сохраняются только действительные номера",
    New_Flow_Tutorials_phonenumbergrabber_connection_3: "❌ Блок подветви галереи",
    New_Flow_Tutorials_phonenumbergrabber_connection_2: "❌ Блок быстрого ответа",
    New_Flow_Tutorials_phonenumbergrabber_connection_1: "❌ Блок входящего сообщения (не может быть первым блоком)",
    New_Flow_Tutorials_weblink_description: "Отправка кликабельной веб-ссылки, открывающейся в браузере пользователя",
    New_Flow_Tutorials_weblink_usageType:
      "Подходит для перехода на сайт, страницу продукта, магазин, форму регистрации, лендинги и статьи.",
    New_Flow_Tutorials_weblink_feature_1: "Автоматическая проверка URL",
    New_Flow_Tutorials_weblink_feature_2: "Поддержка ссылок с/без WWW",
    New_Flow_Tutorials_weblink_tip_1: "Предпочтительно использовать короткие ссылки",
    New_Flow_Tutorials_weblink_tip_2: "Проверяйте ссылки перед отправкой",
    New_Flow_Tutorials_weblink_tip_3: "Ссылки должны быть мобильными",
    New_Flow_Tutorials_weblink_tip_4: "Избегайте слишком большого количества перенаправлений",
    New_Flow_Tutorials_weblink_tip_5: "Предпочтительно использовать HTTPS",
    New_Flow_Tutorials_weblink_limitation_1: "Только http:// или https:// допустимы",
    New_Flow_Tutorials_weblink_limitation_2: "Невозможно добавить описание",
    New_Flow_Tutorials_weblink_limitation_3: "Внутренние ссылки (file://) не поддерживаются",
    New_Flow_Tutorials_weblink_connection_1: "⬅️ Вход из: Подблок галереи",
    New_Flow_Tutorials_weblink_connection_2: "❌ Выход отсутствует (конец потока)",

    // #region AIFlow Section

    // #region Notification Section
    Notify_Ok: "Операция выполнена успешно",
    Notify_InternalException: "Произошла ошибка системы",
    Notify_CannotSendSmsNow: "Отправка SMS в данный момент невозможна",
    Notify_InvalidPhoneNumber: "Введённый номер телефона недействителен",
    Notify_InvalidCountryCode: "Введённый код страны недействителен",
    Notify_PhoneNumberNotAvailableInThisCountry: "Этот номер нельзя использовать в выбранной стране",
    Notify_InstagramerIdNotExist: "Пользователь Instagram не найден",
    Notify_EmptyProductList: "Список продуктов пуст",
    Notify_InvalidVerificationCode: "Введённый код подтверждения неверен",
    Notify_LowQuality: "Низкое качество контента",
    Notify_CannotEmptyChildren: "Невозможно удалить подэлементы",
    Notify_InvalidAspectRatio: "Введённое соотношение сторон недействительно",
    Notify_InvalidMediaCodec: "Медиа кодек не поддерживается",
    Notify_InvalidMediaType: "Тип медиа не поддерживается",
    Notify_MediaUrlNotAccessible: "URL медиа недоступен",
    Notify_CannotCreatePrePostNow: "Невозможно создать предварительный пост сейчас",
    Notify_InvalidMediaContent: "Медиа контент недействителен",
    Notify_Unexpected: "Произошла непредвиденная ошибка",
    Notify_TooManyRequestForImageHashtagGenerator: "Слишком много запросов на генерацию хэштегов для изображения",
    Notify_LoginFailed: "Вход не выполнен, попробуйте снова",
    Notify_NullUserId: "ID пользователя не указан",
    Notify_RealtimeSocketNotExist: "Соединение с сервером не установлено",
    Notify_PushSocketNotExist: "Соединение не установлено",
    Notify_InstaApiNotFoundForConnect: "Соединение с серверами Instagram не установлено",
    Notify_EmptyHashtagList: "Список хэштегов пуст",
    Notify_InvalidHashtagListId: "ID списка хэштегов недействителен",
    Notify_DeleteHashtagFail: "Не удалось удалить хэштег",
    Notify_InvalidBase64Content: "Содержимое Base64 недействительно",
    Notify_InvalidTermsAndConditionSvgType: "Условия недействительны",
    Notify_InvalidLotteryAnnouncementBannerId: "ID баннера лотереи недействителен",
    Notify_InvalidLotteryAnnouncementBannerStr: "Текст баннера лотереи недействителен",
    Notify_InvalidPostId: "ID поста недействителен",
    Notify_TooSoonLotteryInfo: "Информация о лотерее отправлена слишком рано",
    Notify_InvalidDirectParams: "Параметры Direct недействительны",
    Notify_NoInstagramerExists: "Instagram аккаунт не найден",
    Notify_PropertyNotFoundOrNull: "Элемент не найден или пуст",
    Notify_ReachNumberOfPinDirect: "Достигнуто максимальное количество закрепленных сообщений",
    Notify_InvalidStoryId: "ID Story недействителен",
    Notify_MaxPrePostReach: "Достигнуто максимальное количество предварительных постов",
    Notify_InvalidDraftId: "ID черновика недействителен",
    Notify_InvalidPrePostId: "ID предварительного поста недействителен",
    Notify_ReachHashtagListLimit: "Достигнуто максимальное количество списков хэштегов",
    Notify_EmptyUsername: "Имя пользователя не указано",
    Notify_TooManyRequestForPageHashtagAnalysis: "Слишком много запросов на анализ хэштегов страницы",
    Notify_PasswordRequired: "Требуется пароль",
    Notify_PackageRequiredInThisTime: "Требуется активный пакет",
    Notify_FeatureRequiredInThisTime: "Эта функция должна быть активной",
    Notify_NoShopperExist: "Покупатель не найден",
    Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount:
      "Случайная лотерея фолловеров без входа недоступна для приватных или подтвержденных аккаунтов",
    Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount:
      "Лотерея вовлеченности фолловеров без входа недоступна для приватных аккаунтов",
    Notify_InvalidLinkId: "ID ссылки недействителен",
    Notify_ReachMaxBioLink: "Достигнуто максимальное количество ссылок в био",
    Notify_OnlyBusinessAccountHasThisAccess: "Этот доступ доступен только для бизнес-аккаунтов",
    Notify_NoYoutubeChannelFound: "Канал YouTube не найден",
    Notify_CannotGetYoutubeRightNow: "Невозможно получить информацию YouTube сейчас",
    Notify_AparatUsernameNotFound: "Имя пользователя Aparat не найдено",
    Notify_AparatChannelHasNotAnyVideo: "Канал Aparat не содержит видео",
    Notify_InvalidYoutubeChannelId: "ID канала YouTube недействителен",
    Notify_NoAparatChannelFound: "Канал Aparat не найден",
    Notify_CannotGetAparatRightNow: "Невозможно получить информацию Aparat сейчас",
    Notify_NotSettedCustomDomain: "Пользовательский домен не установлен",
    Notify_CannotStoryWithoutWinnerBanner: "Невозможно создать Story без баннера победителя",
    Notify_ExceedMaxStoryWinnerLotteryBanner: "Количество баннеров победителя Story превышает лимит",
    Notify_LotteryOnProcessingOrEnded: "Лотерея в обработке или завершена",
    Notify_CannotAbortLotteryOneHourBefore: "Невозможно отменить лотерею менее чем за час до выполнения",
    Notify_CannotAbortFollowerLottery: "Невозможно отменить лотерею фолловеров",
    Notify_InvalidImageOrExceedMaxSize: "Изображение недействительно или превышает максимальный размер",
    Notify_ExceedLoginAttempt: "Превышено максимальное количество попыток входа",
    Notify_NotExistComment: "Комментарий не найден",
    Notify_UserNotFound: "Пользователь не найден",
    Notify_ExistInstagramerBefore: "Этот аккаунт Instagram уже зарегистрирован",
    Notify_CannotChangeBusinessAccountType:
      "Невозможно изменить тип бизнес-аккаунта, пожалуйста, обратитесь в поддержку через тикет",
    Notify_InvalidProductId: "Введённый ID продукта недействителен",
    Notify_InvalidTrendHashtagPeriod: "Выбранный период для трендового хэштега недействителен",
    Notify_InvalidLanguageId: "ID языка недействителен",
    Notify_CannotStoryWithoutTermsBanner: "Невозможно создать Story без баннера условий",
    Notify_ExceedMaxStoryTermsLotteryBanner: "Количество баннеров условий лотереи Story превышает допустимый предел",
    Notify_LotteryTermsIsNull: "Условия лотереи не зарегистрированы",
    Notify_CanShareTermsBefore6HoursOfStartLottery: "Условия можно делиться только за 6 часов до начала лотереи",
    Notify_CanShareTermForOnlyDefinedStatusLotteries:
      "Совместное использование условий активно только для лотерей в определённом статусе",
    Notify_SharedRemainingTimeBefore: "Оставшееся время уже было поделено",
    Notify_ShareRemainingTimeOnlyActiveForScoreLottery:
      "Совместное использование оставшегося времени активно только для рейтинговых лотерей",
    Notify_CanShareTermsBefore1HoursOfStartLottery: "Условия можно делиться только за 1 час до начала лотереи",
    Notify_InvalidSubProductIds: "ID подпродуктов недействительны",
    Notify_ReachMaxProductMedia: "Достигнуто максимальное количество медиа для продукта",
    Notify_InvalidMediaProductId: "ID медиа продукта недействителен",
    Notify_AccountNotABusiness: "Этот аккаунт не является бизнес-аккаунтом",
    Notify_NotFoundProductWithThisTempId: "Продукт с этим временным ID не найден",
    Notify_InvalidAvailabilityStatus: "Введённый статус доступности недействителен",
    Notify_InvalidIbanNumber: "Введённый номер IBAN недействителен",
    Notify_ExistedIbanNumber: "Этот номер IBAN уже зарегистрирован",
    Notify_IbanMethodNotAvailableForNotTomanPriceUser: "Метод IBAN недоступен для пользователей с валютой не в томанах",
    Notify_SearchQueryIsEmpty: "Поисковый запрос пуст",
    Notify_ExceedMaxInEachCard: "Количество элементов в каждой карточке превышает допустимый предел",
    Notify_ProductNotAlbumPost: "Этот продукт не зарегистрирован как альбомный Post",
    Notify_InvalidChildrenId: "ID ребёнка недействителен",
    Notify_NotAvailableProduct: "Продукт в данный момент недоступен",
    Notify_ExceedStockCount: "Выбранное количество превышает запас",
    Notify_CannotUnloadAnInstanceProduct: "Невозможно выгрузить экземпляр продукта",
    Notify_InvalidCategoryId: "ID категории недействителен",
    Notify_NotFoundAnyProductOnThisCategory: "В этой категории продукты не найдены",
    Notify_NotFoundAnyNextProduct: "Следующий продукт не найден",
    Notify_NotFoundAnyPreviousProduct: "Предыдущий продукт не найден",
    Notify_InvalidItemId: "ID предмета недействителен",
    Notify_IpInvalid: "Введённый IP недействителен",
    Notify_InstagramRedirectInTenSeconds: "Через 10 секунд вы будете автоматически перенаправлены в Instagram",
    Notify_InstagramRedirect: "Перенаправление в Instagram",
    Notify_InstagramRedirectExplain: "Убедитесь, что ваш VPN включён, так как ваш IP-адрес недействителен",
    Notify_ThisInstagramAccountAddedBefore: "Этот аккаунт Instagram уже добавлен",
    Notify_InvalidTicketId: "Неверный ID тикета",
    Notify_ExpiredSignature: "Срок действия подписи истек",
    Notify_Forbidden: "Несанкционированный доступ",
    Notify_ConnectedInstagramPageNotFound: "Подключенная страница Instagram не найдена",
    Notify_AllInstagramAccountConnectedAddedBefore: "Все подключенные аккаунты Instagram уже добавлены",
    Notify_SelectInstagramPageToConnect: "Пожалуйста, выберите страницу Instagram для подключения",
    Notify_InstagramRedirectRoleNotFound: "Роль перенаправления Instagram не найдена",
    Notify_FacebookLoginNotFound: "Вход через Facebook не найден",
    Notify_SelectedPageNotFound: "Выбранная страница не найдена",
    Notify_ShouldConnectInstaPageAgain: "Необходимо повторно подключить страницу Instagram",
    Notify_InvalidProductSuggestionId: "Неверный ID предложения продукта",
    Notify_NotSavedSuggestions: "Предложения не сохранены",
    Notify_ExistedSuggestedMedia: "Этот предложенный медиаресурс уже зарегистрирован",
    Notify_InvalidUploadMediaUrl: "Неверный URL загрузки медиаресурса",
    Notify_SuggestedPostAutoReplyKeyNotExist: "Ключ автоответа для предложенного Post не найден",
    Notify_UploadingTimeIsSoSoon: "Время загрузки слишком рано",
    Notify_InvalidPreStoryId: "Неверный ID Pre-Story",
    Notify_NotProvidedInstagramerId: "ID Instagramer не предоставлен",
    Notify_InvalidInstagramerId: "Неверный ID Instagramer",
    Notify_InvalidThreadId: "Неверный ID потока",
    Notify_InvalidLiveMediaId: "Неверный ID живого медиаресурса",
    Notify_NotCreatedExportComment: "Экспорт комментариев не создан",
    Notify_CreateExportAvailableWith24HourPeriod: "Создание экспорта возможно раз в 24 часа",
    Notify_NotSetted: "Не задано",
    Notify_ExceedGeneralAutoReplyCount: "Количество общих автоответов превышает лимит",
    Notify_InvalidTransactionId: "Неверный ID транзакции",
    Notify_CannotRenewalPackageWith1MonthTimeExist: "Невозможно продлить пакет на 1 месяц в данный момент",
    Notify_CannotDeleteCurrentSession: "Невозможно удалить текущую сессию",
    Notify_InvalidSessionId: "Неверный ID сессии",
    Notify_CannotDeleteCurrentSessionForNewSessionFor1Day:
      "Невозможно удалить текущую сессию для создания новой в течение 1 дня",
    Notify_UpgradedBefore: "Этот аккаунт уже был обновлен",
    Notify_PermissionNotExist: "Разрешение не существует",
    Notify_NotExistUser: "Пользователь не найден",
    Notify_UserAlreadyAsPartner: "Пользователь уже зарегистрирован как партнер-админ",
    Notify_ReachMaxPartnerCount: "Достигнуто максимальное количество партнер-админов",
    Notify_InvalidPartnerRoleProvided: "Предоставленная роль партнер-админ не действительна",
    Notify_PartnerRolesLengthIsZero: "Роль для партнер-админ не определена",
    Notify_PartnerNotExist: "Партнер-админ не найден",
    Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf:
      "Вы не можете выбрать себя в качестве партнёра-админа для себя",
    Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow:
      "Время истечения партнёра-админа должно быть не менее 1 часа с настоящего момента",
    Notify_PartnerNameCannotExceed100: "Имя партнёра-админа не может превышать 100 символов",
    Notify_ProductIsMultiSubproducted: "Этот продукт содержит несколько подпродуктов",
    Notify_InvalidSubProductId: "ID подпродукта недействителен",
    Notify_ProductIdOutOfStock: "Товар отсутствует на складе",
    Notify_SubProductIdRequired: "Требуется ID подпродукта",
    Notify_CardIsEmpty: "Корзина пуста",
    Notify_InvalidAddressId: "ID адреса недействителен",
    Notify_ExceedTotalCreateAddress: "Превышено максимальное количество разрешённых адресов",
    Notify_NotSupportedCountry: "Выбранная страна не поддерживается",
    Notify_CannotFetchAddressInThisEndpoint: "Невозможно получить адрес через эту конечную точку",
    Notify_InvalidPostalCode: "Почтовый код недействителен",
    Notify_NeedCompleteAddress: "Необходимо указать полный адрес",
    Notify_CannotBuyFromYourSelf: "Вы не можете купить у самого себя",
    Notify_AllReadyIsBusiness: "Этот аккаунт уже зарегистрирован как бизнес",
    Notify_InvalidBusinessType: "Тип бизнес-аккаунта недействителен",
    Notify_UserAlreadyAuthorized: "Пользователь уже авторизован",
    Notify_InstagramerNotInfluencer: "Instagramer не является инфлюенсером",
    Notify_InstagramerNotShopper: "Instagramer не является продавцом",
    Notify_AuthorizedInstagramerBefore: "Этот Instagramer уже авторизован",
    Notify_UserNotAuthorizedYet: "Пользователь ещё не авторизован",
    Notify_InstagramerNotAuthorized: "Instagramer не авторизован",
    Notify_InvalidBankCardNumber: "Номер банковской карты недействителен",
    Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber:
      "Владелец номера телефона не соответствует национальному номеру",
    Notify_CouponCodeAlreadyExists: "Код купона уже существует",
    Notify_InvalidCouponId: "ID купона недействителен",
    Notify_CannotChangeShowPrivateCouponInBio: "Невозможно изменить отображение приватного купона в био",
    Notify_InvalidCouponCode: "Код купона недействителен",
    Notify_CouponForAnotherPerson: "Купон принадлежит другому лицу",
    Notify_CouponExpired: "Срок действия купона истёк",
    Notify_CouponDeleted: "Купон удалён",
    Notify_CouponUsedUp: "Купон использован",
    Notify_InvalidUsernameSearchQuery: "Неверный запрос поиска имени пользователя",
    Notify_PreviouslyAddedShopAddress: "Этот адрес магазина уже добавлен",
    Notify_NotSettedShopperAddress: "Адрес покупателя не установлен",
    Notify_NotExistAnyLogesticInYourCountry: "В вашей стране нет логистической системы",
    Notify_InvalidLogesticIds: "Идентификаторы логистики недействительны",
    Notify_LogsticsNotSetted: "Логистика не настроена",
    Notify_NotCommpletedAllBusinessVerification: "Все бизнес-проверки не завершены",
    Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic:
      "Эта посылка не поддерживается выбранной доступной логистикой",
    Notify_NotSupportedLogestic: "Выбранная логистика не поддерживается",
    Notify_ExceedLogesticHeight: "Высота посылки превышает лимит логистики",
    Notify_ExceedLogesticWidth: "Ширина посылки превышает лимит логистики",
    Notify_ExceedLogesticLength: "Длина посылки превышает лимит логистики",
    Notify_ExceedLogesticTotalLength: "Общая длина посылки превышает лимит логистики",
    Notify_ExceedLogesticWeight: "Вес посылки превышает лимит логистики",
    Notify_UserAddressesIsEmptyOrNotSetDefaultAddress: "Адреса пользователя пусты или адрес по умолчанию не установлен",
    Notify_NotSupportedBoxByThisDimensions: "Коробка с такими размерами не поддерживается",
    Notify_CannotAvailableOutOfStackProduct: "Невозможно сделать продукт доступным вне склада",
    Notify_YouAreDeadInCivilRegistration: "Вы зарегистрированы как умерший в гражданской регистрации",
    Notify_InstagramerAlreadyAuthorized: "Instagramer уже авторизован",
    Notify_ThreadShouldBeActiveForSendMessage: "Для отправки сообщения ветка должна быть активной",
    Notify_PreviouslyClosedTicket: "Тикет был закрыт ранее",
    Notify_NotMatchedCart: "Корзина не совпадает",
    Notify_PhoneNumberNotBlongsNationalNumber: "Номер телефона не совпадает с национальным номером",
    Notify_NotMatchedCardNumberAndIdentity: "Номер карты и данные личности не совпадают",
    Notify_SuspendedShop: "Этот магазин приостановлен, обратитесь в поддержку",
    Notify_LogesticIdNotSpecifiedForaPostParcel: "Идентификатор логистики не указан для почтовой посылки",
    Notify_LogesticNotInAvailableLogestics: "Выбранная логистика отсутствует в списке доступных логистик",
    Notify_ExceedProductReportForLast24Hour: "Количество отчетов о продукте за последние 24 часа превышает лимит",
    Notify_PreviouslyReportedThisProduct: "Вы уже сообщали об этом продукте ранее",
    Notify_InvalidOrderId: "ID заказа недействителен",
    Notify_NotPendingPayRequest: "Запрос на оплату не в ожидании",
    Notify_NotExistShopAddress: "Адрес магазина не найден",
    Notify_InvalidOrderStatus: "Статус заказа недействителен",
    Notify_CancelInvoiceFailed: "Не удалось отменить счет",
    Notify_PaymentSystemNotSupportedThisPriceType: "Платежная система не поддерживает этот тип цены",
    Notify_InvalidSentOrderType: "Тип отправленного заказа недействителен",
    Notify_InvalidParcelId: "ID посылки недействителен",
    Notify_AddedParcelIdBefore: "ID посылки уже добавлен",
    Notify_InvoiceNotOnPaid: "Счет еще не оплачен",
    Notify_CreatedSystemTicketOnOrderBefore: "Системный тикет для этого заказа уже создан",
    Notify_PaymentServiceNotResponding: "Сервис оплаты в данный момент не отвечает",
    Notify_YouAreNotAdmin: "Вы не администратор",
    Notify_YouAreNotASubAdmin: "Вы не суб-администратор",
    Notify_InvalidFbId: "Недействительный Facebook ID",
    Notify_InvalidFeatureId: "Недействительный ID функции",
    Notify_InActiveFeature: "Эта функция неактивна",
    Notify_FeaturePaused: "Эта функция приостановлена",
    Notify_InvalidPromptInput: "Недопустимый ввод промпта",
    Notify_PromptNotGenerated: "Промпт не сгенерирован",
    Notify_AIGeneratorFailed: "Генератор ИИ столкнулся с ошибкой",
    Notify_NotExecutedPromptForCommentYet: "Промпт для коммента еще не выполнен",

    Notify_InstagramPermissionNotExist: "Разрешение Instagram не существует",
    Notify_InvalidTimeZone: "Недопустимый часовой пояс",
    Notify_PromptCaptionExampleNotGenerated: "Пример заголовка промпта не был сгенерирован",
    Notify_InvalidMasterFlowId: "Недопустимый ID главного потока",
    Notify_InvalidFlowId: "Недопустимый ID потока",
    Notify_EmptySubFlows: "Подпотоки пусты",
    Notify_InvalidFlowObject: "Недопустимый объект потока",
    Notify_InvalidMasterFlowTitle: "Недопустимое название главного потока",
    Notify_InvalidPromptId: "Недопустимый ID промпта",
    Notify_ExceedThreadTokenLimit: "Превышен лимит токенов для этого разговора",
    Notify_InvalidMediaId: "Недопустимый ID медиа",
    Notify_InvalidLotteryId: "Недопустимый ID лотереи",
    Notify_CannotAbortNonUpcomingLottery: "Невозможно отменить неближайшие лотереи в данный момент",
    Notify_CommentCountExceedFreeExport: "Количество комментариев превышает допустимый лимит для бесплатной лотереи",
    Notify_InvalidReserveFeatureId: "Недопустимый ID резервной функции",
    Notify_CannotRenewalThisFeatureNow: "Невозможно обновить эту функцию в данный момент",
    Notify_InvalidLotteryStatus: "Статус лотереи недопустим для изменения",
    Notify_PublishedLotteryBannerBefore: "Баннер лотереи был опубликован ранее",
    Notify_LotteryWinnerBannerIsNull: "Баннер победителя лотереи не существует",
    Notify_InvalidCustomPromptSigniture: "Недопустимая подпись пользовательского промпта",
    Notify_ServiceTemporarilyUnavailable: "Сервис временно недоступен",
    Notify_PageSummaryNotGenerated:
      "Brancy нуждается в большем количестве данных для анализа вашей страницы.\nПожалуйста, будьте терпеливы.",
    Notify_GenerateAIFail: "Генерация ИИ не удалась",
    Notify_InvalidPageAnalysis: "Недействительный анализ страницы",
    Notify_InvalidCustomPrompt: "Недействительный пользовательский запрос",
    Notify_AIModelNotSupportImage: "Модель ИИ не поддерживает изображения",
    Notify_PromptNotSupportImage: "Запрос не поддерживает изображения",
    Notify_AIModelNotSupportAudio: "Модель ИИ не поддерживает аудио",
    Notify_PromptNotSupportVoice: "Запрос не поддерживает голос",
    Notify_AIModelNotSupportVideo: "Модель ИИ не поддерживает видео",
    Notify_InvalidPrompt: "Недействительный запрос",
    Notify_InvalidImageGeneratorInput: "Недействительные входные данные генератора изображений",
    Notify_InSuffcientNumberOfImage: "Недостаточное количество изображений",
    Notify_CreateImageExceedLimit: "Создание изображений превысило лимит",
    Notify_InvalidPromptType: "Недействительный тип запроса",
    Notify_UnSupportedAIInputType: "Неподдерживаемый тип входных данных ИИ",
    Notify_UnSupportedOrientationType: "Неподдерживаемый тип ориентации",
    Notify_SoraFailedAiCall: "Вызов Sora AI не удался",
    Notify_AIVideoSecondNotSupported: "Продолжительность видео ИИ не поддерживается",
    Notify_FailedToTraslateDescription: "Не удалось перевести описание",
    Notify_FailedToGenerateEmbedVector: "Не удалось создать вектор встраивания",
    Notify_NotGeneratedSummaryYet: "Резюме ещё не создано",
    Notify_NoEventsFoundForTheGivenTimeRange: "События не найдены для указанного диапазона времени",
    Notify_NoEventsFoundForThisPrompt: "События не найдены для этого запроса",
    Notify_PageAnalysisNotExist: "Анализ страницы не существует",
    Notify_NoEventIdeaGenerated: "Идея события не была сгенерирована",
    Notify_PhoneNumberAddedBefore: "Этот номер телефона уже добавлен",
    Notify_WhatsAppCodeSendedBeforeAndWait1Day: "Код WhatsApp уже был отправлен. Подождите один день",
    Notify_WhatsAppCodeNotRequested: "Код подтверждения WhatsApp не был запрошен",
    Notify_WhatsAppCodeMaxInvalidCountReach: "Достигнуто максимальное число неверных попыток ввода кода WhatsApp",
    Notify_UserWithThisPhoneNumberAlreadyExist: "Пользователь с таким номером телефона уже существует",
    Notify_InvalidAIToolId: "Недопустимый идентификатор инструмента ИИ",
    Notify_AIToolParameterRequired: "Необходимо указать параметр инструмента ИИ",
    Notify_AIToolParameterNotRequired: "Этот инструмент ИИ не принимает параметры",
    Notify_ExceedDailyLimit: "Превышен дневной лимит",
    Notify_CannotGetTwitchRightNow: "Сейчас невозможно получить данные Twitch",
    Notify_InvalidTwitchChannelId: "Недопустимый идентификатор канала Twitch",
    Notify_PhoneNumberRequired: "Необходимо указать номер телефона",
    Notify_NotVerifiedHost: "Хост не подтвержден",
    Notify_NotBusinesser: "Этот пользователь не является владельцем бизнеса",
    Notify_NotFoundAnySuggestedCategory: "Рекомендуемые категории не найдены",
    Notify_NoInvoiceExist: "Счет не существует",
    Notify_InvalidMediaAiCreatorKey: "Недействительная модель ИИ",
    Notify_InvalidMediaAiVersionKey: "Недействительная версия ИИ",
    Notify_InvalidMediaAiRequestModel: "Недействительная модель запроса ИИ-медиа",
    Notify_MediaAIError: "Произошла ошибка при создании ИИ-медиа",
    Notify_TwitchChannelDoestHaveAnyVideo: "На этом канале Twitch нет видео",
    Notify_CouponAlreadyDeleted: "Этот купон уже удалён",
    Notify_CouponNotDeleted: "Этот купон не удалён",
    Notify_ExceedSubFlowCount: "Превышено максимальное количество подпотоков",
    Notify_ExceedFlowDepth: "Превышена максимальная глубина потока",
    Notify_ExceedFlowItemCount: "Превышено максимальное количество элементов потока",
    Notify_ExceedFlowMediaAudioCount: "Превышено максимальное количество медиа и аудио в потоке",
    Notify_OneFlowButtonHasEmptyItem: "У одной из кнопок нет потока",
    InternalNotify_Ok: "Операция успешно завершена",
    InternalNotify_RepetitiveHashtagInput: "Введенный хэштег повторяется",
    InternalNotify_NotFoundDevice: "Устройство не найдено",
    InternalNotify_EmptyHashtagList: "Невозможно создать пустой список",
    InternalNotify_CannotCreatePrePostNow: "Сейчас невозможно создать предварительный пост",
    InternalNotify_PrivateAccountSelectedForCheckHashtag: "Невозможно выбрать приватный аккаунт для анализа",
    InternalNotify_InstagramLoginRequired: "Эта опция требует входа в Instagram",
    InternalNotify_InstagramLoginRequiredForVerifiedAccount:
      "Эта опция требует входа в Instagram для подтвержденных аккаунтов",
    InternalNotify_PrivateOrVerifiedSponsor:
      "Невозможно выбрать приватный или подтвержденный аккаунт в качестве спонсора",
    InternalNotify_StartUploadingPost: "Пост загружается",
    InternalNotify_UploadingPostError: "Произошла ошибка при загрузке поста",
    InternalNotify_PostUploaded: "Пост загружен, обновите страницу для просмотра",
    InternalNotify_ExceededMedia: "Количество медиа превышает лимит",
    InternalNotify_More4IceBreaker: "Вы не можете иметь более 4 быстрых разговоров",
    InternalNotify_CopyLink: "Ваша ссылка скопирована",
    InternalNotify_copy: "Информация успешно скопирована",
    InternalNotify_CopyTrackingpost: "Код отслеживания вашего пакета скопирован",
    InternalNotify_Network: "Ошибка подключения к сети",
    InternalNotify_TimeExpire: "Регистрация невозможна, время истекло",
    InternalNotify_ExceedPermittedHashtagNumber: "Количество хэштегов превышает допустимый лимит",
    InternalNotify_UnexpectedError: "Произошла непредвиденная ошибка",
    InternalNotify_CopyToClipboard: "Ваша информация уже скопирована в буфер обмена",
    InternalNotify_ExceedPermittedUploadMedia: "Количество медиа превышает допустимый лимит",
    InternalNotify_FillRedBorderFields: "Пожалуйста, заполните поля с красной рамкой",
    InternalNotify_RepeatedVariation: "Как минимум два элемента повторяются",
    InternalNotify_NeedOneProduct: "Требуется как минимум один продукт",
    InternalNotify_UploadMedia: "Проблема с загрузкой медиа",
    InternalNotify_TurnOnProxy: "Вы должны использовать действительный IP",
    InternalNotify_ExceedPermittedLiveTime: "Время прямого эфира превысило допустимый лимит",
    InternalNotify_CommentDisabled: "Вы не можете выполнять действия, когда комментарии отключены",
    InternalNotify_ExceedSelectedCollaboratorPage:
      "Количество выбранных страниц сотрудников превышает допустимый лимит",
    InternalNotify_RepetitiveCollaboratorPage: "Это имя пользователя уже выбрано",
    InternalNotify_ExceedPermittedSizeOfImage: "Размер изображения превышает допустимый лимит",
    InternalNotify_ExceedPermittedAspectRatioAlbum: "Соотношение сторон видео альбома превышает допустимый лимит",
    InternalNotify_ExceedPermittedSizeOfVideoAlbum: "Размер видео альбома превышает допустимый лимит",
    InternalNotify_ExceedPermittedDurationOfVideoAlbum: "Длительность видео альбома превышает допустимый лимит",
    InternalNotify_ExceedPermittedAspectRatioReels: "Соотношение сторон Reels превышает допустимый лимит",
    InternalNotify_ExceedPermittedSizeOfVideoReels: "Размер Reels превышает допустимый лимит",
    InternalNotify_ExceedPermittedDurationOfVideoReels: "Длительность Reels превышает допустимый лимит",
    InternalNotify_NotPermittedMediaType: "Тип медиа не разрешен",
    InternalNotify_InvalidMetaData: "Метаданные недействительны",
    InternalNotify_ExceedSelectedMaxTaggedPeople: "Количество отмеченных людей превышает допустимый лимит",
    InternalNotify_ExceedSelectedMaxHashtags: "Количество выбранных хэштегов превышает допустимый лимит",
    InternalNotify_ExistedInCollaborate:
      "Это имя пользователя уже существует среди сотрудников и не может быть на первом слайде",
    InternalNotify_ExceedPermittedAspectRatioStory: "Соотношение сторон истории превышает допустимый лимит",
    InternalNotify_ExceedPermittedSizeOfVideoStory: "Размер видео истории превышает допустимый лимит",
    InternalNotify_ExceedPermittedWidthOfVideo: "Ширина видео превышает допустимый лимит",
    InternalNotify_ExceedPermittedDurationOfVideoStory: "Продолжительность видео истории превышает допустимый лимит",
    InternalNotify_BelowMinimumDurationOfVideoStory: "Продолжительность видео истории должна быть не менее 3 секунд",
    InternalNotify_ExceedPermittedSpecificWordForAutoreply:
      "Количество специальных слов для автоответа превышает допустимый лимит",
    InternalNotify_ExceedPermittedAspectRatioImage: "Соотношение сторон изображения превышает допустимый лимит",
    InternalNotify_Success: "Операция выполнена успешно",
    InternalNotify_CreateExportAvailableWith24HourPeriod: "Создание экспорта с периодом 24 часа доступно",
    InternalNotify_SaveIceBreaker: "Успешно добавлено",
    InternalNotify_deleteIceBreaker: "Успешно удалено",
    InternalNotify_SavePersistenceMenu: "Меню сохранения добавлено успешно",
    InternalNotify_SelectLanguage: "Язык успешно изменен",
    InternalNotify_SaveFollowTemplate: "Шаблон follow успешно сохранен",
    InternalNotify_AutoReplyOn: "Автоответ включен успешно",
    InternalNotify_AutoReplyOff: "Автоответ отключен успешно",
    InternalNotify_AutoGeneralOn: "Общий автоответ включен успешно",
    InternalNotify_AutoGeneralOff: "Общий автоответ отключен успешно",
    InternalNotify_MaxInEachCard: "Максимум в каждой карточке",
    InternalNotify_ExceedStockCard: "Запрошенное количество превышает остаток на карте",
    InternalNotify_DefaultAddress: "Невозможно удалить адрес по умолчанию",
    InternalNotify_FetchingYourData: "Получение ваших данных, пожалуйста, подождите...",
    InternalNotify_EmptyTitleInQuickReply: "Заголовок быстрого ответа пуст",
    InternalNotify_EmptyTitleForOutputsInQuickReply: "Заголовки выходных данных в быстром ответе пусты",
    InternalNotify_EmptyTitleForFlow: "Заголовок потока пуст",
    InternalNotify_MultipleFlowForPrivateReply: "Нельзя иметь несколько потоков для приватного ответа",
    InternalNotify_NotPermittedForDownload: "Вам не разрешено загружать этот контент",
    InternalNotify_NotFeature: "Эта функция недоступна",
    InternalNotify_ExceedBasefeatureTime: "Время превышает допустимый лимит",
    InternalNotify_ChannelIdNotStartedWithUC: "ID канала должен начинаться с 'UC'",
    InternalNotify_PageAnalysisNotCompleted: "К сожалению, ваша страница еще не была проанализирована ИИ",
    JustCreated: "Тикет зарегистрирован",
    AdminReplied: "Поддержка ответила",
    UserReplied: "Пользователь ответил",
    AdminClosed: "Тикет был закрыт поддержкой",
    UserClosed: "Тикет был закрыт пользователем",
    TimerClosed: "Тикет был закрыт автоматически",
    closethisticket: "Закрыть этот тикет",

    Create: "Создать",
    image: "изображение",
    video: "видео",
    Images: "Изображения",
    Videos: "Видео",
    "Generated artwork and visuals": "Созданные изображения и иллюстрации",
    "AI motion and clips": "Движение и клипы ИИ",
    "Media type": "Тип медиа",

    "Generated AI video preview": "Предпросмотр видео, созданного ИИ",

    Close: "Закрыть",
    Prompt: "Запрос",
    Metadata: "Метаданные",
    Creator: "Создатель",
    Version: "Версия",
    Status: "Статус",
    "Image ID": "ID изображения",
    "Video ID": "ID видео",
    "Job ID": "ID задания",
    "Download image": "Скачать изображение",
    "Download video": "Скачать видео",
    "Your browser does not support video playback.": "Ваш браузер не поддерживает воспроизведение видео.",

    Uploading: "Загрузка",
    "Add video": "Добавить видео",
    "Add audio": "Добавить аудио",
    "Add reference image": "Добавить референсное изображение",
    model: "модель",
    models: "модели",
    "resize aspect ratio": "изменить соотношение сторон",
    "Video models": "Модели видео",
    "Image models": "Модели изображений",
    "Cost level {level}": "Уровень стоимости {level}",
    "Calculating...": "Вычисление...",
    "Search from People or Keyword": "Поиск людей или ключевого слова",
    "Create new Flow": "Создать новый поток",
    "Welcome illustration": "Приветственная иллюстрация",
    "Untitled generation": "Создание без названия",
    "No images yet": "Изображений пока нет",
    "No videos yet": "Видео пока нет",
    "Your successful image generations will appear here.": "Успешно созданные изображения появятся здесь.",
    "Your successful video generations will appear here.": "Успешно созданные видео появятся здесь.",
    "Create your first image": "Создайте первое изображение",
    "Create your first video": "Создайте первое видео",
    "Generating image": "Создание изображения",
    "Generating video": "Создание видео",
    "In progress": "Выполняется",
    "Just now": "Только что",
    "Waiting for the result": "Ожидание результата",

    "Try again": "Попробовать снова",

    "AI provider": "Поставщик ИИ",

    "Choose a model": "Выберите модель",

    "Describe the subject, setting, light, composition, and style...":
      "Опишите объект, окружение, освещение, композицию и стиль...",
    "Use at least {count} characters.": "Используйте не менее {count} символов.",
    "Video creator is unavailable": "Создатель видео недоступен",
    "Image creator is unavailable": "Создатель изображений недоступен",
    "No video models found": "Модели видео не найдены",
    "No image models found": "Модели изображений не найдены",
    "There are no video generation models available for this account.":
      "Для этого аккаунта нет доступных моделей генерации видео.",
    "There are no image generation models available for this account.":
      "Для этого аккаунта нет доступных моделей генерации изображений.",
    "Not available": "Недоступно",
    // #endregion Notification Section
    how: "Как",
    SharedRemainingTimeBefore: "Перед повторной публикацией необходимо подождать 24 часа.",
    ConnectProduct: "Прямое подключение к товару",
    messagesetting_ConnectProductResponseExplain: "Подключите свой продукт к Story или Live.",
    biolinkProperties_Connect: "Подключить",
    economy: "Экономичный",
    pageStatistics_RePosts: "Репосты",
    Retry: "Повторить",
    messagesetting_SpecifyProductResponseExplain: "Выберите товар, чтобы он автоматически отправлялся пользователям",
    messagesetting_ProductResponseExplain: "Подключите текущий товар к пользователю",
    // #region wallet
    createdtime: "Время создания",
    BankCards: "Банковские карты",
    Transactions: "Транзакции",
    Settlements: "Расчёты",
    AddNewBankCard: "Добавить новую банковскую карту",
    RegisterANewCard: "Зарегистрировать новую карту",
    CardBankNumber: "Номер банковской карты",
    CardNumberExplain:
      "Введите номер карты. Банковская карта должна быть зарегистрирована на имя пользователя, который создал аккаунт.",
    RegisterBankCard: "Зарегистрировать банковскую карту",
    CardNumber: "Номер карты",
    DefaultBankCard: "Банковская карта по умолчанию",
    SetAsDefaultBankCard: "Установить как банковскую карту по умолчанию",
    Type: "Тип",
    Suspended: "Приостановлено",
    Amount: "Сумма",
    Time: "Время",
    Order: "Заказ",
    User: "Пользователь",
    NotAvailable: "Недоступно",
    Unsettled: "Не погашено",
    AwaitingSettled: "Ожидает расчёта",
    Settled: "Рассчитано",
    SettlementFailed: "Ошибка расчёта",
    SettleRequest: "Запрос на расчёт",
    emptyInvoice: "Счета ещё не зарегистрированы.",
    InvoiceID: "ID счёта",
    InvoiceType: "Тип счёта",
    InvoiceHistory: "История счетов",
    OrderDetails: "Детали заказа",
    InvoiceDetails: "Детали счёта",
    Paid: "Оплачено",
    Success: "Успешно",
    RefundRequest: "Запрос на возврат",
    Refunding: "Возврат выполняется",
    Refunded: "Возвращено",
    RefundFailed: "Ошибка возврата",
    Failed: "Неудачно",
    Package: "Пакет",
    Product: "Товар",
    Feature: "Функция",
    Custom: "Пользовательский",
    Invoice: "Счёт",
    UnknownStatus: "Неизвестный статус",
    NoSettlementsRegisteredYet: "Пока не зарегистрировано ни одного расчёта.",
    LogesticPayment: "Логистический платёж",
    ProductIncome: "Доход от товара",
    BrancyFeatureIncome: "Доход от функций Brancy",
    BrancyLogesticPayment: "Логистический платёж Brancy",
    BrancyPackageIncome: "Доход от пакетов Brancy",
    BrancyProductIncome: "Доход от товаров Brancy",
    BrancyTransferPayment: "Комиссия за перевод Brancy",
    WalletBalance: "Баланс кошелька",
    TotalWithdrawn: "Всего выведено",
    FailedTransactions: "Неудачные транзакции",
    PendingSettlement: "Ожидает расчёта",
    OrderInProgress: "Заказ обрабатывается",
    OrderPickup: "Забор заказа",
    OrderDelivery: "Доставка заказа",
    SubInvoiceHistory: "История под-счетов",
    history: "История",
    // #endregion wallet
  },
};
